import * as THREE from 'three'
//import * as THREE from 'https://unpkg.com/three@0.109.0/build/three.module.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

// rhino loader:
import { Rhino3dmLoader } from 'three/examples/jsm/loaders/3DMLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';


import { createGLTFLayer, mat } from './modules/customModels.js';

import html2canvas from 'html2canvas';
// https://html2canvas.hertzen.com/ - 

const rhinoLoader = new Rhino3dmLoader();
rhinoLoader.setLibraryPath('https://cdn.jsdelivr.net/npm/rhino3dm@8.4.0/');

import posthog from 'posthog-js';
import axios from 'axios';
import FormData from 'form-data';
import * as mysql from 'mysql';
import * as fs from "fs";

// disable gallery loading since it's not used in havenpark
import "./resultsGallery/script.js";
import openAdminPanel from './adminPanel/script.js';

import { Application as SplineApplication } from '@splinetool/runtime';


// === Importing Shaders: ==== 

import treesVertexShader from "./shaders/trees/vertex.glsl";
import treesFragmentShader from "./shaders/trees/fragment.glsl";
import outlineVertexShader from "./shaders/outline/vertex.glsl";
import outlineFragmentShader from "./shaders/outline/fragment.glsl";

// === Initializing Posthog ===

try {
    posthog.init('phc_g2h9OmTk9dQYB8NCVdYWwLAEXfiauaO0d1QOjQuNIm1', {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only', // optional: controls profile creation behavior
        autocapture: true, // optional: captures clicks, pageviews, etc.
        capture_pageview: true, // optional: capture a pageview on load
    });
} catch {
    console.log("unable to initialize posthog")
}


// INITIALIZING THE ABOUT THE PROJECT FUNCTIONS:
(function initHfCarousel() {
    const track = document.getElementById('hfCarouselTrack');
    const dotsWrap = document.getElementById('hfCarouselDots');
    if (!track || !dotsWrap) return;

    const slides = Array.from(track.querySelectorAll('.hf-c-slide'));
    // build dots
    dotsWrap.innerHTML = '';
    slides.forEach((_, i) => {
        const dot = document.createElement('div');
        dot.className = 'hf-c-dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', () => {
            track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
    });

    const dots = Array.from(dotsWrap.children);
    const setActiveByScroll = () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = 0, bestDist = Infinity;
        slides.forEach((s, i) => {
            const mid = s.offsetLeft + s.clientWidth / 2;
            const d = Math.abs(mid - center);
            if (d < bestDist) { best = i; bestDist = d; }
        });
        dots.forEach((d, i) => d.classList.toggle('active', i === best));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(setActiveByScroll));
    setActiveByScroll();

    // arrows
    document.querySelectorAll('#hfCarousel .hf-c-arrow').forEach(btn => {
        btn.addEventListener('click', () => {
            const dir = Number(btn.dataset.dir || 1);
            const cur = track.scrollLeft;
            const w = track.clientWidth * 0.9; // slide approx a screen
            track.scrollTo({ left: cur + dir * w, behavior: 'smooth' });
        });
    });
})();




document.addEventListener('DOMContentLoaded', function () {
    //Checking user log in:
    if (window.self !== window.top) {

    } else {
        // Running as a top-level page
        checkLoginStatus();
    }

});

window.addEventListener("resize", () => {
    const isMobile = window.innerWidth <= 768; // Define your mobile breakpoint
    if (isMobile) {

        if (window.innerWidth > window.innerHeight) {
            console.log("Landscape");

            let url = window.location.href;

            // Create a URL object
            let urlObj = new URL(url);

            // Use URLSearchParams to extract the value
            let params = new URLSearchParams(urlObj.search);

            // Retrieve the value of the parameter
            let activeProjectValue = params.get('activeProject');
            console.log(activeProjectValue)

            if (activeProjectValue !== null) {
                if (activeProjectValue == "Plac Krakowski") {
                    console.log("change visibility")
                    document.getElementById("OnlyMobileAction").classList.add("OnlyMobileActionVisible")
                    while (document.getElementById("OnlyMobileAction").classList.contains("OnlyMobileActionHidden")) {
                        document.getElementById("OnlyMobileAction").classList.remove("OnlyMobileActionHidden");
                    }
                }
            }

        } else {
            console.log("Portrait");
            let url = window.location.href;

            // Create a URL object
            let urlObj = new URL(url);

            // Use URLSearchParams to extract the value
            let params = new URLSearchParams(urlObj.search);

            // Retrieve the value of the parameter
            let activeProjectValue = params.get('activeProject');
            console.log(activeProjectValue)

            if (activeProjectValue !== null) {

                console.log("Device is in portrait mode");
                document.getElementById("OnlyMobileAction").classList.add("OnlyMobileActionHidden")
                while (document.getElementById("OnlyMobileAction").classList.contains("OnlyMobileActionVisible")) {
                    document.getElementById("OnlyMobileAction").classList.remove("OnlyMobileActionVisible");
                }
            }
        }
    }

});

window.addEventListener('DOMContentLoaded', () => {


    // Restore Age
    const age = sessionStorage.getItem('userAge');
    if (age) document.getElementById('UFFormAge').value = age;
    console.log("set age:", age)
    if (age) sessionUserAge = age;

    // Restore Gender
    const gender = sessionStorage.getItem('userGender');
    if (gender) document.getElementById('UFFormGender').value = gender;
    console.log("set gender:", gender)
    if (gender) sessionUserGender = gender;

    // Restore Relation to Place
    const relation = sessionStorage.getItem('userRelation');
    if (relation) document.getElementById('UFFormRelation').value = relation;
    console.log("set relation:", relation)
    if (relation) sessionUserRelation = relation;


    // Restore Email
    const email = sessionStorage.getItem('userEmail');
    if (email) document.getElementById('UFFormEmail').value = email;
    if (email) sessionUserEmail = email;


    if (age && gender && relation && age != "" && gender != "" && relation != "") {
        document.getElementById("UrbanFutureIntroduceSave").style.backgroundColor = "#003d92";
        document.getElementById("UrbanFutureIntroduceSave").style.setProperty("color", "#FFFFFF", "important");
        document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
        document.getElementById("IntrouceIncompleteMessage").innerHTML = ""

    }




});




// GLOBAL VARIABLES:
// Setting the Project name:
let ReadyToStartViaLogin = false;

let projectName = "PlacKrakowskiEtapII";
let projectCode = "PKII";
let databaseUsersName = projectName + "Users";
let databaseAnswersName = projectName + "Answers";

// at top-level (near your other constants)
const CLASSIFY_URL = 'https://publictwin.info/EngagementAppPrototypes/PlacKrakowskiPHP/Classify_And_Translate_PlacKrakowski.php';
// Adjust path to where you’ll deploy the PHP below:
const INSERT_URL = 'https://publictwin.info/EngagementAppPrototypes/PlacKrakowskiPHP/Answers_Insert_PlacKrakowski.php';


// Setting up session storage for user ID:

let code = Math.floor(10000000 + Math.random() * 90000000).toString();

let userID = projectCode + String(code);

// Set item (if its not set already):
if (!sessionStorage.getItem('userID')) {
    sessionStorage.setItem('userID', userID);
}

if (!sessionStorage.getItem("loginUserID")) {
    sessionStorage.setItem('loginUserID', "-");
}

// Get item
let sessionUserID = sessionStorage.getItem('userID');
const adminPanel = document.getElementById("admin-panel");

function getUserIPAndCheck() {
    fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php')
        .then(r => r.json())
        .then(({ ip }) => {
            const table = databaseUsersName;
            const uid = sessionStorage.getItem('userID') || '-';
            const url = `https://publictwin.info/EngagementAppPrototypes/MainPHP/User_CheckOrInsert.php` +
                `?ip=${encodeURIComponent(ip)}&uid=${encodeURIComponent(uid)}&table=${encodeURIComponent(table)}`;

            return fetch(url);
        })
        .then(r => r.json())
        .then(result => {
            console.log('Database result:', result);
        })
        .catch(err => console.error(err));
}

getUserIPAndCheck();


let userIP = ""; // global variable to store IP

function getUserIP() {
    fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php')
        .then(response => response.json())
        .then(data => {
            userIP = data.ip;
        });
}
getUserIP();



function loadUserDataByIP() {
    fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php')
        .then(res => res.json())
        .then(({ ip }) => {
            const uid = sessionStorage.getItem('userID') || '-';
            return fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/User_Load.php', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ip,
                    uid,
                    table: databaseUsersName,
                })
            });
        })
        .then(res => res.json())
        .then(userData => {
            if (userData.status === "success" && userData.user.user_end_session === "false") {
                const u = userData.user;
                // ... your existing restore logic ...
            } else if (userData.status === "not_found") {
                console.log("No user record for this (ip, uid) yet.");
            } else if (userData.status === "error") {
                console.error("Load error:", userData.message);
            }
        })
        .catch(err => console.error("Failed to load user data:", err));
}

loadUserDataByIP();


function setUserSessionActive() {
    const table = databaseUsersName;
    const uid = sessionStorage.getItem('userID') || '-';

    // use cached IP if you already have it; otherwise fetch
    const ensureIp = () =>
        userIP && userIP !== '' ? Promise.resolve({ ip: userIP })
            : fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php').then(r => r.json());

    ensureIp()
        .then(({ ip }) =>
            fetch("https://publictwin.info/EngagementAppPrototypes/MainPHP/User_SetSessionActive.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ip, uid, table })
            })
        )
        .then(res => res.json())
        .then(data => {
            console.log("Session reset result:", data);
        })
        .catch(err => console.error("Session reset failed:", err));
}








// ---- Config ----
const projectCenter = [18.6732, 50.2916];
const pojectCameraStart = [18.6732, 50.2916]
const PROJECT_RADIUS_KM = 5;

let projectAreaCoordinates = [
    [4.413439324817972, 51.90689525824487],
    [4.417184358263626, 51.903542096157736],
    [4.417135285853192, 51.90346752368117],
    [4.417304988631145, 51.90342279646927],
    [4.417341894658875, 51.9034898918639],
    [4.417656997656991, 51.90340789010966],
    [4.421671654479894, 51.903871912053404],
    [4.422196652632522, 51.90471811566752],
    [4.423595494503871, 51.905249158583615],
    [4.42369320711515, 51.90518164746942],
    [4.42535059926675, 51.90584294765438],
    [4.42532626584736, 51.905903197743555],
    [4.426022983987423, 51.906174595990336],
    [4.4261448435663056, 51.906091621343506],
    [4.42725955332952, 51.90654471811277],
    [4.427138165878517, 51.90668089000977],
    [4.429107201072696, 51.907480012761795],
    [4.429180244986412, 51.90741961805455],
    [4.4298908638909325, 51.907691568461985],
    [4.430025058913316, 51.90764621226688],
    [4.430282828395548, 51.907767189818685],
    [4.430467365223848, 51.907888256056395],
    [4.430688479873822, 51.90797911399318],
    [4.431093213757322, 51.908054867119745],
    [4.43134783237511, 51.90783527865844],
    [4.430500760077962, 51.907510218407054],
    [4.4305490458494035, 51.90744226347903],
    [4.425402084515895, 51.90536728459236],
    [4.425289101273904, 51.90455738150956],
    [4.425311690129121, 51.904511995699124],
    [4.425238179887174, 51.90444510715486],
    [4.425835135411035, 51.90421957080352],
    [4.432284351616829, 51.9068211779113],
    [4.43323842329724, 51.90594721959047],
    [4.429416298563012, 51.904394289299006],
    [4.429528171290855, 51.90417116119585],
    [4.4313909066098915, 51.904112579403034],
    [4.438441736684979, 51.9069589149735],
    [4.43964477738939, 51.906177632960265],
    [4.434507771069832, 51.904103389204124],
    [4.434634514952336, 51.90388991449589],
    [4.436146391034811, 51.90375094071791],
    [4.437310711913682, 51.90423338462034],
    [4.437346627243443, 51.90421903323312],
    [4.437421511324203, 51.9042203119497],
    [4.43750254388425, 51.90424333883806],
    [4.438153869772151, 51.904519853250974],
    [4.439935762726577, 51.905214345510984],
    [4.440129022801244, 51.905193868061446],
    [4.440196388383953, 51.9053824368047],
    [4.441154250911438, 51.90578549287659],
    [4.439340936159255, 51.906965935278464],
    [4.436815286423013, 51.908619835477595],
    [4.434562798484961, 51.910104012714214],
    [4.434010035083702, 51.91047542271548],
    [4.433753186076132, 51.91074041933447],
    [4.433033186264765, 51.911995509181935],
    [4.432938554918934, 51.91214073127256],
    [4.432680725499893, 51.91236394416464],
    [4.4324124010070705, 51.91250191371532],
    [4.4321786713518065, 51.912572541574946],
    [4.431420367666874, 51.91261233261372],
    [4.431034050961955, 51.91262454961404],
    [4.4308011334113075, 51.91267649683485],
    [4.430647049966211, 51.912814199621465],
    [4.430538151279819, 51.913185946459805],
    [4.430074222996069, 51.913262600484984],
    [4.4292737474887645, 51.91330095919318],
    [4.428901760279672, 51.91331055217498],
    [4.428105921074916, 51.913289969209444],
    [4.426746266762137, 51.91326451345441],
    [4.425694122912205, 51.91334875417846],
    [4.424333769160086, 51.91343161419687],
    [4.424022575042812, 51.913436678545224],
    [4.423408182033455, 51.913477210083954],
    [4.4232319144145436, 51.913500022169245],
    [4.422019378793891, 51.91356881000638],
    [4.4202425891463974, 51.9136745786827],
    [4.418362432884464, 51.91378798438433],
    [4.4159848296934285, 51.91394302184327],
    [4.415158410381451, 51.9139998520136],
    [4.414879713249519, 51.914020137117774],
    [4.4137965757796, 51.91405057129711],
    [4.412640522145324, 51.914068332591256],
    [4.412545450121911, 51.91403626678067],
    [4.412482779276843, 51.913876062458144],
    [4.412364515455181, 51.913499084499335],
    [4.412275357966166, 51.91338780691552],
    [4.412106881088874, 51.91321605501486],
    [4.412004893396102, 51.913149757208316],
    [4.411356343790885, 51.912911700825816],
    [4.409184619364851, 51.912106048468104],
    [4.409095298004104, 51.91208157857844],
    [4.409067913557493, 51.912045125315984],
    [4.409069653011301, 51.911990228396206],
    [4.409269467257843, 51.91125869872823],
    [4.409483355452522, 51.91054217025061],
    [4.409501715859932, 51.91045580607974],
    [4.409563094706215, 51.910354138844326],
    [4.409993192126677, 51.90980272855887],
    [4.411428421916298, 51.91026153732582],
    [4.411460103549615, 51.91027138776707],
    [4.411497659353955, 51.910222669912855],
    [4.412249604778566, 51.90930918289874],
    [4.412666439754872, 51.908815108917],
    [4.413039006004595, 51.90837113385592],
    [4.413170408493016, 51.9080877050186],
    [4.41317407704139, 51.90776323838685],
    [4.413126142687787, 51.907575252240804],
    [4.413018166548085, 51.907280116853144],
    [4.412844490997969, 51.90705066251053],
    [4.4123251507729435, 51.90670034121865],
    [4.412396970824489, 51.90665252084764],
    [4.413439324817972, 51.90689525824487]

]

let projectRemove3DElements = [
    [18.672724333804894, 50.290525169945965],
    [18.672930143802745, 50.2904730947491],
    [18.673151050728734, 50.29053603222437],
    [18.67298378723794, 50.29078322253298],
    [18.674695706766073, 50.291586436568934],
    [18.674713508427686, 50.291774578039764],
    [18.674886342542322, 50.292059743068194],
    [18.674724282261792, 50.292320352213494],
    [18.67443358783092, 50.292553169258156],
    [18.674845703904055, 50.29285814343052],
    [18.674946221685786, 50.2930616046757],
    [18.67486732096387, 50.29311761685065],
    [18.674157930293603, 50.292885043204706],
    [18.673819291957415, 50.29301704727354],
    [18.67345924742824, 50.29331740327589],
    [18.673192736239315, 50.293151881559425],
    [18.673212332462327, 50.29286324695644],
    [18.672895439589496, 50.2926825197319],
    [18.67307351985562, 50.292368560068525],
    [18.672859079912996, 50.29244655132973],
    [18.67227599483141, 50.29218434350736],
    [18.672025708076006, 50.29232506772226],
    [18.671909448348714, 50.292287912376395],
    [18.672037897346485, 50.29214974368824],
    [18.67182493190407, 50.29200450861802],
    [18.671491697109815, 50.29157897922548],
    [18.67134636086044, 50.291473577953894],
    [18.67216126623734, 50.29075423802709],
    [18.67261322313081, 50.29068442135204],
    [18.672724333804894, 50.290525169945965]




]




// Custom models:
// --- custom 3D models (module) ---
let UFModels = { proposal: null, context: null, zones: null };

// pick the model origin for your project
const MODEL_ORIGIN = [18.6743, 50.2924];
const BASE = import.meta.env.BASE_URL || '/';
const MODEL_BASE = `${BASE}res/models/`;

// --- proposal variants registry ---
const PROPOSAL_OPTIONS = [
    { key: 'option_1', label: 'Konfiguracja 01', url: `${MODEL_BASE}PKrakowski_Proposal_Konfiguracja_01.glb`, configId: 1 },
    { key: 'option_2', label: 'Konfiguracja 02', url: `${MODEL_BASE}PKrakowski_Proposal_Konfiguracja_02.glb`, configId: 2 },
    { key: 'option_3', label: 'Konfiguracja 03', url: `${MODEL_BASE}PKrakowski_Proposal_Konfiguracja_03.glb`, configId: 3 },
    { key: 'option_4', label: 'Konfiguracja 04', url: `${MODEL_BASE}PKrakowski_Proposal_Konfiguracja_04.glb`, configId: 4 },
    { key: 'option_5', label: 'Konfiguracja 05', url: `${MODEL_BASE}PKrakowski_Proposal_Konfiguracja_05.glb`, configId: 5 },
];
// default
const DEFAULT_PROPOSAL_KEY = 'option_1';

// Layer id generator (unique per option)
const proposalLayerId = (key) => `UF-proposal-${key}`;

// Cache: map key -> { layer, opts }
UFModels._proposalLayers = new Map();
// Track current active key
let _currentProposalKey = null;


// --- helpers to toggle custom-layer visibility safely ---
function setCustomLayerVisibilityById(id, visible) {
    if (!map.getLayer(id)) return;
    map.setLayoutProperty(id, 'visibility', visible ? 'visible' : 'none');
}

function setProposalVisibility(key, visible) {
    const entry = UFModels._proposalLayers.get(key);
    const id = proposalLayerId(key);

    // if our custom layer exposes a toggle, use it (nice for skipping render)
    entry?.layer?.setEnabled?.(visible);

    // always set the Mapbox layout visibility too (works for custom layers)
    setCustomLayerVisibilityById(id, visible);
}

function update3DVisibilityForZoom(currentZoom) {
    const showDetail = currentZoom >= zoomLevelThreshold - 0.5;

    let ZOOM_ADJUSTMENT_MOBILE = 1.3;
    let ZOOM_ADJUSTMENT_DESKTOP = 1.0;
    let zoomLevelAdjustment = isMobileDevice() ? ZOOM_ADJUSTMENT_MOBILE : ZOOM_ADJUSTMENT_DESKTOP;

    let zoomLevelLabelsThreshold = zoomLevelThreshold + zoomLevelAdjustment;
    const showDetialLabels = (currentZoom >= zoomLevelThreshold && currentZoom < zoomLevelLabelsThreshold);

    // context model
    setCustomLayerVisibilityById('UF-context', showDetail);
    setCustomLayerVisibilityById('UF-zones', showDetail);

    ZoneLabels.setVisible(showDetialLabels);

    // proposals: only the active one is visible when zoomed in
    for (const [key] of UFModels._proposalLayers) {
        setProposalVisibility(key, showDetail && key === _currentProposalKey);
    }

    // UI: hide the proposal switcher when zoomed out
    const sw = document.getElementById('UF-ProposalSwitcher');
    if (sw) sw.style.display = showDetail ? 'inline-flex' : 'none';

    if (showDetail) ensureModelsOnTop();
}

// === ZONE DESCRIPTIONS (configId -> zoneKey -> text) =========================
const ZONE_TEXT = {
    1: {
        Klony: "Zamiast jednej z trybun część skweru rekreacyjnego, z placem zabaw dla dzieci. Nad pozostałą trybuną dach zacieniający. Dużo nowych drzew. Pod starymi klonami węższe niż obecnie przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew. Miejsce na targ (niebieskie namioty). Więcej wygodnych ławek. W miejscu starej toalety nowy pawilon gastronomiczny z toaletą publiczną, w nim miejsce spotkań Rady Dzielnicy. Zamiast starej fontanny podświetlane tryskacze w posadzce.",
        Akademicka: "Skatepark jako część ogólnodostępnego skweru. Przeszkody to rzeźbiarskie formy dekoracyjne (tu wstępne propozycje ich kształtu, do dyskusji), które kierują ruch w taki sposób, aby osoby jeżdżące na deskach, rolkach lub tp. nie zagrażały przechodniom. Duży słup ogłoszeniowy. Pergola zacieniająca nad przejściem - na istniejących stalowych ramach zamontowane linki dla pnączy. Zadaszenia zacieniające nad trybunami. Trybuna w sąsiedztwie skateparku przecięta, co umożliwia przejazd przez nią na otwartą część placu, na której część posadzki jest wykonana z nawierzchni wygodnej dla rolkarzy.",
        Górniczy: "Aleja Pamięci równoległa do budynku Wydziału Górniczego, czyli wyodrębniona z placu przestrzeń dla Pomnika Powstań Polskich. Od otwartej części placu pomnik jest oddzielony drzewami. Od strony ulic Łużyckiej i Akademickiej znajduje się na osi widokowej proponowanej alei. Wejścia do alei z narożników placu.",
        Łużycka: "Skwer z ławkami i pawilonem gastronomicznym (w nim miejsce spotkań Rady Dzielnicy) oraz z toaletą publiczną. Tarasy z miejscami do siedzenia i duży ogród deszczowy (oznaczenie - ciemna zieleń). Miejsce dla targu (granatowe namioty) również częściowo przewidziane  w tej strefie.",
        Centrum: "Otwarta część placu jest zmniejszona w stosunku do obecnej przez zieleniec w miejscu jednej z trybun. Dwa rodzaje posadzki - ułożone na nowo stare płyty (ciemniejsze) i nawierzchnia do jazdy na rolkach na części obok skateparku (jaśniejsze oznaczenie)."
    },
    2: {
        Klony: "Pod starymi klonami zamiast betonu węższe przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew. Więcej wygodnych ławek. Jak wynika z badań trybuny są chętnie wykorzystywane do siedzenia i rozmowy, często w kilkuosobowych grupach. W tej propozycji dwie trybuny zostają jako strefa spotkań, są wzbogacone o specjalnie zaprojektowane, częściowo ruchome meble do siedzenia. Nad nimi daszki zacieniające z ogniwami fotowoltaicznymi dające możliwość podłączenia urządzeń przenośnych do prądu.",
        Akademicka: "Badania wskazują, że pożądane byłoby stworzenie miejsca bezpośredniego kontaktu i współdziałania mieszkańców, studentów i pracowników Politechniki. W tym wariancie proponujemy w miejscu skateparku (który przynosimy na drugą stronę placu) urządzenie otwartej strefy popularyzacji nauki, kameralnych wydarzeń kulturalnych i organizowanych na różne sposoby wspólnych działań oddolnych. Nawierzchnia przepuszczalna, skwerowy charakter, infrastruktura umożliwiająca mocowanie różnych elementów, np. lekkich zadaszeń, dostęp do prądu itp. Stały pawilon może służyć m.in radzie dzielnicy. Trybuna usunięta, zostaje tylko jej niższa część (od strony obecnego skateparku).",
        Górniczy: "Miejskie Lapidarium - miejsce, gdzie przeplatają się różne wątki historii miasta i uczelni, Pgdzie zgromadzone są i wyeksponowane elementy nieistniejących już budowli oraz obiekty związane z historią miasta, budujące gliwicką tożsamość. Pomnik Powstań jest częścią Lapidarium. Za nim Bębny Czasu - instalacja edukacyjna. Na trawnikach atrakcja dla dzieci - figury koni (wspomnienie dawnego targu końskiego) i krowy prof. Fryzego. Kawiarnia Kloppot (nazwa istniejącego tu kiedyś stawu), która jest zarazem klubem historycznym, punktem informacji o historii miasta i miejscem spotkań mieszkańców.",
        Łużycka: "Nowy skatepark jest częścią ogólnodostępnego skweru. Przeszkody to  rzeźbiarskie formy dekoracyjne (tu wstępne propozycje ich kształtu do dyskusji), jednocześnie kierują ruch w taki sposób, aby osoby jeżdżące na deskach, rolkach lub tp. nie zagrażały przechodniom.",
        Centrum: "Część centralna nieco mniejsza niż obecnie, nawierzchnia z przełożonych płyt obecnego placu."
    },
    3: {
        Klony: "Pod starymi klonami zamiast betonu węższe przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew. Więcej wygodnych ławek. Zamiast trybun duży, chroniący przed deszczem i słońcem dach z pnączami. Pod nim dwa pawilony kawiarni i przestrzeń dająca możliwość zorganizowania targu i różnych wydarzeń, np. potańcówki. Na co dzień miejsce odpoczynku, rozmów, picia kawy, spotkań. Dach latem zacienia, zimą przepuszcza światło słoneczne.",
        Akademicka: "Badania wskazują, że pożądane byłoby stworzenie miejsca bezpośredniego kontaktu i współdziałania mieszkańców, studentów i pracowników Politechniki. W tym wariancie proponujemy w miejscu skateparku (który przenosimy na drugą stronę placu) urządzenie dużego zadaszenia z dostępem do prądu i wody, z ogniwami fotowoltaicznymi i z systemem zbierania deszczówki. Pod dachemi możliwość organizowania  wydarzeń popularyzujących naukę i współpracę naukowców z mieszkańcami, wydarzeń kulturalnych, wystaw, targów, ale i działań pomocowych w sytuacjach kryzysowych.",
        Górniczy: "Wzdłuż południowej krawędzi placu znajduje się “strefa historii i pamięci” ukształtowana przez dodanie elementów rzeźbiarskich w otoczeniu pomnika. Mogą to być postaci z historii Gliwic w skali naturalnej obok których, na kamiennych „kartach historii”, byłyby opisane lub wyświetlane opowieści o ich roli w rozwoju Gliwic. Przez „karty historii” można byłoby przechodzić, niczym przez kolejne bramy wtajemniczenia, dla lepszego poznania i zrozumienia dziejów miasta.",
        Łużycka: "W tej propozycji skatepark jest częścią ogólnodostępnego skweru. Przeszkody to  rzeźbiarskie formy dekoracyjne (tu wstępne propozycje ich kształtu do dyskusji), które kierują ruch w taki sposób, aby osoby jeżdżące na rolkach lub tp. nie zagrażały przechodniom.",
        Centrum: "Część centralna nieco mniejsza niż obecnie, nawierzchnia z przełożonych płyt obecnego placu."
    },
    4: {
        Klony: "Pod starymi klonami  zamiast betonu węższe przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew. Więcej wygodnych ławek. Trybuny rozbudowane o drewniane tarasy i pochylnię - miejsce spotkań i atrakcji typu pomost widokowy czy “kładka w koronach drzew” (przy maksymalnej ochronie klonów). Od strony otwartej placu dodane zadaszenia zacieniające trybuny. Pomosty stanowią zadaszenie targu dostępnego od strony alei klonów, mogłyby tu znaleźć się też niewielkie pawilony gastronomiczne.",
        Akademicka: "Budynek Centrum nauki dostępny przez podcienia od strony ul. Akademickiej a od strony placu w formie stopni tworzących wysoką trybunę, która może być wykorzystywana przy różnych okazjach. Po tych stopniach wchodzimy na dach budynku, który jest tarasem widokowym, z pawilonem kawiarni i przestrzenią ekspozycyjną.",
        Górniczy: "Przeniesienie pomnika w inne miejsce daje możliwość usytuowania kilku dwukondygnacyjnych pawilonów z tarasami tworzących pierzeję placu. W pawilonach mogłyby się mieścić bary z przekąskami, kawiarnie i inne, użyteczne społecznie funkcje – np. świetlica Rady Dzielnicy, społeczna kawiarnia, oddolna komitywa, klub studencki, karciany, klub gier planszowych, lub przestrzeń co-workingowa.",
        Łużycka: "Skatepark ukształtowany jako część skweru, z możliwością użytkowania części głównej płyty placu. Jest tu też pawilon gastronomiczny z zadaszonym tarasem.",
        Centrum: "Część centralna nieco mniejsza niż obecnie, nawierzchnia z przełożonych płyt obecnego placu."
    },
    5: {
        Klony: "Pod starymi klonami zamiast betonu węższe przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew. Miejsce na targ (niebieskie namioty), dużo wygodnych ławek. Toaleta publiczna wyremontowana. Trybuny pozostawione, zostają częściowo zazielenione, nad nimi zacieniająca pergola z pnączami.",
        Akademicka: "Nowy skatepark w miejscu starego. Lepsze przeszkody (tu propozycja do dyskusji), z wyspą zieleni z trawą, drzewami i pnączami (cień, schładzanie, oczyszczanie powietrza). Na jednej z przeszkód (tunel) od zewnątrz ścianka do wspinaczki (boulderingu). Nad trybuną daszki zacieniające, na trybunie stoliki umożliwiające rozłożenie np. gier planszowych. Trybuna jest przecięta i umożliwia przejazd na otwartą część placu, gdzie jaśniejszym kolorem zaznaczono nawierzchnię nadającą się do jazdy np. na rolkach.",
        Górniczy: "Strefa Pamięci i Wyciszenia – zieleniec otaczający pomnik stanowi wyraźnie wydzieloną, ale dostępną z otwartej części placu zieloną strefę wyciszenia. Wygodne ławki pozwalające na odpoczynek. Od strony placu ogrody deszczowe (zaznaczone ciemną zielenią)",
        Łużycka: "Rozbudowany skwer, ze ścieżkami i ławkami ułożonymi tak, aby ułatwić kilkuosobowe rozmowy. Na skwerze dwa pawilony - jeden kawiarniany, drugi mieszczący świetlicę, klub i Radę Dzielnicy. Przed nimi miejsca do siedzenia oraz ogród deszczowy wchodzący w część otwartą placu.",
        Centrum: "Otwarta część placu jest zmniejszona w stosunku do obecnej przez zielone strefy pomnika i skweru. Jaśniejsza część placu to posadzka do jeżdżenia na rolkach/desce itp. Pozostała część placu z przełożony obecnych płyt betonowych. Na płycie placu fontanna w postaci podświetlanych tryskaczy."
    }
};


// Short, 3-word max labels (per configuration)
const ZONE_LABELS = {
  1: {
    Klony:       'fontanna, pawilon, targ, dachy nad trybunami',
    Akademicka:  'skwer-skatepark, pergola',
    Górniczy:    'aleja z pomnikiem',
    Łużycka:     'skwer, pawilon, plac zabaw',
    Centrum:     'plac'
  },
  2: {
    Klony:       'klony, trybuny z siedziskami',
    Akademicka:  'oddolne aktywności',
    Górniczy:    'lapidarium, kawiarnia',
    Łużycka:     'skatepark - skwer',
    Centrum:     'plac'
  },
  3: {
    Klony:       'klony, długi dach, targ, kawiarnia',
    Akademicka:  'zadaszona przestrzeń aktywności',
    Górniczy:    'gliwickie opowieści',
    Łużycka:     'skatepark - skwer',
    Centrum:     'plac'
  },
  4: {
    Klony:       'klony, pomosty w koronach drzew, targ',
    Akademicka:  'budynek Centrum Nauki',
    Górniczy:    'kawiarnia, coworking, odpoczynek',
    Łużycka:     'skatepark otwarty, pawilon gastro',
    Centrum:     'plac'
  },
  5: {
    Klony:       'klony, targ, trybuny, pergole',
    Akademicka:  'sketepark zamknięty',
    Górniczy:    'skwer z pomnikiem',
    Łużycka:     'pawilony gastronomiczne +',
    Centrum:     'plac, fontanna'
  }
};



const ZONE_LABEL_PIXEL_NUDGE = {
  // id lowercased → [dx, dy] in pixels
  'zone_01': [0, 0],
  'zone_02': [0, 0],
  'zone_03': [0, 0],
  'zone_04': [0, 0],
  'zone_05': [0, 0],
};

function getPixelNudgeFor(z) {
  const id = String(z?.id || '').toLowerCase();
  return ZONE_LABEL_PIXEL_NUDGE[id] || [0, 0];
}

(function addLabel3ToZoneText() {
    if (typeof ZONE_TEXT !== 'object' || !ZONE_TEXT) return;
    for (const [cfgId, zonesMap] of Object.entries(ZONE_LABELS)) {
        ZONE_TEXT[cfgId] ??= {};
        for (const [zoneKey, label] of Object.entries(zonesMap)) {
            const cur = ZONE_TEXT[cfgId][zoneKey];
            if (typeof cur === 'string') {
                ZONE_TEXT[cfgId][zoneKey] = { text: cur, label3: label };
            } else if (cur && typeof cur === 'object') {
                cur.label3 = label;
            } else {
                ZONE_TEXT[cfgId][zoneKey] = { text: '', label3: label };
            }
        }
    }
})();




// materials for context rules
const M_WHITE = mat.std(0xffffff);
const M_OFFWHITE = mat.std(0xf5f5f5);
const M_LIGHTGRAY = mat.std(0xd9d9d9);

// 6-step grayscale gradient (lightest -> darkest)
// Use these as a smooth progression of neutral tones
const M_GRAY_01 = mat.std(0xf7f7f7); // very ligh       t
const M_GRAY_02 = mat.std(0xededed);
const M_GRAY_03 = mat.std(0xe0e0e0);
const M_GRAY_04 = mat.std(0xcfcfcf);
const M_GRAY_05 = mat.std(0xbfbfbf);
const M_GRAY_06 = mat.std(0x9e9e9e); // darkest of the set

const M_LIGHBEIGE_CONTEXT = mat.std(0xfcfbf4);

// 4-step muted green gradient (lightest -> darkest)
const M_GREEN_01 = mat.std(0xe3f6d9); // very light mint
const M_GREEN_02 = mat.std(0xbce4a3); // light
const M_GREEN_03 = mat.std(0x9fcf9f); // mid
const M_GREEN_04 = mat.std(0x6fa86f); // dark olive

// beige
const M_BEIGE_01 = mat.std(0xf5f0e6);
const M_BEIGE_02 = mat.std(0xe6dccb);
const M_BEIGE_03 = mat.std(0xcac0b0);

// brown
const M_BROWN_01 = mat.std(0xb0a8a2);
const M_BROWN_02 = mat.std(0x7f7468);

// colors:
const M_YELLOW_01 = mat.std(0xb6ac80);
const M_YELLOW_02 = mat.std(0xccc580);
const M_ORANGE_01 = mat.std(0xac9066);
const M_BLUE_01 = mat.std(0x8096ac);
const M_PURPLE_01 = mat.std(0x9a80ac);
const M_RED_01 = mat.std(0xac8090);


const M_BASE_ZONE = mat.std(0xffd04c);
M_BASE_ZONE.transparent = true;
M_BASE_ZONE.opacity = 0.02;
M_BASE_ZONE.metalness = 0.05;
M_BASE_ZONE.roughness = 0.08;
M_BASE_ZONE.reflectivity = 0.6;
M_BASE_ZONE.envMapIntensity = 1.2;
M_BASE_ZONE.side = THREE.DoubleSide;
// M_BASE_ZONE.depthWrite = false;
M_BASE_ZONE.alphaTest = 0.0;

const M_SELECT_ZONE = mat.std(0xffd04c);
M_SELECT_ZONE.transparent = true;
M_SELECT_ZONE.opacity = 0.15;
M_SELECT_ZONE.metalness = 0.05;
M_SELECT_ZONE.roughness = 0.08;
M_SELECT_ZONE.reflectivity = 0.6;
M_SELECT_ZONE.envMapIntensity = 1.2;
M_SELECT_ZONE.side = THREE.DoubleSide;
// M_SELECT_ZONE.depthWrite = false;
M_SELECT_ZONE.alphaTest = 0.0;

const M_PEOPLE = mat.std(0xffd04c);

const M_TREE_CROWNS = mat.std(0x7bbc5d);
M_TREE_CROWNS.transparent = true;
M_TREE_CROWNS.opacity = 0.45;
M_TREE_CROWNS.metalness = 0.05;
M_TREE_CROWNS.roughness = 0.08;
M_TREE_CROWNS.reflectivity = 0.6;
M_TREE_CROWNS.envMapIntensity = 1.2;
M_TREE_CROWNS.side = THREE.DoubleSide;
// M_TREE_CROWNS.depthWrite = false;
M_TREE_CROWNS.alphaTest = 0.0;

const M_TREE_CROWNS_02 = mat.std(0x98cb80);
M_TREE_CROWNS_02.transparent = true;
M_TREE_CROWNS_02.opacity = 0.45;
M_TREE_CROWNS_02.metalness = 0.05;
M_TREE_CROWNS_02.roughness = 0.08;
M_TREE_CROWNS_02.reflectivity = 0.6;
M_TREE_CROWNS_02.envMapIntensity = 1.2;
M_TREE_CROWNS_02.side = THREE.DoubleSide;
// M_TREE_CROWNS_02.depthWrite = false;
M_TREE_CROWNS_02.alphaTest = 0.0;

const M_TREE_CROWNS_03 = mat.std(0xb1d1a2);
M_TREE_CROWNS_03.transparent = true;
M_TREE_CROWNS_03.opacity = 0.45;
M_TREE_CROWNS_03.metalness = 0.05;
M_TREE_CROWNS_03.roughness = 0.08;
M_TREE_CROWNS_03.reflectivity = 0.6;
M_TREE_CROWNS_03.envMapIntensity = 1.2;
M_TREE_CROWNS_03.side = THREE.DoubleSide;
// M_TREE_CROWNS_03.depthWrite = false;
M_TREE_CROWNS_03.alphaTest = 0.0;

const M_TREE_CROWNS_04 = mat.std(0xbce4a3);
M_TREE_CROWNS_04.transparent = true;
M_TREE_CROWNS_04.opacity = 0.45;
M_TREE_CROWNS_04.metalness = 0.05;
M_TREE_CROWNS_04.roughness = 0.08;
M_TREE_CROWNS_04.reflectivity = 0.6;
M_TREE_CROWNS_04.envMapIntensity = 1.2;
M_TREE_CROWNS_04.side = THREE.DoubleSide;
// M_TREE_CROWNS_04.depthWrite = false;
M_TREE_CROWNS_04.alphaTest = 0.0;

const M_IVY = mat.std(0xb1d1a2);
M_IVY.transparent = true;
M_IVY.opacity = 1;
M_IVY.metalness = 0.05;
M_IVY.roughness = 0.08;
M_IVY.reflectivity = 0.6;
M_IVY.envMapIntensity = 1.2;
M_IVY.side = THREE.DoubleSide;
// M_IVY.depthWrite = false;
M_IVY.alphaTest = 0.0;




const M_TREE_TRUNKS = mat.std(0xC3B9B0);
M_TREE_TRUNKS.transparent = true;
M_TREE_TRUNKS.opacity = 0.5;
M_TREE_TRUNKS.metalness = 0.05;
M_TREE_TRUNKS.roughness = 0.08;
M_TREE_TRUNKS.reflectivity = 0.6;
M_TREE_TRUNKS.envMapIntensity = 1.2;
M_TREE_TRUNKS.side = THREE.DoubleSide;
// M_TREE_TRUNKS.depthWrite = false;
M_TREE_TRUNKS.alphaTest = 0.0;

// proposal yellows for greenery types

const M_PROPOSAL_YELLOW_01 = mat.std(0xf2b366);
const M_PROPOSAL_YELLOW_02 = mat.std(0xf2ca6e);
const M_PROPOSAL_YELLOW_03 = mat.std(0xf2e394);


// glass:
const M_GLASS = mat.std(0x88cfff); // base tint (soft blue)
M_GLASS.transparent = true;
M_GLASS.opacity = 0.28;           // visible but clearly transparent
M_GLASS.metalness = 0.05;        // subtle metallic response
M_GLASS.roughness = 0.08;        // mostly smooth for crisp reflections
M_GLASS.reflectivity = 0.6;      // strengthen reflection on non-PBR fallbacks
M_GLASS.envMapIntensity = 1.2;   // make environment reflections visible
M_GLASS.side = THREE.DoubleSide; // render both sides for thin glass geometry
M_GLASS.depthWrite = false;      // avoid z-fighting / sorting issues with translucency
M_GLASS.alphaTest = 0.0;

// edges helper for zone/island
function addEdgeLines(mesh, color = 0x6d6d6d, opacity = 0.5) {
    if (!mesh.geometry || mesh.userData._edgesHelper) return;
    const edgeGeom = new THREE.EdgesGeometry(mesh.geometry);
    const edgeMat = new THREE.LineBasicMaterial({
        color: color,
        linewidth: 0.1,
        depthTest: true,
        depthWrite: false,
        transparent: true,
        opacity: opacity
    });
    const edges = new THREE.LineSegments(edgeGeom, edgeMat);
    edges.renderOrder = (mesh.renderOrder ?? 0) + 1;
    edges.frustumCulled = mesh.frustumCulled;
    mesh.add(edges);
    mesh.userData._edgesHelper = edges;
}
function addEdgeLinesContext(mesh, color = 0x6d6d6d, opacity = 0.5) {
    if (!mesh.geometry || mesh.userData._edgesHelper) return;
    const edgeGeom = new THREE.EdgesGeometry(mesh.geometry);
    const edgeMat = new THREE.LineBasicMaterial({
        color: color,
        linewidth: 0.1,
        depthTest: true,
        depthWrite: false,
        transparent: true,
        opacity: opacity
    });
    const edges = new THREE.LineSegments(edgeGeom, edgeMat);
    edges.renderOrder = (mesh.renderOrder ?? 0) + 1;
    edges.frustumCulled = mesh.frustumCulled;
    mesh.add(edges);
    mesh.userData._edgesHelper = edges;
}
let ZONE_EDGE_COLOR = 0xffd04c;
ZONE_EDGE_COLOR = 0xba9738;

const ZONE_EDGE_OPACITY_BASE = 0.2;     // non-selected default
const ZONE_EDGE_OPACITY_SELECTED = 1; // selected should be lighter


const HEART_FULL = 'https://publictwin.info/digital_maquette/content/Urban_Future/Icons/HearthIcon.svg';
const HEART_EMPTY = 'https://publictwin.info/digital_maquette/content/Urban_Future/Icons/HearthEmptyIcon.svg';


function addEdgeLinesZones(mesh, color = ZONE_EDGE_COLOR, opacity = ZONE_EDGE_OPACITY_BASE) {
    if (!mesh || !mesh.geometry) return;

    let helper = mesh.userData._edgesHelper;

    // (Re)create helper if missing or not a LineSegments
    if (!helper || !helper.isLineSegments) {
        if (helper && helper.parent === mesh) {
            mesh.remove(helper);
            helper.geometry?.dispose?.();
            helper.material?.dispose?.();
        }
        const edgeGeom = new THREE.EdgesGeometry(mesh.geometry);
        const edgeMat = new THREE.LineBasicMaterial({
            color: color,
            linewidth: 1,
            depthTest: false,      // draw on top of filled mesh (prevents z-fighting clipping)
            depthWrite: true,
            transparent: true,
            opacity: opacity
        });
        helper = new THREE.LineSegments(edgeGeom, edgeMat);
        helper.name = 'zoneEdges';
        helper.renderOrder = (mesh.renderOrder ?? 0) + 1;
        helper.frustumCulled = false;
        mesh.add(helper);
        mesh.userData._edgesHelper = helper;
    } else {
        // Ensure style is updated even if helper already existed
        if (helper.material) {
            helper.material.opacity = opacity;
            helper.material.transparent = opacity < 1;
            if (helper.material.color && typeof helper.material.color.setHex === 'function') {
                helper.material.color.setHex(color);
            }
            helper.material.needsUpdate = true;
        }
        helper.visible = opacity > 0;
    }
}
// Silhouette outline (no inner edges)
function addSilhouetteOutline(mesh, {
    color = 0x6d6d6d,
    opacity = 0.5,
    thickness = 0.03,     // world units; increase if your model is tiny
    renderOrderBoost = 0.1
} = {}) {
    if (!mesh.geometry || mesh.userData._silhouette) return;

    // A backface-only clone, slightly "inflated"
    const mat = new THREE.MeshBasicMaterial({
        color,
        side: THREE.BackSide,   // <- only backfaces, gives a silhouette
        transparent: true,
        opacity,
        depthTest: true,
        depthWrite: false
    });

    const outline = new THREE.Mesh(mesh.geometry, mat);
    outline.name = (mesh.name || 'mesh') + '_silhouette';
    outline.castShadow = false;
    outline.receiveShadow = false;

    // Keep transforms in sync by parenting to the mesh
    outline.position.set(0, 0, 0);
    outline.quaternion.set(0, 0, 0, 1);
    outline.scale.copy(mesh.scale).multiplyScalar(1 + thickness);

    // Render after the main mesh so the depth buffer is filled first
    outline.renderOrder = (mesh.renderOrder ?? 0) + renderOrderBoost;

    mesh.add(outline);
    mesh.userData._silhouette = outline;
}

// styling for CONTEXT model, per your rules
function styleContextMesh(mesh) {
    // console.log(mesh);
    const srcName = (mesh.userData?.name || mesh.name || '');
    const s = srcName.toLowerCase();


    // zone_1 / zone_2 -> light gray + edges
    if (s.includes('zone_01') || s.includes('zone_02')) {
        mesh.material = M_LIGHBEIGE_CONTEXT;
        addEdgeLinesContext(mesh);
        return;
    }
    if (s.includes('existing')) {
        mesh.material = M_LIGHBEIGE_CONTEXT;
        addEdgeLines(mesh);
        return;
    }

    // island_A / island_B -> off white + edges
    if (s.includes('island_a') || s.includes('island_b')) {
        mesh.material = M_WHITE;
        addEdgeLines(mesh);
        return;
    }

    if (s.includes('crowns_01')) {
        mesh.material = M_TREE_CROWNS;
        return;
    }
    if (s.includes('crowns_02')) {
        mesh.material = M_TREE_CROWNS_02;
        return;
    }
    if (s.includes('crowns_03')) {
        mesh.material = M_TREE_CROWNS_03;
        return;
    }
    if (s.includes('crowns_04')) {
        mesh.material = M_TREE_CROWNS_04;
        return;
    }
    if (s.includes('trunk')) {
        mesh.material = M_TREE_TRUNKS;
        return;
    }

    // greenery types -> three different greens
    if (s.includes('greenery_type_01')) { mesh.material = M_GREEN_01; return; }
    if (s.includes('greenery_type_02')) { mesh.material = M_GREEN_02; return; }
    if (s.includes('greenery_type_03')) { mesh.material = M_GREEN_03; return; }

    // default -> white
    mesh.material = M_WHITE;
}

// styling for PROPOSAL model, per your rules:
function styleProposalMesh(mesh) {
    // console.log(mesh);
    const srcName = (mesh.userData?.name || mesh.name || '');
    const s = srcName.toLowerCase();

    if (s.includes('crowns_01')) {
        mesh.material = M_TREE_CROWNS;
        return;
    }
    if (s.includes('crowns_02')) {
        mesh.material = M_TREE_CROWNS_02;
        return;
    }
    if (s.includes('crowns_03')) {
        mesh.material = M_TREE_CROWNS_03;
        return;
    }
    if (s.includes('crowns_04')) {
        mesh.material = M_TREE_CROWNS_04;
        return;
    }
    if (s.includes('trunk')) {
        mesh.material = M_TREE_TRUNKS;
        return;
    }
    if (s.includes('gray_01')) {
        mesh.material = M_GRAY_01;
        return;
    }
    if (s.includes('gray_02')) {
        mesh.material = M_GRAY_02;
        return;
    }
    if (s.includes('gray_03')) {
        mesh.material = M_GRAY_03;
        return;
    }
    if (s.includes('gray_04')) {
        mesh.material = M_GRAY_04;
        return;
    }
    if (s.includes('gray_05')) {
        mesh.material = M_GRAY_05;
        if (s.includes('tribune')) {
            // addEdgeLines(mesh,0xffffff,0.5);
        }
        return;
    }
    if (s.includes('gray_06')) {
        mesh.material = M_GRAY_06;
        return;
    }
    if (s.includes('green_01')) {
        mesh.material = M_GREEN_01;
        return;
    }
    if (s.includes('green_02')) {
        mesh.material = M_GREEN_02;
        return;
    }
    if (s.includes('green_03')) {
        mesh.material = M_GREEN_03;
        return;
    }
    if (s.includes('beige_01')) {
        mesh.material = M_BEIGE_01;
        return;
    }
    if (s.includes('beige_02')) {
        mesh.material = M_BEIGE_02;
        return;
    }
    if (s.includes('beige_03')) {
        mesh.material = M_BEIGE_03;
        return;
    }
    if (s.includes('brown_01')) {
        mesh.material = M_BROWN_01;
        return;
    }
    if (s.includes('brown_02')) {
        mesh.material = M_BROWN_02;
        return;
    }
    if (s.includes('yellow_01')) {
        mesh.material = M_YELLOW_01;
        return;
    }
    if (s.includes('yellow_02')) {
        mesh.material = M_YELLOW_02;
        return;
    }
    if (s.includes('orange_01')) {
        mesh.material = M_ORANGE_01;
        return;
    }
    if (s.includes('blue_01')) {
        mesh.material = M_BLUE_01;
        return;
    }
    if (s.includes('purple_01')) {
        mesh.material = M_PURPLE_01;
        return;
    }
    if (s.includes('red_01')) {
        mesh.material = M_RED_01;
        return;
    }
    if (s.includes('glass')) {
        mesh.material = M_GLASS;
        return;
    }
    if (s.includes('water')) {
        mesh.material = M_GLASS;
        return;
    }
    if (s.includes('ivy')) {
        mesh.material = M_IVY;
        return;
    }



    if (s.includes('roofs')) {
        addEdgeLines(mesh);
        return;
    }
    if (s.includes('people')) {
        mesh.material = M_PEOPLE;
        return;
    }





    // island_A / island_B -> off white + edges
    if (s.includes('island_a') || s.includes('island_b')) {
        mesh.material = M_OFFWHITE;
        addEdgeLines(mesh);
        return;
    }

    // greenery types -> three different greens
    if (s.includes('type_b')) {
        mesh.material = M_PROPOSAL_YELLOW_01;
        addEdgeLines(mesh);
        return;
    }
    if (s.includes('type_c')) {
        mesh.material = M_PROPOSAL_YELLOW_02;
        addEdgeLines(mesh);
        return;
    }
    if (s.includes('type_d')) {
        mesh.material = M_PROPOSAL_YELLOW_03;
        addEdgeLines(mesh);
        return;
    }

    // default -> white
    mesh.material = M_WHITE;
}

// optional: small public API for the rest of your app
window.UF3D = {
    // focus a mesh by name (proposal) and fly to it
    focusMeshByName(name) {
        const m = UFModels.proposal?.pickables?.find(o => o.name === name);
        if (!m) return false;

        // clear old selection
        UFModels.proposal._selected.forEach(o => {
            o.selected = false;
            if (UFModels.proposal.hoverStyle === 'opacity') {
                o.material.opacity = (o._baseOpacity ?? 0.55);
            } else {
                o.material = o._origMat || o.material;
            }
        });
        UFModels.proposal._selected.clear();

        // select + fly
        UFModels.proposal._selected.add(m);
        m.selected = true;
        if (UFModels.proposal.hoverStyle === 'opacity') {
            m.material.opacity = (m._selectedOpacity ?? 1.0);
        }
        const ll = UFModels.proposal.meshCenterLngLat?.(m);
        if (ll) map.easeTo({ center: ll, zoom: 19.5, duration: 1000 });
        return true;
    }
};







const START_ZOOM_DESKTOP = 17.5;
const START_ZOOM_MOBILE = 17; // a touch wider view on phones

const ZOOM_THRESHOLD_DESKTOP = 17.4; // below this, hide details on desktop
const ZOOM_THRESHOLD_MOBILE = 16.9; // below this, hide details on mobile

let zoomLevelThreshold = isMobileDevice() ? ZOOM_THRESHOLD_MOBILE : ZOOM_THRESHOLD_DESKTOP;

// ---- Device detection (robust but simple) ----
function isMobileDevice() {
    const ua = navigator.userAgent || "";
    const coarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
    const small = Math.min(window.innerWidth, window.innerHeight) <= 700;
    const mobileUA = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    const isMobile = coarse || small || mobileUA;
    console.log("Is mobile device: " + isMobile);
    return isMobile;
}

// ---- Geo helpers: 20 km envelope around center ----
function boundsAround(center, km) {
    const [lng, lat] = center;
    const latRad = lat * Math.PI / 180;

    // ~ km per degree
    const KM_PER_DEG_LAT = 110.574;
    const KM_PER_DEG_LNG = Math.max(1e-6, 111.320 * Math.cos(latRad)); // avoid div by 0 near poles

    const dLat = km / KM_PER_DEG_LAT;
    const dLng = km / KM_PER_DEG_LNG;

    const clampLat = v => Math.max(-85, Math.min(85, v)); // Mapbox safe latitude
    const wrapLng = v => ((v + 180) % 360 + 360) % 360 - 180;

    const sw = [wrapLng(lng - dLng), clampLat(lat - dLat)];
    const ne = [wrapLng(lng + dLng), clampLat(lat + dLat)];
    return [sw, ne];
}

// ---- Build derived values ----
const bounds = boundsAround(projectCenter, PROJECT_RADIUS_KM);

const cameraStartOverview = {
    zoom: isMobileDevice() ? START_ZOOM_MOBILE : START_ZOOM_DESKTOP,
    center: pojectCameraStart,
    bearing: 101.47391590634993,
    pitch: 60.49959898565759
};

let PasswordReset = true;

const CAMERA_ICON_URL = 'https://publictwin.info/PromptarePlacemakingWeek/content/Icons/CameraIconMain.svg';
const CAMERA_ICON_WHITE_URL = 'https://publictwin.info/PromptarePlacemakingWeek/content/Icons/CameraIconMainWhite.svg';


const QUESTION_ICON_URL = 'https://publictwin.info/HavenparkGroningen/content/Icons/QuestionIcon.svg';
const QUESTION_ICON_WHITE_URL = 'https://publictwin.info/HavenparkGroningen/content/Icons/QuestionIconWhite.svg';


const participationZones = [
    {
        id: "zone_01",
        no: 1,
        zoneId: "zone_01_strefa_klonow_przy_wroclawskiej",
        meshKey: "zone_01_strefa_klonow_przy_wroclawskiej", // optional alias; same as zoneId
        displayName: "Strefa Klonów Przy Ul.Wrocławskiej",
        center: [18.672931661648164, 50.29181220435936],
        zoom: 19.5, pitch: 65.59729491041661, bearing: -26.64004420693209
    },
    {
        id: "zone_02",
        no: 2,
        zoneId: "zone_02_strefa_przy_ul.akademickiej",
        meshKey: "zone_02_strefa_przy_ul.akademickiej",
        displayName: "Strefa Przy Ul.Akademickiej",
        center: [18.673844779824833, 50.292000080860674],
        zoom: 18.9, pitch: 59.49959898565793, bearing: 119.21133270509085
    },
    {
        id: "zone_03",
        no: 3,
        zoneId: "zone_03_strefa_przy_wydziale_górniczym",
        meshKey: "zone_03_strefa_przy_wydziale_górniczym",
        displayName: "Strefa Przy Wydziale Górniczym",
        center: [18.673479416115583, 50.291386426625934],
        zoom: 18.9, pitch: 57.797498139062874, bearing: 144.3817558952087
    },
    {
        id: "zone_04",
        no: 4,
        zoneId: "zone_04_strefa_przy_ul.łużyckiej",
        meshKey: "zone_04_strefa_przy_ul.łużyckiej",
        displayName: "Strefa Przy Ul.Łużyckiej",
        center: [18.672567517100617, 50.29129475655088],
        zoom: 18.8, pitch: 58.518835078359565, bearing: -115.85465336558286
    },
    {
        id: "zone_05",
        no: 5,
        zoneId: "zone_05_strefa_centralna",
        meshKey: "zone_05_strefa_centralna",
        displayName: "Strefa Centralna",
        center: [18.673093899698472, 50.291697429216214],
        zoom: 18.1, pitch: 34.96489163483665, bearing: -37.22320904093834
    }
];


let participationPoints = [
    {
        id: "point-1",
        name: "Point 1",
        no: 1,
        title: "Toekomstige Parkactiviteiten",
        lngLat: [4.4161, 51.9094],
        height: 2,
        description: "Which scenario (or combination) would you choose and why?",
        media: { type: 'image', src: 'https://publictwin.info/PromptarePlacemakingWeek/content/Images/Locations/1-min.png', alt: 'View from the Piazza Camillo Prampolini' },
        cameraSettings: {
            bearing: -46.481068893487645,
            center: { lng: 4.415163412324574, lat: 51.910036639492574 },
            pitch: 65.68255068649005,
            zoom: 16.522795905917633,
        }

    },
    {
        id: "point-2",
        name: "Point 2",
        no: 2,
        title: "Plezierige Parkervaring",
        lngLat: [4.4125, 51.9119],
        height: 2,
        description: "What harms and benefits do you see for each scenario?",
        media: { type: 'image', src: 'https://publictwin.info/PromptarePlacemakingWeek/content/Images/Locations/2-min.png', alt: 'View from the Piazza Della Vittoria' },
        cameraSettings: {
            bearing: 123.10761129139746,
            center: { lng: 4.413937458110155, lat: 51.911217712237715 },
            pitch: 65.96497640896958,
            zoom: 16.470609650067765,
        }
    },
    {
        id: "point-3",
        name: "Point 3",
        no: 3,
        title: "Persoonlijke Inbreng Vooraf",
        lngLat: [4.4145, 51.9076],
        height: 2,
        description: "What tradeoffs would you make?",
        media: { type: 'image', src: 'https://publictwin.info/PromptarePlacemakingWeek/content/Images/Locations/3-min.png', alt: 'View from the Reggio Emilia Stazione' },
        cameraSettings: {
            bearing: 21.18435014116585,
            center: { lng: 4.415181654600957, lat: 51.90855596139983 },
            pitch: 71.4839625839427,
            zoom: 16.825834406375414,
        }
    },
]
let sitePhotosPoints = [
    {
        id: "point-1",
        name: "Point 1",
        no: 1,
        title: "Locatie 01",
        lngLat: [6.5971, 53.2213],
        height: 2,
        description: "",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/1-min.png', alt: 'View from the Piazza Camillo Prampolini' },
        cameraSettings: {
            bearing: -114.66072759205923,
            center: { lng: 6.595583057017393, lat: 53.220698009944044 },
            pitch: 64.77817580435186,
            zoom: 17.335840646987076,
        }

    },
    {
        id: "point-2",
        name: "Point 2",
        no: 2,
        title: "Locatie 02",
        lngLat: [6.5944, 53.2208],
        height: 2,
        description: "",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/2-min.png', alt: 'View from the Piazza Della Vittoria' },
        cameraSettings: {
            bearing: 171.95358537647303,
            center: { lng: 6.594444463423486, lat: 53.22053998854179 },
            pitch: 64.01457838216855,
            zoom: 17.898754015439863,
        }
    },
    {
        id: "point-3",
        name: "Point 3",
        no: 3,
        title: "Locatie 03",
        lngLat: [6.5946, 53.2189],
        height: 2,
        description: "",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/3-min.png', alt: 'View from the Reggio Emilia Stazione' },
        cameraSettings: {
            bearing: -26.8162795010295,
            center: { lng: 6.593819242821837, lat: 53.21972659422215 },
            pitch: 63.644695745495206,
            zoom: 17.588350744630947,
        }
    },
    {
        id: "point-4",
        name: "Point 4",
        no: 4,
        title: "Locatie 04",
        lngLat: [6.5928, 53.22],
        height: 2,
        description: "",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/4-min.png', alt: 'View from the Reggio Emilia Stazione' },
        cameraSettings: {
            bearing: 19.32873556939512,
            center: { lng: 6.592773739888344, lat: 53.21997298486542 },
            pitch: 57.372799579060505,
            zoom: 18.03260800766054,
        }
    },
]

const relationSelect = document.getElementById('UFFormRelation');
const selfInput = document.getElementById('UFFormRelationSelf');



relationSelect.addEventListener('change', updateRelationField);
updateRelationField(); // initialize on load


function updateRelationField() {
    const isSelfDescribe = relationSelect.value === 'anders, namelijk:';

    // Show/hide the text input and toggle required accordingly
    selfInput.style.display = isSelfDescribe ? '' : 'none';
    selfInput.required = isSelfDescribe;

    // If the user switches away from self-describe, clear the input
    if (!isSelfDescribe) selfInput.value = '';
}




function escapeHTML(str = '') {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
// --- indexing/state ---
const __pointsSorted = [...participationPoints].sort((a, b) => (a.no ?? 0) - (b.no ?? 0));
const __idToIndex = __pointsSorted.reduce((m, p, i) => (m[p.id] = i, m), {});
window.__participationState = { idx: null };

// --- photos indexing/state ---
const __photoPointsSorted = [...sitePhotosPoints].sort((a, b) => (a.no ?? 0) - (b.no ?? 0));
const __photoIdToIndex = __photoPointsSorted.reduce((m, p, i) => (m[p.id] = i, m), {});
window.__photoState = { idx: null };

function resetPinSelection() {
    document.querySelectorAll('.participation-pin').forEach(pin => {
        pin.classList.remove('selectedPin');
        pin.innerHTML = `<img class="icon" alt="" src="${QUESTION_ICON_URL}">`;
        if (pin.classList.contains('photo')) {
            pin.innerHTML = `<img class="icon" alt="" src="${CAMERA_ICON_URL}">`;
        }
    });
}

function selectParticipatePoint(point) {
    if (!point) return;
    resetPinSelection();
    const selectedPin = document.querySelector(`.participation-pin[data-id="${point.id}"]`);
    if (selectedPin) {
        selectedPin.classList.add('selectedPin');
        selectedPin.innerHTML = `<img class="icon" alt="" src="${QUESTION_ICON_WHITE_URL}">`;
    }
}

function navigateParticipate(delta) {
    const st = window.__participationState;
    const N = __pointsSorted.length;
    if (!N) return;
    st.idx = st.idx == null ? 0 : ((st.idx + delta) % N + N) % N;
    const point = __pointsSorted[st.idx];

    let CameraMoveTo = {
        zoom: isMobileDevice() ? point.cameraSettings.zoom - 2 : point.cameraSettings.zoom,
        center: [point.cameraSettings.center.lng, point.cameraSettings.center.lat],
        pitch: point.cameraSettings.pitch,
        bearing: point.cameraSettings.bearing,
    };

    flyTowards(CameraMoveTo);

    console.log('flying to point', point);
    renderParticipatePanel(point);
    selectParticipatePoint(point);



}

function navigatePhotos(delta) {
    const st = window.__photoState;
    const N = __photoPointsSorted.length;
    if (!N) return;
    st.idx = st.idx == null ? 0 : ((st.idx + delta) % N + N) % N;
    const point = __photoPointsSorted[st.idx];

    const CameraMoveTo = {
        zoom: isMobileDevice() ? point.cameraSettings.zoom - 2 : point.cameraSettings.zoom,
        center: [point.cameraSettings.center.lng, point.cameraSettings.center.lat],
        pitch: point.cameraSettings.pitch,
        bearing: point.cameraSettings.bearing,
    };
    flyTowards(CameraMoveTo);

    renderPhotosPanel(point);
    selectPhotoPoint(point);
}

function setCurrentPhoto(point) {
    const idx = __photoIdToIndex[point.id];
    window.__photoState.idx = Number.isInteger(idx) ? idx : 0;

    const CameraMoveTo = {
        zoom: isMobileDevice() ? point.cameraSettings.zoom - 2 : point.cameraSettings.zoom,
        center: [point.cameraSettings.center.lng, point.cameraSettings.center.lat],
        pitch: point.cameraSettings.pitch,
        bearing: point.cameraSettings.bearing,
    };
    flyTowards(CameraMoveTo);

    renderPhotosPanel(point);
    selectPhotoPoint(point);
}



function setCurrentParticipate(point) {
    const idx = __idToIndex[point.id];
    window.__participationState.idx = Number.isInteger(idx) ? idx : 0;
    let CameraMoveTo = {
        zoom: isMobileDevice() ? point.cameraSettings.zoom - 2 : point.cameraSettings.zoom,
        center: [point.cameraSettings.center.lng, point.cameraSettings.center.lat],
        pitch: point.cameraSettings.pitch,
        bearing: point.cameraSettings.bearing,
    };

    flyTowards(CameraMoveTo);


    console.log('flying to point', point);
    renderParticipatePanel(point);
    selectParticipatePoint(point);

}

function resetPhotoPinSelection() {
    document.querySelectorAll('.camera-pin.photo').forEach(pin => {
        pin.classList.remove('selectedPhotoPin');
        pin.innerHTML = `<img class="icon" alt="" src="${CAMERA_ICON_URL}">`;
    });
}

function selectPhotoPoint(point) {
    if (!point) return;
    resetPhotoPinSelection();
    const sel = document.querySelector(`.camera-pin.photo[data-id="${point.id}"]`);
    if (sel) {
        sel.classList.add('selectedPhotoPin');
        sel.innerHTML = `<img class="icon" alt="" src="${CAMERA_ICON_WHITE_URL}">`;
    }
}


// scroll bar:
function isMobileLike() {
    // coarse pointer or small viewport = “mobile enough”
    const coarse = window.matchMedia?.('(pointer: coarse)').matches;
    const small = Math.min(window.innerWidth, window.innerHeight) <= 820;
    return coarse || small;
}

// Per-instance state keyed by element
const SCROLLBAR_STATE = new WeakMap();

function attachMobileScrollBar(bodyEl) {
    if (!bodyEl) return;
    if (SCROLLBAR_STATE.has(bodyEl)) return; // already attached to this element

    // build DOM
    const track = document.createElement('div');
    track.className = 'participate-scrollbar';
    const thumb = document.createElement('div');
    thumb.className = 'thumb';
    track.appendChild(thumb);
    bodyEl.appendChild(track);

    function update() {
        const h = bodyEl.clientHeight;
        const sh = bodyEl.scrollHeight;

        // no overflow => hide track
        if (sh <= h + 1) {
            track.style.display = 'none';
            return;
        }
        track.style.display = 'block';

        // Clamp scrollTop into [0, sh - h] to avoid overscroll jitter
        const maxScroll = Math.max(1, sh - h);
        const stRaw = bodyEl.scrollTop;
        const st = Math.min(Math.max(stRaw, 0), maxScroll);

        // Use the track’s own height; cheaper than getBoundingClientRect() on every tick
        const trackH = track.offsetHeight;

        // Keep the thumb *visible*: ~50% of the track height, with a sane minimum
        const THUMB_FRAC = 0.5;
        const tHeight = Math.max(24, Math.round(trackH * THUMB_FRAC));
        const maxTop = Math.max(0, trackH - tHeight);
        const tTop = Math.round((st / maxScroll) * maxTop);

        thumb.style.height = `${tHeight}px`;
        // Smoother, GPU-friendly movement:
        thumb.style.transform = `translateY(${tTop}px)`;
    }


    let fadeTimer;
    function onScroll() {
        bodyEl.classList.add('scrolling');
        update();
        clearTimeout(fadeTimer);
        fadeTimer = setTimeout(() => bodyEl.classList.remove('scrolling'), 600);
    }

    bodyEl.addEventListener('scroll', onScroll, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(bodyEl);

    // save per-instance state + destroy fn
    SCROLLBAR_STATE.set(bodyEl, {
        track, thumb, ro, onScroll,
        destroy() {
            bodyEl.removeEventListener('scroll', onScroll);
            ro.disconnect();
            track.remove();
            SCROLLBAR_STATE.delete(bodyEl);
        }
    });

    // initial paint
    requestAnimationFrame(() => {
        update();
        if (isMobileLike?.()) {
            bodyEl.classList.add('show-bar');
            setTimeout(() => bodyEl.classList.remove('show-bar'), 1200);
        }
    });
}

// Inline track = exactly host height, no extra space
function attachMobileScrollBarInline(bodyEl) {
    if (!bodyEl || SCROLLBAR_STATE.has(bodyEl)) return;

    // host must be scrollable + positioned
    if (getComputedStyle(bodyEl).position === 'static') bodyEl.style.position = 'relative';
    bodyEl.style.overflowY ||= 'auto';

    const track = document.createElement('div');
    track.className = 'participate-scrollbar inline';
    const thumb = document.createElement('div');
    thumb.className = 'thumb';
    track.appendChild(thumb);
    bodyEl.appendChild(track);

    function update() {
        const h = bodyEl.clientHeight;
        const sh = bodyEl.scrollHeight;

        // if (sh <= h + 1) { track.style.display = 'none'; return; }
        track.style.display = 'block';
        track.style.height = h + 'px'; // lock to host height

        const maxScroll = Math.max(1, sh - h);
        const st = Math.min(Math.max(bodyEl.scrollTop, 0), maxScroll);

        const trackH = track.clientHeight || h;
        const THUMB_FRAC = 0.5;                      // nice chunky thumb
        const tHeight = Math.max(24, Math.round(trackH * THUMB_FRAC));
        const maxTop = Math.max(0, trackH - tHeight);
        const tTop = Math.round((st / maxScroll) * maxTop);

        thumb.style.height = `${tHeight}px`;
        thumb.style.transform = `translateY(${tTop}px)`;
    }

    let fadeTimer;
    function onScroll() {
        bodyEl.classList.add('scrolling');
        update();
        clearTimeout(fadeTimer);
        fadeTimer = setTimeout(() => bodyEl.classList.remove('scrolling'), 600);
    }

    bodyEl.addEventListener('scroll', onScroll, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(bodyEl);

    SCROLLBAR_STATE.set(bodyEl, {
        destroy() {
            bodyEl.removeEventListener('scroll', onScroll);
            ro.disconnect();
            track.remove();
            SCROLLBAR_STATE.delete(bodyEl);
        }
    });

    requestAnimationFrame(() => {
        update();
        bodyEl.classList.add('show-bar');       // brief reveal
        // setTimeout(() => bodyEl.classList.remove('show-bar'), 1200);
    });
}



function detachMobileScrollBar(bodyEl) {
    SCROLLBAR_STATE.get(bodyEl)?.destroy();
}






// Attach to every .scroll element now
function attachMobileScrollBarsAll(root = document) {
    root.querySelectorAll('.scroll').forEach(el => attachMobileScrollBar(el));
}

// Observe DOM for dynamically added/removed .scroll nodes
(function observeScrollables() {
    const mo = new MutationObserver(muts => {
        for (const m of muts) {
            // added nodes
            m.addedNodes.forEach(n => {
                if (n.nodeType !== 1) return;
                if (n.classList?.contains('scroll')) attachMobileScrollBar(n);
                n.querySelectorAll?.('.scroll').forEach(el => attachMobileScrollBar(el));
            });
            // removed nodes -> cleanup to avoid leaks
            m.removedNodes.forEach(n => {
                if (n.nodeType !== 1) return;
                if (n.classList?.contains('scroll')) detachMobileScrollBar(n);
                n.querySelectorAll?.('.scroll').forEach(el => detachMobileScrollBar(el));
            });
        }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // initial pass (after DOM ready)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => attachMobileScrollBarsAll());
    } else {
        attachMobileScrollBarsAll();
    }
})();

function showParticipateWrapper() {
    const wrapper = document.getElementById('ParticipateMenuWrapper');
    if (!wrapper) return;

    // Cancel any pending close cleanup
    if (wrapper._closing?.cancel) wrapper._closing.cancel();

    wrapper.classList.remove('UrbanFutureDisplayNone'); // legacy safety
    wrapper.classList.add('is-open');
    wrapper.setAttribute('aria-hidden', 'false');
}

function hideParticipateWrapper(clearOnEnd = true) {
    const wrapper = document.getElementById('ParticipateMenuWrapper');
    if (!wrapper) return;

    wrapper.classList.remove('is-open');
    wrapper.setAttribute('aria-hidden', 'true');

    if (!clearOnEnd) return;

    // Cancel previous closing handler (if any)
    if (wrapper._closing?.cancel) wrapper._closing.cancel();

    // Token to identify THIS hide operation
    const token = Symbol('uf-hide');
    const onEnd = (e) => {
        if (e.propertyName !== 'transform') return;       // only care about transform
        if (wrapper._closing?.token !== token) return;     // stale handler; ignore
        if (wrapper.classList.contains('is-open')) return; // reopened; don't clear

        wrapper.removeEventListener('transitionend', onEnd);
        wrapper._closing = null;
        wrapper.innerHTML = '';
    };

    // Save cancel handle
    wrapper._closing = {
        token,
        cancel() {
            wrapper.removeEventListener('transitionend', onEnd);
            wrapper._closing = null;
        }
    };

    wrapper.addEventListener('transitionend', onEnd);
}

// Render the participate panel for a given point, or hide if none
function renderParticipatePanel(point) {
    const wrapper = document.getElementById('ParticipateMenuWrapper');
    if (!wrapper) return;

    if (!point) {
        // Deselect the currently selected participation pin (if any)
        const sel = PinZManager.selectedId;               // e.g. "participation::point-1"
        if (sel) {
            const [type, id] = String(sel).split('::');
            if (type === 'participation') {
                PinZManager.setSelected(id, type, false);     // closes pin-popup via onDeselect
            }
        }

        window.__participationState.idx = null;
        resetPinSelection();
        hideParticipateWrapper();
        return;
    }

    const title = escapeHTML(point.title ?? point.name ?? '');
    const desc = escapeHTML(point.description ?? '');
    const media = point.media && point.media.type === 'image'
        ? `<img class="participate-media" src="${point.media.src}" alt="${escapeHTML(point.media.alt || title)}">`
        : '';

    wrapper.innerHTML = `
    <div class="participate-panel" data-point-id="${escapeHTML(point.id)}">
      <button id="participate-close" class="participate-close clickableButton" aria-label="Close">
        <img class="participateIcon"
             src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CloseMenu.png" />
      </button>

      <div id="participate-nav" class="participate-nav-abs" aria-label="Navigate places">
        <button id="participate-prev" class="participate-nav-btn" aria-label="Previous place" title="Previous">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/PreviousIcon.svg" />
        </button>
        <button id="participate-next" class="participate-nav-btn" aria-label="Next place" title="Next">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/NextIcon.svg" />
        </button>
      </div>

      

      <div class="participate-body" id="participate-body">
        
        <div id="participate-question-block" class="participate-question-wrapper">

          <label class="participate-question" for="participate-input">
            ${desc}
          </label>

          <div class="participate-input-wrapper">
            <textarea id="participate-input" class="participate-input" placeholder="Typ je idee ..."></textarea>
            <button id="participate-submit" class="participate-submit clickableButton">
              <img class="participateIcon"
                   src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/SendIconMainWhite.svg" />
            </button>
          </div>
          <div id="zones-description" class="zones-description" style="margin-top:12px; white-space:pre-wrap;"></div>

        </div>
      </div>
    </div>
  `;

    // attach mobile scrollbar to this body
    // attachMobileScrollBar(document.getElementById('participate-body'));

    // wire buttons
    document.getElementById('participate-close').onclick = () => renderParticipatePanel(null);
    const prev = document.getElementById('participate-prev');
    const next = document.getElementById('participate-next');
    if (__pointsSorted.length <= 1) { prev.disabled = true; next.disabled = true; }
    prev.onclick = () => navigateParticipate(-1);
    next.onclick = () => navigateParticipate(1);
    if (point?.id != null) {
        // select via manager so z-order & popup rules apply
        PinZManager.setSelected(point.id, 'participation', true);
    }

    // ---- Trigger selection logic (random on point change) ----
    const triggerSpan = document.getElementById('participate-trigger-text');
    const regenBtn = document.getElementById('participate-trigger-regenerate');

    // participation state bag
    const st = (window.__participationState = window.__participationState || {});
    st.triggerByPoint = st.triggerByPoint || {};  // map: pointId -> triggerId

    // detect if point changed since last open
    const prevPointId = st._prevPointId;
    const pointChanged = prevPointId !== point.id;
    st._prevPointId = point.id;


    // --- Submit answer ---
    const inputEl = document.getElementById('participate-input');
    const submitEl = document.getElementById('participate-submit');

    // Check readiness whenever the field is focused/clicked
    if (inputEl) {
        const checkReady = () => {
            if (ReadyToStart || ReadyToStartViaLogin) {
                console.log('can submit');
            }
            else {
                console.log('cannot submit yet');
                while (document.getElementById("UserMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
                    document.getElementById("UserMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone")
                }
                document.getElementById("UrbanFutureIntroduceButton").click();
            }
        };

        // Fire on keyboard/tab focus and on pointer/touch clicks
        inputEl.addEventListener('focus', checkReady, { passive: true });
        inputEl.addEventListener('pointerdown', checkReady, { passive: true });
        inputEl.addEventListener('click', checkReady, { passive: true });
    }



    // simple double-submit guard
    let isSubmitting = false;

    if (submitEl) {
        submitEl.addEventListener('click', async (ev) => {
            ev.preventDefault();

            if (isSubmitting) return; // guard
            const answer_text = (inputEl?.value || '').trim();

            // OPTIONAL: minimum length gate (reduce noise)
            if (!answer_text) {
                inputEl?.focus();
                inputEl?.setAttribute('placeholder', 'Typ iets concreets (min. 5 tekens)…');
                return;
            }

            // disable UI while working
            isSubmitting = true;
            submitEl.disabled = true;
            submitEl.classList.add('is-loading'); // if you have a CSS spinner class

            // helper: fetch with timeout
            const fetchJSON = async (url, options = {}, timeoutMs = 15000) => {
                const ctrl = new AbortController();
                const to = setTimeout(() => ctrl.abort(), timeoutMs);
                try {
                    const res = await fetch(url, { ...options, signal: ctrl.signal });
                    const json = await res.json().catch(() => ({}));
                    return { ok: res.ok, status: res.status, json };
                } finally {
                    clearTimeout(to);
                }
            };

            try {
                // 1) Classify first
                showParticipateStatusHTML('<strong>Even geduld…</strong> je idee wordt geanalyseerd…', 'loading');
                const classifyPayload = { answer_text };
                const cls = await fetchJSON(
                    'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Classify_And_Translate.php',
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(classifyPayload)
                    },
                    15000 // 15s timeout
                );

                if (!cls.ok || cls.json?.status !== 'ok') {
                    showParticipateStatus('kan niet classificeren — probeer opnieuw', 'error');
                    return;
                }

                // destructure + sanity
                const answer_text_en = typeof cls.json.answer_text_en === 'string' ? cls.json.answer_text_en : '-';
                const language = typeof cls.json.language === 'string' ? cls.json.language : 'und';
                const sentiment = typeof cls.json.sentiment === 'string' ? cls.json.sentiment : 'not for classification';
                const categories = Array.isArray(cls.json.categories) ? cls.json.categories : ['other'];
                const insight_score = Number.isFinite(cls.json.insight_score)
                    ? Math.max(0, Math.min(100, Math.trunc(cls.json.insight_score))) : 0;

                // 2) Gather other fields
                const uid = sessionStorage.getItem('userID') || '-';
                const ipObj = (window.userIP && window.userIP !== '')
                    ? { ip: window.userIP }
                    : (await fetchJSON('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php', {}, 8000)).json || {};
                const ip = ipObj.ip || '-';

                const question_id = Number.isFinite(point.no)
                    ? point.no
                    : (parseInt(String(point.id).replace(/\D+/g, ''), 10) || 0);

                const age_group = sessionStorage.getItem('userAge') || window.sessionUserAge || '-';
                const relation_to_place = sessionStorage.getItem('userRelation') || window.sessionUserRelation || '-';
                const gender = sessionStorage.getItem('userGender') || window.sessionUserGender || '-';

                // 3) Insert with classification fields (+ insight_score, source: 'app')
                const insertBody = {
                    table: databaseAnswersName,
                    question_id,
                    answer_text,
                    answer_text_en,
                    language,
                    sentiment,
                    categories,       // array is fine; PHP will normalize
                    insight_score,    // NEW
                    user_IP: ip,
                    user_identifier: uid,
                    logged_in_user_id: sessionStorage.getItem('loginUserID') || '-',
                    age_group,
                    relation_to_place,
                    gender,
                    source: 'app'     // distinguish from OCR forms
                };

                const ins = await fetchJSON(
                    'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Answers_Insert.php',
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(insertBody)
                    },
                    15000
                );

                if (ins.ok && ins.json?.status === 'ok') {
                    inputEl.value = '';
                    // categories is your array from the classifier result
                    const catsHTML = categories.map(c => `
                    <span class="cat-chip">
                        <span class="cat-ico">${iconFor(c)}</span>
                        <span class="cat-lbl">${labelNL(c)}</span>
                    </span>
                    `).join(' ');

                    showParticipateStatusHTML(
                        `jouw idee is opgeslagen ✔ — je droeg bij aan: ${catsHTML}`,
                        'ok'
                    );
                    hideParticipateStatus(5000);
                    updateAnswerBadgesAll?.();
                    updateCategoryChipsAll?.();

                    // OPTIONAL: tiny “receipt” chip under the textarea
                    // (Uncomment if you want to show immediate feedback)
                    /*
                    const chipHost = document.getElementById('participate-question-block');
                    if (chipHost && !chipHost.querySelector('.cls-chip')) {
                      const chip = document.createElement('div');
                      chip.className = 'cls-chip';
                      chip.innerHTML = `
                        <span class="cls-sentiment">${sentiment}</span>
                        <span class="cls-cats">${categories.join(', ')}</span>
                        <span class="cls-score">insight: ${insight_score}</span>
                      `;
                      chipHost.appendChild(chip);
                      setTimeout(() => chip.remove(), 4500);
                    }
                    */
                } else {
                    const msg = ins.json?.message || 'kon niet opslaan — probeer het opnieuw';
                    showParticipateStatus(msg, 'error');
                }
            } catch (err) {
                const aborted = err?.name === 'AbortError';
                showParticipateStatus(aborted ? 'timeout — probeer het opnieuw' : 'netwerkfout — probeer het opnieuw', 'error');
            } finally {
                isSubmitting = false;
                submitEl.disabled = false;
                submitEl.classList.remove('is-loading');
            }
        }, { passive: false });
    }


    // open with slide-in
    showParticipateWrapper();

    // Optionally close other menus
    if (UrbanFutureSelectOptionsMenuOpen) {
        UrbanFutureTopNavbarSelectOptions.click();
    }
}


const PERSON_ICON_URL = 'https://publictwin.info/digital_maquette/content/Urban_Future/Icons/PersonIcon.svg';
function metersToPixelsAtLat(meters, lat, zoom) {
    const earth = 40075016.686;              // meters
    const latRad = lat * Math.PI / 180;
    const metersPerPixel = (earth * Math.cos(latRad)) / (512 * Math.pow(2, zoom));
    return meters / metersPerPixel;          // pixels
}
function bindOutsideClose(handler) {
    const host = map?.getContainer?.() || document; // only listen on the map, not whole document
    const onDoc = (ev) => {
        const t = ev.target;
        if (!t) return;

        // ignore clicks inside pins or their popup
        if (t.closest('.pin-wrap') || t.closest('.pin-popup')) return;

        // ignore clicks inside any menu/panel
        if (t.closest('#ParticipateMenuWrapper')) return;

        // if the click wasn't even on the map container, ignore it
        if (!host.contains(t)) return;

        handler();
    };

    host.addEventListener('pointerdown', onDoc, true); // pointerdown is snappier & consistent
    return () => host.removeEventListener('pointerdown', onDoc, true);
}


function createParticipationPinsSimple(points) {
    const pins = [];
    let selectedIdLocal = null;
    let unbindOutsideClose = null; // cleanup handle

    const ICONS = (typeof CATEGORY_ICONS === 'object' && CATEGORY_ICONS) || {};
    const labelNLsafe = (typeof labelNL === 'function') ? labelNL : (c => c);
    const iconForsafe = (typeof iconFor === 'function') ? iconFor : (c => (ICONS[c] || '•'));

    async function fetchCategorySummaryForPins() {
        const table = window.databaseAnswersName || 'HavenparkGroningenAnswers';
        const qids = (window.participationPoints || points)
            .map(p => Number(p.no || 0))
            .filter(n => Number.isFinite(n) && n > 0);
        if (!qids.length) return {};
        const res = await fetch(
            'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Answers_Categories_Summary.php',
            { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ table, question_ids: qids }) }
        ).then(r => r.json()).catch(() => null);
        if (!res || res.status !== 'ok') return {};
        return res.summary || {};
    }

    function renderTop3Chips(container, topArr) {
        container.innerHTML = '';
        const row = document.createElement('div');
        row.className = 'pin-chips';
        (topArr || []).slice(0, 3).forEach(({ category }) => {
            const chip = document.createElement('div');
            chip.className = 'pin-chip';
            chip.title = labelNLsafe(category);
            chip.textContent = ICONS[category] || '•';
            row.appendChild(chip);
        });
        container.appendChild(row);
    }

    function closePinPopup(wrap) {
        const el = wrap?.querySelector?.('.pin-popup');
        if (el) el.remove();
    }

    // shows immediately (loading…), then fills with data
    async function showTop6PopupOverPin(pinWrap, point) {
        closePinPopup(pinWrap);

        const popup = document.createElement('div');
        popup.className = 'pin-popup';
        popup.style.left = '50%';
        popup.style.bottom = '40px';
        popup.innerHTML = `<span class="pill">loading…</span>`;
        pinWrap.style.position = 'relative';
        pinWrap.appendChild(popup);

        const qid = Number(point.no || 0);
        if (!qid) {
            popup.innerHTML = `<span class="pill">no data</span>`;
            return;
        }

        try {
            const table = window.databaseAnswersName || 'HavenparkGroningenAnswers';
            const res = await fetch(
                'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Answers_Categories_Summary.php',
                { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ table, question_ids: [qid] }) }
            ).then(r => r.json());
            const list = (res?.summary?.[String(qid)] || []).slice(0, 6);
            if (!list.length) {
                popup.innerHTML = `<span class="pill">geen categorieën</span>`;
            } else {
                popup.innerHTML = list.map(({ category, count }) =>
                    `<span class="pill" title="${labelNLsafe(category)}">
             ${iconForsafe(category)} ${labelNLsafe(category)} (${count})
           </span>`
                ).join(' ');
            }
        } catch {
            popup.innerHTML = `<span class="pill">kon niet laden</span>`;
        }

        popup.addEventListener('wheel', (ev) => ev.stopPropagation(), { passive: false });
        let touchStartY = 0;
        popup.addEventListener('touchstart', (ev) => { touchStartY = ev.touches?.[0]?.clientY || 0; }, { passive: true });
        popup.addEventListener('touchmove', (ev) => {
            const el = popup;
            const atTop = el.scrollTop <= 0;
            const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
            const y = ev.touches?.[0]?.clientY || touchStartY;
            const dy = y - touchStartY;
            if ((atTop && dy > 0) || (atBottom && dy < 0)) ev.preventDefault();
            ev.stopPropagation();
        }, { passive: false });
    }

    function makeEl(point) {
        const wrap = document.createElement('div');
        wrap.className = 'pin-wrap';
        wrap.style.position = 'relative';

        const chipsHost = document.createElement('div');
        chipsHost.className = 'chips-host';
        wrap.appendChild(chipsHost);

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'participation-pin';
        btn.dataset.id = point.id;
        btn.setAttribute('aria-label', point.title || point.name || 'Location');
        btn.innerHTML = `<img class="icon" alt="" src="${QUESTION_ICON_URL}">`;

        const badge = document.createElement('div');
        badge.className = 'pin-count';
        badge.dataset.questionId = String(point.no || 0);
        badge.innerHTML = `<img src="${PERSON_ICON_URL}" alt=""><span class="n">0</span>`;

        wrap.appendChild(btn);
        wrap.appendChild(badge);

        const handleOpen = (ev) => {
            ev?.stopPropagation?.();
            PinZManager.setSelected(point.id, 'participation', true);   // will open popup via onSelect
            selectedIdLocal = point.id;
            setCurrentParticipate(point);
            // bind outside close once when something is selected
            if (!unbindOutsideClose) {
                unbindOutsideClose = bindOutsideClose(() => {
                    renderParticipatePanel(null);
                    if (selectedIdLocal != null) {
                        PinZManager.setSelected(selectedIdLocal, 'participation', false);
                        selectedIdLocal = null;
                    }
                    if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
                });
            }
        };

        btn.addEventListener('click', handleOpen, { passive: true });
        btn.addEventListener('touchend', handleOpen, { passive: true });
        btn.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); handleOpen(ev); }
        });

        return { wrap, btn, badge, chipsHost };
    }

    function updateAllOffsets() {
        pins.forEach(p => {
            const lat = p.def.lngLat[1];
            const hMeters = Number(p.def.height || 0);
            const px = hMeters > 0 ? Math.round(metersToPixelsAtLat(hMeters, lat, map.getZoom())) : 0;
            p.marker.setOffset([0, -px]);
        });
    }

    points.forEach(pt => {
        const { wrap, btn, badge, chipsHost } = makeEl(pt);
        const marker = new mapboxgl.Marker({ element: wrap, anchor: 'bottom', offset: [0, 0] })
            .setLngLat(pt.lngLat)
            .addTo(map);

        pins.push({ def: pt, marker, el: btn, wrap, badge, chipsHost });

        PinZManager.register(pt.id, 'participation', {
            wrap,
            lngLat: pt.lngLat,
            type: 'participation',
            onSelect: () => showTop6PopupOverPin(wrap, pt),
            onDeselect: () => closePinPopup(wrap)
        });
    });

    (async () => {
        const summary = await fetchCategorySummaryForPins();
        for (const p of pins) {
            const qid = String(p.def.no || 0);
            renderTop3Chips(p.chipsHost, summary[qid] || []);
        }
        PinZManager.updateAll();
    })();

    const update = () => updateAllOffsets();
    map.on('zoom', update);
    map.on('pitch', update);
    map.on('resize', update);
    updateAllOffsets();

    // expose selection for participate-nav
    function selectById(id) {
        PinZManager.setSelected(id, 'participation', true);
        selectedIdLocal = id;
        if (!unbindOutsideClose) {
            unbindOutsideClose = bindOutsideClose(() => {
                renderParticipatePanel(null);
                if (selectedIdLocal != null) {
                    PinZManager.setSelected(selectedIdLocal, 'participation', false);
                    selectedIdLocal = null;
                }
                if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
            });
        }
    }
    window.__participationPinsAPI = { selectById };

    return {
        pins,
        show: renderParticipatePanel,
        hide() {
            renderParticipatePanel(null);
            if (selectedIdLocal != null) PinZManager.setSelected(selectedIdLocal, 'participation', false);
            selectedIdLocal = null;
            if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
        },
        selectById,
        destroy() {
            pins.forEach(p => {
                p.marker.remove();
                PinZManager.unregister(p.def.id, 'participation');
            });
            map.off('zoom', update);
            map.off('pitch', update);
            map.off('resize', update);
            if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
        }
    };
}



// Fetch counts for a set of question IDs and update badges
async function updateAnswerBadgesAll() {
    const table = window.databaseAnswersName || 'HavenparkGroningenAnswers';
    const qids = participationPoints
        .map(p => Number(p.no || 0))
        .filter(n => Number.isFinite(n) && n > 0);

    if (!qids.length) return;

    try {
        const res = await fetch('https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Answers_Counts.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                table,
                question_ids: qids
                // option: source: 'app' // if you want to limit counts by source
            })
        }).then(r => r.json());

        // Expect: { status: 'ok', counts: { "1": 5, "2": 12, ... } }
        if (res?.status === 'ok' && res.counts) {
            const counts = res.counts;
            for (const pin of (window.__participationPins?.pins || [])) {
                const qid = String(pin?.def?.no || 0);
                const n = counts[qid] ?? 0;
                if (pin?.badge) {
                    const nEl = pin.badge.querySelector('.n');
                    if (nEl) nEl.textContent = String(n);
                }
            }
        }
    } catch (e) {
        console.warn('Failed to fetch answer counts', e);
    }
}
async function updateCategoryChipsAll() {
    const table = window.databaseAnswersName || 'HavenparkGroningenAnswers';
    const qids = participationPoints
        .map(p => Number(p.no || 0))
        .filter(n => Number.isFinite(n) && n > 0);

    if (!qids.length) return;

    try {
        const res = await fetch('https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Answers_Categories_Summary.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ table, question_ids: qids })
        }).then(r => r.json());

        if (res?.status === 'ok' && res.summary) {
            const summary = res.summary;
            for (const pin of (window.__participationPins?.pins || [])) {
                const qid = String(pin?.def?.no || 0);
                const top = summary[qid] || [];
                if (pin?.wrap) {
                    const chipsHost = pin.wrap.querySelector('.chips-host') || pin.chipsHost;
                    if (chipsHost) renderTop3Chips(chipsHost, top);
                }
            }
        }
    } catch (e) {
        console.warn('Failed to fetch categories summary', e);
    }
}


function renderPhotosPanel(point) {
    const wrapper = document.getElementById('ParticipateMenuWrapper');
    if (!wrapper) return;

    if (!point) {
        window.__photoState.idx = null;
        resetPhotoPinSelection();
        hideParticipateWrapper();
        return;
    }

    const title = escapeHTML(point.title ?? point.name ?? '');
    const media = (point.media && point.media.type === 'image')
        ? `<img class="participate-media" src="${point.media.src}" alt="${escapeHTML(point.media.alt || title)}">`
        : '';
    const desc = point.description ? `<p class="participate-desc">${escapeHTML(point.description)}</p>` : '';

    wrapper.innerHTML = `
    <div class="participate-panel" data-photo-id="${escapeHTML(point.id)}">
      <button id="participate-close" class="participate-close clickableButton" aria-label="Close">
        <img class="participateIcon"
             src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CloseMenu.png" />
      </button>

      <div id="participate-nav" class="participate-nav-abs" aria-label="Navigate photos">
        <button id="participate-prev" class="participate-nav-btn" aria-label="Previous photo" title="Previous">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/PreviousIcon.svg" />
        </button>
        <button id="participate-next" class="participate-nav-btn" aria-label="Next photo" title="Next">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/NextIcon.svg" />
        </button>
      </div>



      <div class="participate-body scroll" id="participate-body">
        ${media}
        ${desc}
      </div>
    </div>
  `;

    // scroll bar for the body
    // attachMobileScrollBar(document.getElementById('participate-body'));

    // wire buttons
    document.getElementById('participate-close').onclick = () => renderPhotosPanel(null);
    const prev = document.getElementById('participate-prev');
    const next = document.getElementById('participate-next');
    if (__photoPointsSorted.length <= 1) { prev.disabled = true; next.disabled = true; }
    prev.onclick = () => navigatePhotos(-1);
    next.onclick = () => navigatePhotos(1);

    showParticipateWrapper();

    if (window.UrbanFutureSelectOptionsMenuOpen) {
        UrbanFutureTopNavbarSelectOptions.click();
    }
}

function createPhotosPinsSimple(points) {
    const pins = [];
    let selectedPhotoIdLocal = null;
    let unbindOutsideClose = null;

    function makeEl(point) {
        const el = document.createElement('button');
        el.type = 'button';
        el.className = 'camera-pin photo';
        el.dataset.id = point.id;
        el.setAttribute('aria-label', point.title || point.name || 'Photo location');
        el.innerHTML = `<img class="icon" alt="" src="${CAMERA_ICON_URL}">`;

        const open = (ev) => {
            ev?.stopPropagation?.();
            PinZManager.setSelected(point.id, 'photo', true);
            selectedPhotoIdLocal = point.id;
            setCurrentPhoto(point);

            if (!unbindOutsideClose) {
                unbindOutsideClose = bindOutsideClose(() => {
                    renderPhotosPanel(null);
                    if (selectedPhotoIdLocal != null) {
                        PinZManager.setSelected(selectedPhotoIdLocal, 'photo', false);

                        selectedPhotoIdLocal = null;
                    }
                    if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
                });
            }
        };

        el.addEventListener('click', open, { passive: true });
        el.addEventListener('touchend', open, { passive: true });
        el.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); open(ev); }
        });

        return el;
    }

    points.forEach(pt => {
        const el = makeEl(pt);
        const marker = new mapboxgl.Marker({ element: el, anchor: 'center' })
            .setLngLat(pt.lngLat)
            .addTo(map);

        pins.push({ def: pt, marker, el });

        PinZManager.register(pt.id, 'photo', {
            wrap: el,
            lngLat: pt.lngLat,
            type: 'photo'
        });
    });

    return {
        pins,
        show: renderPhotosPanel,
        hide() {
            renderPhotosPanel(null);
            if (selectedPhotoIdLocal != null) PinZManager.setSelected(selectedPhotoIdLocal, 'photo', false);

            selectedPhotoIdLocal = null;
            if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
        },
        destroy() {
            pins.forEach(p => {
                p.marker.remove();
                PinZManager.unregister(p.def.id, 'photo');
            });
            if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
        }
    };
}







function initPinsOnce() {
    if (!window.__participationPins) {
        window.__participationPins = createParticipationPinsSimple(participationPoints);
    }
    if (!window.__photoPins) {
        window.__photoPins = createPhotosPinsSimple(sitePhotosPoints);
    }
    console.log('pins initialized');
    updateAnswerBadgesAll();
}



function ensureParticipateStatusHost() {
    const body = document.getElementById('participate-body');
    if (!body) return null;

    // Reuse one status node per panel
    let status = body.querySelector('.participate-status');
    if (!status) {
        status = document.createElement('div');
        status.className = 'participate-status';
        const anchor = body.querySelector('.participate-input-wrapper:last-of-type') || body.lastElementChild;
        (anchor || body).insertAdjacentElement('afterend', status);
    }
    return status;
}

/**
 * Text-only status (safe): message as plain text.
 * mode: 'loading' | 'ok' | 'error' | 'info'
 */
function showParticipateStatus(message, mode = 'loading') {
    const status = ensureParticipateStatusHost();
    if (!status) return;

    status.innerHTML = '';                 // clear any HTML
    status.textContent = message;          // set plain text
    status.className = 'participate-status';
    status.classList.add(mode);

    // Add spinner only for loading
    if (mode === 'loading') {
        const spin = document.createElement('span');
        spin.className = 'spinner';
        status.prepend(spin);
    }
}

/**
 * HTML-capable status (use when you need icons/badges).
 * mode: 'loading' | 'ok' | 'error' | 'info'
 */
function showParticipateStatusHTML(html, mode = 'info') {
    const status = ensureParticipateStatusHost();
    if (!status) return;

    status.className = 'participate-status';
    status.classList.add(mode);
    status.innerHTML = html;

    if (mode === 'loading') {
        // If your HTML didn’t include a spinner, we’ll add one at the start
        if (!status.querySelector('.spinner')) {
            const spin = document.createElement('span');
            spin.className = 'spinner';
            status.prepend(spin);
        }
    }
}

function hideParticipateStatus(delay = 1200) {
    const body = document.getElementById('participate-body');
    const status = body?.querySelector('.participate-status');
    if (status) setTimeout(() => status.remove(), delay);
}







let map = null;

// --- Shared z-index manager for ALL pins (participation + photos) ---
// Depth metric: geodesic distance (meters) from camera target (map.getCenter()).
// Closer distance -> higher z-index. Selected pin still wins via a large boost.
const PinZManager = (() => {
    const registry = new Map();
    let mapRef = null;
    let selectedKey = null;

    // --- z-index budget (keep pins within ~0..1000) ---
    const Z_CAP = 1000;
    const TYPE_BASE = { participation: 600, photo: 400 }; // tier bases
    const DEPTH_RANGE = 200;   // contribution from distance: 0..200
    const SELECT_BOOST = 350;   // selected pin gets a big bump

    // keep your keying the same
    const keyFor = (id, type) => `${type}::${id}`;

    function geoDistanceMeters(a, b) {
        const toRad = d => d * Math.PI / 180;
        const R = 6371008.8;
        const dLat = toRad(b.lat - a.lat);
        const dLng = toRad(b.lng - a.lng);
        const la1 = toRad(a.lat);
        const la2 = toRad(b.lat);
        const sa = Math.sin(dLat / 2);
        const sb = Math.sin(dLng / 2);
        const h = sa * sa + Math.cos(la1) * Math.cos(la2) * sb * sb;
        return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
    }

    // distance -> 0..DEPTH_RANGE (closer => larger). Tune D0 for your scene scale.
    function depthFromDistance(dist) {
        const D0 = 500;                 // ~“half distance” in meters
        const frac = 1 / (1 + dist / D0);  // 0..1
        return Math.round(frac * DEPTH_RANGE);
    }

    function zFor(p) {
        const base = TYPE_BASE[p.type] ?? 0;
        const center = mapRef?.getCenter?.();
        const dist = (center && p.lngLat)
            ? geoDistanceMeters({ lng: center.lng, lat: center.lat }, { lng: p.lngLat[0], lat: p.lngLat[1] })
            : 0;

        const depth = depthFromDistance(dist);           // 0..200
        const boost = p.selected ? SELECT_BOOST : 0;     // 0 or 350

        // cap so pins never exceed ~1000
        return Math.min(Z_CAP, base + depth + boost);
    }

    function updateAll() {
        registry.forEach((p) => {
            if (!p?.wrap) return;
            p.wrap.style.zIndex = String(zFor(p));
        });
    }

    function setSelected(id, type, on) {
        const key = keyFor(id, type);
        if (on) {
            if (selectedKey && registry.has(selectedKey)) {
                const prev = registry.get(selectedKey);
                prev.selected = false;
                prev.onDeselect?.(prev);
            }
            selectedKey = key;
            const cur = registry.get(key);
            if (cur) {
                cur.selected = true;
                cur.onSelect?.(cur);
            }
        } else {
            if (selectedKey === key) selectedKey = null;
            const cur = registry.get(key);
            if (cur) {
                cur.selected = false;
                cur.onDeselect?.(cur);
            }
        }
        updateAll();
    }

    return {
        init(map) { mapRef = map; updateAll(); },
        register(id, type, pinData) {
            registry.set(keyFor(id, type), { ...pinData, type, selected: !!pinData.selected });
            updateAll();
        },
        unregister(id, type) {
            if (selectedKey === keyFor(id, type)) selectedKey = null;
            registry.delete(keyFor(id, type));
            updateAll();
        },
        setSelected,
        updateAll,
        get selectedId() { return selectedKey; },
        _keyFor: keyFor
    };
})();





let initialDistance = null;
let URLBasedProject = null;
var modelLoaded = false;
var detailedModelLoaded = false;
var symbolsEntered = [];
var multitouchDetected = false;
var raycast = null;



var activeModel = null;
var selectedProject = null;
var zoomLevel = null;


var currentScale = "global";
var clickPointLngLat = null;
var imagesLoaded = null;
var dropingPinState = false;

var userPermissionsStatus = null;
var userProjectPermissionsStatus = "public";


// === Initialize ===


initializeMapbox();

// map on load functionality: => To be cleared up:

function initializeMapbox() {
    fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/mapbox_get_token.php')
        .then(response => response.json())
        .then(data => {
            mapboxgl.accessToken = data.token;

            map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u',
                ...cameraStartOverview,
                antialias: true,
                preserveDrawingBuffer: true,
                maxBounds: bounds
            });
            PinZManager.init(map);

            // keep z-order in sync with camera
            map.on('move', () => PinZManager.updateAll());
            map.on('zoom', () => PinZManager.updateAll());
            map.on('pitch', () => PinZManager.updateAll());
            map.on('rotate', () => PinZManager.updateAll());

            // Ensure pins are created only after the map is fully loaded
            if (typeof map.loaded === 'function' && map.loaded()) {
                initPinsOnce();
            } else {
                map.once('load', initPinsOnce);
            }

            initializeMapFunctionalities();

            // Continue with map setup...
        })
        .catch(err => {
            console.error("Failed to fetch Mapbox token:", err);
        });

}


function initializeMapFunctionalities() {

    map.on('load', () => {

        addCustom3DModels();
        buildProposalSwitcherUI();
        buildTreesSwitchUI();
        reflectTreesSwitchUI();       // ensure UI reflects default
        updateTreesVisibilityForActive();
        initZonesFeature();
        installStylePersistence();
        // Figutnig out what layers are added to the map:
        const style = map.getStyle();

        // Extract the layers array
        const layers = style.layers;

        // Log the layers to the console
        // console.log("Current map layers:", layers);


        // Add images and layer after images are loaded
        imagesLoaded = 0;
        // console.log("loading the map!");

        function checkImagesLoaded() {
            // console.log("running check images loaded!")
            imagesLoaded++;
            if (imagesLoaded >= 2) { // Number of images
                // Add the source and layer after images are loaded
                map.addSource('PTProjects', {
                    'type': 'geojson',
                    'data': PublicTwinProjects
                });

                map.addLayer({
                    'id': 'PTProjects',
                    'type': 'symbol',
                    'source': 'PTProjects',
                    'layout': {
                        'icon-image': [
                            'case',
                            ['==', ['get', 'activeStatus'], 'maquetteInDevelopment'], 'logo2',
                            ['==', ['get', 'activeStatus'], 'activeMaquette'], 'logo1',
                            'logo1'
                        ],
                        'icon-size': 0.025,
                        'icon-padding': 0,
                        'icon-allow-overlap': true
                    }
                });
            }
        }
        checkLoadedOrigin();

        // console.log(PublicTwinProjects);

        // Load images
        map.loadImage('./res/map/PublicTwin_Marker_Logo_Yellow.png', (error, image) => {
            if (error) throw error;
            map.addImage('logo1', image);
            checkImagesLoaded();
        });

        map.loadImage('./res/map/PublicTwin_Marker_Logo_Grey.png', (error, image) => {
            if (error) throw error;
            map.addImage('logo2', image);
            checkImagesLoaded();
        });





        map.on('mouseenter', 'PTProjects', (e) => {
            map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const description = e.features[0].properties.description;

            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            popup.setLngLat(coordinates)
                .setHTML(
                    `<h3>${e.features[0].properties.title}</h3>
                <img src="${e.features[0].properties.image}" class="popupImage"></img>
                <p><span>${e.features[0].properties.description}</span></p>
                <button id="enterProjectButton-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="enterButton clickableButton">rozpocznij!</button>`
                )
                .addTo(map);

            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');

            const enterButton = document.getElementById(`enterProjectButton-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
            if (enterButton) {
                enterButton.addEventListener('click', () => {

                    for (var l = 0; l < PublicTwinProjects.features.length; l++) {
                        if (PublicTwinProjects.features[l].properties.title == e.features[0].properties.title) {
                            selectedProject = PublicTwinProjects.features[l];
                        }
                    }


                    if (e.features[0].properties.activeStatus === "activeMaquette") {
                        handleButtonClick(e.features[0].properties.title, e.features[0].geometry.coordinates);
                        flyTowards(selectedProject.properties.cameraReset);
                        zoomLevelCheck(selectedProject.properties.cameraReset.zoom);
                        popup.remove();
                    }
                });
            }

            if (e.features[0].properties.activeStatus === "maquetteInDevelopment") {
                popupContent.classList.add("maquetteInDevelopment");
                popupTip.classList.add("maquetteInDevelopment");

                popupContent.classList.remove("activeMaquette");
                popupTip.classList.remove("activeMaquette");
            } else if (e.features[0].properties.activeStatus === "activeMaquette") {
                popupContent.classList.add("activeMaquette");
                popupTip.classList.add("activeMaquette");

                popupContent.classList.remove("maquetteInDevelopment");
                popupTip.classList.remove("maquetteInDevelopment");
            }
        });



        map.on('touchstart', 'PTProjects', (e) => {
            map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const description = e.features[0].properties.description;
            const touchedProject = e.features[0];
            // console.log(touchedProject);

            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            popup.setLngLat(coordinates)
                .setHTML(
                    `<h3>${e.features[0].properties.title}</h3>
                <img src="${e.features[0].properties.image}" class="popupImage"></img>
                <p><span class="boldPopUp">description:</span><span>${e.features[0].properties.description}</span></p>
                <button id="enterProjectButton-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="enterButton clickableButton">enter!</button>`
                )
                .addTo(map);

            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');

            const enterButton = document.getElementById(`enterProjectButton-${e.features[0].properties.title.replace(/\s+/g, '-')}`);

            if (enterButton) {
                enterButton.addEventListener('click', () => {
                    for (var l = 0; l < PublicTwinProjects.features.length; l++) {
                        if (PublicTwinProjects.features[l].properties.title == touchedProject.properties.title) {
                            selectedProject = PublicTwinProjects.features[l];
                        }
                    }


                    if (touchedProject.properties.activeStatus === "activeMaquette") {
                        handleButtonClick(touchedProject.properties.title, touchedProject.geometry.coordinates);
                        flyTowards(touchedProject.properties.cameraReset);
                        zoomLevelCheck(selectedProject.properties.cameraReset.zoom);
                        popup.remove();
                    }
                });
            }

            if (e.features[0].properties.activeStatus === "maquetteInDevelopment") {
                popupContent.classList.add("maquetteInDevelopment");
                popupTip.classList.add("maquetteInDevelopment");

                popupContent.classList.remove("activeMaquette");
                popupTip.classList.remove("activeMaquette");
            } else if (e.features[0].properties.activeStatus === "activeMaquette") {
                popupContent.classList.add("activeMaquette");
                popupTip.classList.add("activeMaquette");

                popupContent.classList.remove("maquetteInDevelopment");
                popupTip.classList.remove("maquetteInDevelopment");
            }
        });


        map.on('mouseleave', 'PTProjects', () => {
            map.getCanvas().style.cursor = '';
        });

        handleUrl();


    });
    // map on move functionality: => To be cleared up;
    map.on("mousemove", (e) => {


    });

    map.on("touchmove", (e) => {
        zoomLevel = map.getZoom();
        zoomLevelCheck();



    });
    map.on("move", function () {
    });
    map.on("wheel", (e) => {


        zoomLevel = map.getZoom();
        // console.log(zoomLevel);

        zoomLevelCheck()

    });

    // Detect when two fingers touch the map
    map.on('touchstart', function (e) {
        if (e.points.length === 2) {
            // Calculate the initial distance between two fingers
            const point1 = e.points[0];
            const point2 = e.points[1];
            initialDistance = calculateDistance(point1, point2);
        }
        if (e.points.length >= 2) {
            console.log("multitouch detected");
            multitouchDetected = true;
            raycast = false;
        } else {
            multitouchDetected = false;
        }
    });

    // Detect finger movement (pinching)
    map.on('touchmove', function (e) {
        if (e.points.length === 2 && initialDistance !== null) {
            // Calculate the current distance between two fingers
            const point1 = e.points[0];
            const point2 = e.points[1];
            const currentDistance = calculateDistance(point1, point2);

            // Determine if pinch zooming in or out
            if (currentDistance > initialDistance) {
                // console.log('Pinch zooming in');
                zoomLevel = map.getZoom();
                // console.log(zoomLevel);

                zoomLevelCheck()
                // alert("zooming in");
                // You can apply custom logic here or let Mapbox handle zooming
            } else {
                // console.log('Pinch zooming out');
                // console.log('Pinch zooming in');
                zoomLevel = map.getZoom();
                // console.log(zoomLevel);

                zoomLevelCheck()
                // alert("zooming out");
                // You can apply custom logic here or let Mapbox handle zooming
            }

            // Update the initial distance
            initialDistance = currentDistance;
        }
        if (e.points.length >= 2) {
            // console.log("multitouch detected");
            multitouchDetected = true;
            raycast = true;
        } else {
            multitouchDetected = false;
        }
        raycast = false;
    });

    // Clean up on touch end (reset initial distance)
    map.on('touchend', function (e) {
        if (e.points.length < 2) {
            initialDistance = null;
        }
        // if(symbolsEntered.length>=2){
        //     enteredSymbol=false;
        //     symbolsEntered=[];

        // }
        multitouchDetected = false;
        raycast = true;
    });


    map.on('touchstart', 'UrbanFutureReactionsLayer', (e) => {
        if (multitouchDetected == false && raycast == true) {
            popupReactions.remove();
            // map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const question = e.features[0].properties.question;
            selectedReaction = e.features[0].properties.title;


            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            // map.stop();

            const cameraZoom = {
                center: map.getCenter(),
                zoom: map.getZoom(),
                bearing: map.getBearing(),
                pitch: map.getPitch()
            };

            // map.stop();

            setTimeout(() => {
                map.flyTo({
                    center: coordinates,
                    zoom: cameraZoom.zoom,
                    pitch: cameraZoom.pitch,
                    bearing: cameraZoom.bearing,
                    essential: true,
                    duration: 1000,
                });
            }, 50);


            // rating

            popupReactions
                .setLngLat(coordinates)
                .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>${e.features[0].properties.comment}</h3>
                        </div>
                    `)
                .addTo(map);

            popupParticipateApp.remove();
            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');


            popupContent.classList.add("reactionsPopUp");
            popupTip.classList.add("reactionsPopUp");

            popupContent.classList.remove("ParticipateAppPopUp");
            popupTip.classList.remove("ParticipateAppPopUp");


            popupContent.classList.remove("Rating0");
            popupContent.classList.remove("Rating1");
            popupContent.classList.remove("Rating2");
            popupContent.classList.remove("Rating3");
            popupContent.classList.remove("Rating4");
            popupContent.classList.remove("Rating5");


            popupContent.classList.add(`Rating${e.features[0].properties.rating}`);
            // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

            popupContent.classList.remove("maquetteInDevelopment");
            popupTip.classList.remove("maquetteInDevelopment");
            popupContent.classList.remove("activeMaquette");
            popupTip.classList.remove("activeMaquette");
            popupContent.classList.remove("openQuestions");
            popupTip.classList.remove("openQuestions");
        }

    });

    map.on('touchstart', 'UrbanFutureCommentsLayer', (e) => {
        if (multitouchDetected == false && raycast == true) {
            popupReactions.remove();
            // map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const question = e.features[0].properties.question;
            selectedReaction = e.features[0].properties.title;


            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            // map.stop();

            const cameraZoom = {
                center: map.getCenter(),
                zoom: map.getZoom(),
                bearing: map.getBearing(),
                pitch: map.getPitch()
            };

            // map.stop();

            setTimeout(() => {
                map.flyTo({
                    center: coordinates,
                    zoom: cameraZoom.zoom,
                    pitch: cameraZoom.pitch,
                    bearing: cameraZoom.bearing,
                    essential: true,
                    duration: 1000,
                });
            }, 50);


            // rating

            popupReactions
                .setLngLat(coordinates)
                .setHTML(`
                            <div class="questionTitleDiv">
                                <span class="questionTitleSpan">${e.features[0].properties.selected_comment_question}</span>
                            </div>
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
                .addTo(map);

            popupParticipateApp.remove();
            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');


            popupContent.classList.add("reactionsPopUp");
            popupTip.classList.add("reactionsPopUp");

            popupContent.classList.remove("ParticipateAppPopUp");
            popupTip.classList.remove("ParticipateAppPopUp");


            popupContent.classList.remove("Rating0");
            popupContent.classList.remove("Rating1");
            popupContent.classList.remove("Rating2");
            popupContent.classList.remove("Rating3");
            popupContent.classList.remove("Rating4");
            popupContent.classList.remove("Rating5");


            popupContent.classList.add(`Rating0`);
            // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

            popupContent.classList.remove("maquetteInDevelopment");
            popupTip.classList.remove("maquetteInDevelopment");
            popupContent.classList.remove("activeMaquette");
            popupTip.classList.remove("activeMaquette");
            popupContent.classList.remove("openQuestions");
            popupTip.classList.remove("openQuestions");
        }

    });

    map.on('touchstart', 'UrbanFuturePhotosLayer', (e) => {
        if (multitouchDetected == false && raycast == true) {
            popupReactions.remove();
            // map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const question = e.features[0].properties.question;
            selectedReaction = e.features[0].properties.title;


            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            // map.stop();

            const cameraZoom = {
                center: map.getCenter(),
                zoom: map.getZoom(),
                bearing: map.getBearing(),
                pitch: map.getPitch()
            };

            // map.stop();

            setTimeout(() => {
                map.flyTo({
                    center: coordinates,
                    zoom: cameraZoom.zoom,
                    pitch: cameraZoom.pitch,
                    bearing: cameraZoom.bearing,
                    essential: true,
                    duration: 1000,
                });
            }, 50);


            // rating

            popupReactions
                .setLngLat(coordinates)
                .setHTML(`
                            <div class="popupImageDivUF">
                                    <img src=${e.features[0].properties.httpadress} class="popupImageUF"/>
                            </div>
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
                .addTo(map);

            popupParticipateApp.remove();
            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');


            popupContent.classList.add("reactionsPopUp");
            popupTip.classList.add("reactionsPopUp");

            popupContent.classList.remove("ParticipateAppPopUp");
            popupTip.classList.remove("ParticipateAppPopUp");


            popupContent.classList.remove("Rating0");
            popupContent.classList.remove("Rating1");
            popupContent.classList.remove("Rating2");
            popupContent.classList.remove("Rating3");
            popupContent.classList.remove("Rating4");
            popupContent.classList.remove("Rating5");


            popupContent.classList.add(`Rating0`);
            // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

            popupContent.classList.remove("maquetteInDevelopment");
            popupTip.classList.remove("maquetteInDevelopment");
            popupContent.classList.remove("activeMaquette");
            popupTip.classList.remove("activeMaquette");
            popupContent.classList.remove("openQuestions");
            popupTip.classList.remove("openQuestions");
        }

    });

    map.on('touchstart', (e) => {
        if (multitouchDetected == false && raycast == true) {
            const possibleLayers = [
                'UrbanFutureReactionsLayer',
                'UrbanFutureCommentsLayer',
                'UrbanFuturePhotosLayer'
            ];

            // Only include layers that are currently on the map
            const layersToCheck = possibleLayers.filter(layerID => map.getLayer(layerID));

            if (!layersToCheck.length) return; // no active layers to check

            const features = map.queryRenderedFeatures(e.point, {
                layers: layersToCheck
            });

            if (!features.length) {
                popupReactions.remove(); // Or handle safely if popupReactions may be undefined
            }
        }
    });




    map.on('click', 'UrbanFutureReactionsLayer', (e) => {
        popupReactions.remove();
        // map.getCanvas().style.cursor = 'pointer';

        // selectedProject = e.features[0];
        const coordinates = e.features[0].geometry.coordinates.slice();
        const question = e.features[0].properties.question;
        selectedReaction = e.features[0].properties.title;


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }
        const cameraZoom = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch()
        };

        // map.stop();

        setTimeout(() => {
            map.flyTo({
                center: coordinates,
                zoom: cameraZoom.zoom,
                pitch: cameraZoom.pitch,
                bearing: cameraZoom.bearing,
                essential: true,
                duration: 1000,
            });
        }, 50);


        // rating

        popupReactions
            .setLngLat(coordinates)
            .setHTML(`
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
            .addTo(map);

        popupParticipateApp.remove();
        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');


        popupContent.classList.add("reactionsPopUp");
        popupTip.classList.add("reactionsPopUp");

        popupContent.classList.remove("ParticipateAppPopUp");
        popupTip.classList.remove("ParticipateAppPopUp");


        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");


        popupContent.classList.add(`Rating${e.features[0].properties.rating}`);
        // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");


    });
    map.on('mouseenter', 'UrbanFutureReactionsLayer', () => {
        map.getCanvas().style.cursor = 'pointer';
    });

    map.on('click', 'UrbanFutureCommentsLayer', (e) => {

        popupReactions.remove();
        // map.getCanvas().style.cursor = 'pointer';

        // selectedProject = e.features[0];
        const coordinates = e.features[0].geometry.coordinates.slice();
        const question = e.features[0].properties.question;
        selectedReaction = e.features[0].properties.title;


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }

        const cameraZoom = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch()
        };

        // map.stop();

        setTimeout(() => {
            map.flyTo({
                center: coordinates,
                zoom: cameraZoom.zoom,
                pitch: cameraZoom.pitch,
                bearing: cameraZoom.bearing,
                essential: true,
                duration: 1000,
            });
        }, 50);


        // rating

        popupReactions
            .setLngLat(coordinates)
            .setHTML(`
                            <div class="questionTitleDiv">
                                <span class="questionTitleSpan">${e.features[0].properties.selected_comment_question}</span>
                            </div>
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
            .addTo(map);

        popupParticipateApp.remove();
        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');


        popupContent.classList.add("reactionsPopUp");
        popupTip.classList.add("reactionsPopUp");

        popupContent.classList.remove("ParticipateAppPopUp");
        popupTip.classList.remove("ParticipateAppPopUp");


        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");


        popupContent.classList.add(`Rating0`);
        // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");


    });
    map.on('mouseenter', 'UrbanFutureCommentsLayer', () => {
        map.getCanvas().style.cursor = 'pointer';
    });

    map.on('click', 'UrbanFuturePhotosLayer', (e) => {

        popupReactions.remove();
        // map.getCanvas().style.cursor = 'pointer';

        // selectedProject = e.features[0];
        const coordinates = e.features[0].geometry.coordinates.slice();
        const question = e.features[0].properties.question;
        selectedReaction = e.features[0].properties.title;


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }

        const cameraZoom = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch()
        };

        // map.stop();

        setTimeout(() => {
            map.flyTo({
                center: coordinates,
                zoom: cameraZoom.zoom,
                pitch: cameraZoom.pitch,
                bearing: cameraZoom.bearing,
                essential: true,
                duration: 1000,
            });
        }, 50);


        // rating

        popupReactions
            .setLngLat(coordinates)
            .setHTML(`
                            <div class="popupImageDivUF">
                                    <img src=${e.features[0].properties.httpadress} class="popupImageUF"/>
                            </div>
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
            .addTo(map);

        popupParticipateApp.remove();
        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');


        popupContent.classList.add("reactionsPopUp");
        popupTip.classList.add("reactionsPopUp");

        popupContent.classList.remove("ParticipateAppPopUp");
        popupTip.classList.remove("ParticipateAppPopUp");


        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");


        popupContent.classList.add(`Rating0`);
        // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");


    });
    map.on('mouseenter', 'UrbanFuturePhotosLayer', () => {
        map.getCanvas().style.cursor = 'pointer';
    });


    map.on('click', (e) => {
        let cameraPosition = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch()
        };
        console.log("cameraPosition", cameraPosition);

        const possibleLayers = [
            'UrbanFutureReactionsLayer',
            'UrbanFutureCommentsLayer',
            'UrbanFuturePhotosLayer'
        ];

        // Only include layers that are currently on the map
        const layersToCheck = possibleLayers.filter(layerID => map.getLayer(layerID));

        if (!layersToCheck.length) return; // no active layers to check

        const features = map.queryRenderedFeatures(e.point, {
            layers: layersToCheck
        });

        if (!features.length) {
            popupReactions.remove(); // Or handle safely if popupReactions may be undefined
        }
    });
}


const ENGAGEMENT_SELECTED_COLOR = '#003d92';
const ENGAGEMENT_CONTAINER_SEL = '#EngagementOptions';
const OPTION_SEL = '.EngagementOptionButtons';
const ICON_SEL = '.EngagementOptionIcon';
const LABEL_SEL = '.EngagementOptionText';

const ENGAGEMENT_ACTIONS = {
    // by label text (fallbacks, case-insensitive)
    informacje: () => { try { iniciateInform(); } catch (_) { } },
    partycypacja: () => { try { iniciateParticipate(); } catch (_) { } },
    rezultaty: () => { try { iniciateResults(); } catch (_) { } },
};



function stripActiveSuffix(src) {

    return src.replace(/Active(?=\.svg(\?.*)?$)/, '');
}

function withActiveSuffix(src, isActive) {
    const base = stripActiveSuffix(src);
    if (!isActive) return base;
    // insert "Active" right before the .svg extension, keep any query string
    return base.replace(/(\.svg)(\?.*)?$/, 'Active$1$2');
}


function applyEngagementOptionStyles() {
    const container = document.querySelector(ENGAGEMENT_CONTAINER_SEL);
    if (!container) return;
    const options = container.querySelectorAll(OPTION_SEL);

    options.forEach(opt => {
        const isSelected = (opt.getAttribute('selected') === 'true');
        const img = opt.querySelector(ICON_SEL);
        const label = opt.querySelector(LABEL_SEL);

        // Text color
        if (label) {
            label.style.color = isSelected ? ENGAGEMENT_SELECTED_COLOR : '';
        }

        // Icon swap
        if (img && img.src) {
            img.src = withActiveSuffix(img.src, isSelected);
            // Optional: set alt for accessibility
            if (!img.alt) {
                const txt = label ? label.textContent.trim() : '';
                img.alt = isSelected ? `${txt} (selected)` : txt;
            }
        }

        // Accessibility niceties
        opt.setAttribute('aria-selected', String(isSelected));
        opt.classList.toggle('is-selected', isSelected);
    });
}


function initEngagementOptionsInteractions() {
    if (window.__engagementOptionsBound) return; // avoid double-binding
    const container = document.querySelector(ENGAGEMENT_CONTAINER_SEL);
    if (!container) return;
    const options = Array.from(container.querySelectorAll(OPTION_SEL));
    if (!options.length) return;

    // Make the options behave like radio buttons
    options.forEach(opt => {
        opt.setAttribute('role', 'tab'); // semantics, optional
        opt.addEventListener('click', () => {
            options.forEach(o => o.setAttribute('selected', o === opt ? 'true' : 'false'));
            applyEngagementOptionStyles();
            runSelectedEngagementAction();
        }, { passive: true });
    });

    // Mark container as a tablist for a11y (optional)
    container.setAttribute('role', 'tablist');

    window.__engagementOptionsBound = true;
}

function runSelectedEngagementAction() {
    const selected = getSelectedEngagementOption();
    if (!selected) return;

    // Prefer ID mapping
    const id = selected.id && String(selected.id).trim();
    if (id && ENGAGEMENT_ACTIONS[id]) {
        ENGAGEMENT_ACTIONS[id]();
        return;
    }

    // Fallback: use the visible label text
    const label = selected.querySelector(LABEL_SEL);
    const key = label ? label.textContent.trim().toLowerCase() : '';
    if (key && ENGAGEMENT_ACTIONS[key]) {
        ENGAGEMENT_ACTIONS[key]();
    }
}
function getSelectedEngagementOption() {
    const container = document.querySelector(ENGAGEMENT_CONTAINER_SEL);
    if (!container) return null;
    return container.querySelector(`${OPTION_SEL}[selected="true"]`) || null;
}
function resetEngagementOptions() {
    document.getElementById("EngagementOptionsInform").setAttribute('selected', 'false');
    document.getElementById("EngagementOptionsParticipate").setAttribute('selected', 'true');
    document.getElementById("EngagementOptionsResults").setAttribute('selected', 'false');
}


const ResultsMenuClose = document.getElementById('ResultsMenuClose');
const InformMenuClose = document.getElementById('InformMenuClose');

ResultsMenuClose.addEventListener('click', () => {
    document.getElementById("EngagementOptionsParticipate").click();
});
InformMenuClose.addEventListener('click', () => {
    document.getElementById("EngagementOptionsParticipate").click();
});

// Engagement actions functions:
function iniciateInform() {
    console.log("Inform action initiated");
    if (UrbanFutureSelectOptionsMenuOpen) {
        UrbanFutureTopNavbarSelectOptions.click();
    }
    document.getElementById("ParticipateMenuWrapper").classList.add("UrbanFutureDisplayNone");
    document.getElementById("ResultsMenu").classList.add("UrbanFutureDisplayNone");
    while (document.getElementById("InformAndResultsMenuWrapper").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("InformAndResultsMenuWrapper").classList.remove("UrbanFutureDisplayNone")
    }
    while (document.getElementById("InformMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("InformMenu").classList.remove("UrbanFutureDisplayNone")
    }

    enterInstruction("viaInform");
}

function iniciateParticipate() {
    // your existing camera/UI work
    flyTowards(cameraStartOverview);
    zoomLevelCheck(cameraStartOverview.zoom);
    document.getElementById("InformAndResultsMenuWrapper").classList.add("UrbanFutureDisplayNone");
    document.getElementById("InformMenu").classList.add("UrbanFutureDisplayNone");
    document.getElementById("ResultsMenu").classList.remove("UrbanFutureDisplayNone");

    // NEW: clear any current zone selection/hover
    if (typeof zonesClearSelection === 'function') zonesClearSelection();
    if (typeof zonesClearHover === 'function') zonesClearHover();

    // NEW: make all zones appear as if they were hovered
    setAllZonesHoverVisual(true);

    // NEW: show a hint toast (auto-hides after 10s; click to dismiss)
    showParticipateHintToast(
        'kliknij w którąś ze <span>stref</span> w aktywnej <span>konfiguracji</span> aby zostawić opinię lub dodać polubienie!',
        { duration: 10000 }
    );

    console.log("Participate action initiated");
}

function iniciateResults() {
    if (UrbanFutureSelectOptionsMenuOpen) {
        UrbanFutureTopNavbarSelectOptions.click();
    }
    console.log("Results action initiated");
    document.getElementById("InformMenu").classList.add("UrbanFutureDisplayNone");
    document.getElementById("ParticipateMenuWrapper").classList.add("UrbanFutureDisplayNone");

    document.getElementById("InformAndResultsMenuWrapper").classList.remove("UrbanFutureDisplayNone");
    document.getElementById("ResultsMenu").classList.remove("UrbanFutureDisplayNone");
}



document.addEventListener('DOMContentLoaded', () => {

    initEngagementOptionsInteractions();


    if (typeof UrbanFutureStartExperienceButton !== 'undefined' && UrbanFutureStartExperienceButton) {
        UrbanFutureStartExperienceButton.addEventListener('click', function () {

            resetEngagementOptions();
            applyEngagementOptionStyles();
            runSelectedEngagementAction();

        }, true);
    }
});





// POPUP DEFINITIONS:

const participatePopup = new mapboxgl.Popup({
    offset: 25,
    closeOnClick: false

});
const popup = new mapboxgl.Popup({
    offset: 25,
    closeOnClick: false

});
const popupQuestions = new mapboxgl.Popup({
    offset: 25,
    closeOnClick: false,
    closeButton: false,

});
const popupReactions = new mapboxgl.Popup({
    offset: 25,
    closeOnClick: false,
    closeButton: false,

});
const popupParticipateApp = new mapboxgl.Popup({
    offset: 40,
    closeOnClick: false,
    closeButton: false,

});




var PublicTwinProjects = {
    'type': 'FeatureCollection',
    'features': [

        {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': pojectCameraStart,

            },
            'properties': {
                'title': 'Plac Krakowski',
                'projectCode': "2025_3_NL_RR_M4H",
                "permissions": "public",
                "image": "https://publictwin.info/PlacKrakowski/res/icons/PlacKrawkoskiIcon_Main.png",
                'icon': 'logo1',
                'description': 'Etap II konsulatacji w sprawie przyszłości Placu Krakowskiego.',
                "descriptionLong": ".",
                'location': 'Gliwice, Polska',
                'status': 'active',
                'activeStatus': 'activeMaquette',
                'digitalTwin': "none",
                'digitalTwinLink': "-",
                "advancedSelection": "false",
                "projectSelected": "false",
                "participatoryModuleActive": true,
                "modelID": "-",
                "origin": projectCenter,
                "cameraReset": {
                    center: pojectCameraStart,
                    zoom: isMobileDevice() ? START_ZOOM_MOBILE : START_ZOOM_DESKTOP,
                    bearing: 101.47391590634993,
                    pitch: 60.49959898565759
                },
                "participatoryActions": {
                    'type': 'FeatureCollection',
                    'features': [
                        {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'Point',
                                'coordinetes': [18.6732, 50.2916]
                                //   'coordinates': [19.4513, 51.7788],
                                //   'coordinates': [18.651,50.291],
                            },
                            'properties': {
                                'title': 'M4H Westerhaven',
                                "image": "https://publictwin.info/M4HRotterdam/content/Images/M4HRotterdam_Main.png",
                                'icon': 'participate',
                                'description': 'Hybrid participation workshop, creating visions for the future of Rotterdam.',
                                'location': 'Rotterdam, Netherlands',
                                'status': 'active',
                                'openTill': '31.12.2025',
                                "participatoryForm": "https://eoxsnlhinp7.typeform.com/to/bT4Az155",
                                "qrCode": "https://publictwin.info/digital_maquette/content/Urban_Future/Participation/Urban_Future_General_Form.png",
                                // "center":[18.651,50.291],
                                'center': [18.6732, 50.2916],
                                // 'center': [19.4513, 51.7788],
                                "zoom": 14.5,
                                "bearing": -22.396,
                                "pitch": 62.361

                            },
                        },
                    ],
                },
            }
        },

    ]
}





window.onload = function () {
    const urlParams = new URLSearchParams(window.location.search);
    let resetToken = urlParams.get('token');
    let activeProjectValue = urlParams.get('activeProject');
    checkLoadedOrigin();

    console.log(resetToken);
    console.log(activeProjectValue);

    if (resetToken && activeProjectValue) {

        if (activeProjectValue == "Plac Krakowski") {
            document.getElementById('tokenUF').value = resetToken;
            console.log("entering plac Krakowski via password-reset link");
            // Starting with resetToken - allowing for password change:

            // alert(`ID: ${sessionUserID}\nGender: ${sessionUserGender}\nAge: ${sessionUserAge}\nRelation: ${sessionUserRelation}\nEmail: ${sessionUserEmail}\nRole: ${sessionUserRole}`);

            //SETTING UP THE CORRECT STYLES AND VIEW:



            map.once('load', function () {
                const currentStyle = map.getStyle();
                if (currentStyle.sprite && !currentStyle.sprite.includes('cmantxs6m01ii01skcbe76l1u')) {
                    map.setStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u');

                    map.once('style.load', function () {
                        urbanFutureAddProjectElements();
                        urbanFutureMoveLayersToFront();
                    });
                } else {
                }
            });




            // do it only once in a session logic needs to be implemneted:
            if (sessionStorage.getItem('introOpenedOnce') == "false") {
                showElement(document.getElementById("FunctionalitiesIntroMenu"));
                sessionStorage.setItem('introOpenedOnce', "true");
                setTimeout(() => {
                    document.getElementById("FunctionalitiesIntroMenuContinue").click();
                }, 15000);
            }
            else {

            }


            if (locationTypeAction == "PinBased") {
                let cameraMoveTo = cameraStartOverview;
                flyTowards(cameraMoveTo);

            } else {
                UpdateLocationToUser();

            }

            // zoomLevelCheck(cameraMoveTo.zoom);


            console.log("hidding the main menu:");
            document.getElementById("UserMenuUrbanFuture").style.display = "none";
            document.getElementById("UserMenuUrbanFuture").style.visibility = "hidden";

            // document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")



            document.getElementById("StartIncompleteMessage").innerHTML = "";


            // hidding login menu on project start - as a double check:
            document.getElementById("closeMediaGalleryImage").style.display = "none";
            document.getElementById("loginMenu").style.display = "none";
            document.getElementById("mainMenuWrapper").style.display = "none";
            document.getElementById("mainMenuMasterplanWrapper").style.display = "none";

            startParticipationUrbanFuture();


            console.log("hidding the login menu");
            // Showing the password reset menu:
            hideElement(document.getElementById("FunctionalitiesIntroMenu"));
            showElement(document.getElementById("UserLoginMenuUrbanFuture"));

            toggleRemindTokenFunctionUF();

        }
    } else if (resetToken) {
        // Show the password reset form and set the token value
        // to ensure that password reset is shown on link click:
        document.getElementById("UrbanFutureLoginButton").click();

        // document.getElementById('passwordResetDiv').style.display = 'block';
        document.getElementById('tokenUF').value = resetToken;

        menuSignUpDiv.style.display = 'none';
        menuLogInDiv.style.display = 'none';
        passwordResetRequestDiv.style.display = 'none';
    }

};

function checkLoadedOrigin() {
    if (window.self !== window.top) {


        let url = window.location.href;

        // Create a URL object
        let urlObj = new URL(url);

        // Use URLSearchParams to extract the value
        let params = new URLSearchParams(urlObj.search);

        // Retrieve the value of the parameter
        let activeProjectValue = params.get('activeProject');

        // Iniciate project start sequence:

        if (map.getStyle().sprite && !map.getStyle().sprite.includes('cmantxs6m01ii01skcbe76l1u')) {
            map.setStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u');


            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        } else {
            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        }

        // sessionStorage.setItem('introOpenedOnce', "true");

        // document.getElementById("UrbanFutureIntroduceCloseButton").classList.remove("UrbanFutureDisplayNone");

        // document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone");
        // document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone");
        // document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")

        // document.getElementById("StartIncompleteMessage").innerHTML = "";

        // startParticipationUrbanFuture();


    } else {
    }


}

function setPinsVisibility(show) {
    const pins = window.__participationPins?.pins || [];
    const display = show ? 'flex' : 'none'; // your .camera-pin uses flex
    for (const p of pins) {
        const wrap = p?.wrap; // <-- wrapper that contains button + badge
        if (!wrap) continue;

        wrap.style.display = display;
        wrap.setAttribute("aria-hidden", String(!show));
        // be extra safe: when hidden, don’t allow any interactions
        wrap.style.pointerEvents = show ? "auto" : "none";
    }

    const pinsPhotos = window.__photoPins?.pins || [];
    const displayPhotos = show ? 'flex' : 'none'; // your .camera-pin uses flex
    for (const p of pinsPhotos) {
        if (p?.el) {
            p.el.style.display = displayPhotos;
            p.el.setAttribute('aria-hidden', String(!show));
        }
    }




}


function zoomLevelCheck(targetZoomLevel) {



    let functionZoomLevel = null;
    if (targetZoomLevel) {
        functionZoomLevel = targetZoomLevel;
        console.log("target zoom", functionZoomLevel)
    } else {
        functionZoomLevel = map.getZoom();
        // console.log("no target zoom provided:", functionZoomLevel);
    }


    setPinsVisibility(functionZoomLevel >= zoomLevelThreshold);

    if (functionZoomLevel < zoomLevelThreshold) {

        if (map.getLayer("PTProjects")) {
            map.setLayoutProperty("PTProjects", 'visibility', 'visible');
        }
    }
    else {

        if (map.getLayer("PTProjects")) {
            map.setLayoutProperty("PTProjects", 'visibility', 'none');
        }
        popup.remove();
    }

    update3DVisibilityForZoom(functionZoomLevel);
    applyZoomVisibilityTo3DUI(functionZoomLevel >= zoomLevelThreshold);


}


// mouse position vector:
const mouse = new THREE.Vector2();

// window sizes parameters:
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
const cameraStart = {
    zoom: 16,
    center: [4.358780, 52.00236828785361],
    pitch: 60,
    bearing: 35,

};






function handleUrl() {
    // URL analysis functionality:
    let url = window.location.href;

    // Create a URL object
    let urlObj = new URL(url);

    // Use URLSearchParams to extract the value
    let params = new URLSearchParams(urlObj.search);

    // Retrieve the value of the parameter
    let activeProjectValue = params.get('activeProject');


    if (activeProjectValue !== null) {
        // alert(`The value of myVariable is: ${activeProjectValue}`);

        if (activeProjectValue == "Plac Krakowski") {

            if (window.innerWidth <= 768) {
                document.getElementById("OnlyMobileAction").classList.add("OnlyMobileActionHidden")
                while (document.getElementById("OnlyMobileAction").classList.contains("OnlyMobileActionVisible")) {
                    document.getElementById("OnlyMobileAction").classList.remove("OnlyMobileActionVisible");
                }

            } else {
                // console.log("set only mobile visible")

                // Changing for desktop-based-action:
                // document.getElementById("OnlyMobileAction").classList.add("OnlyMobileActionVisible")
                // while(document.getElementById("OnlyMobileAction").classList.contains("OnlyMobileActionHidden")){
                //     document.getElementById("OnlyMobileAction").classList.remove("OnlyMobileActionHidden");
                // }

            }
            // document.documentElement.requestFullscreen();

            // document.getElementById("UserMenuUrbanFuture").style.display="none";
            // document.getElementById("UserMenuUrbanFuture").style.visibility="hidden";
        }
        else {

            // comment for now:
            // document.getElementById("UserMenuUrbanFuture").style.display="none";
            // document.getElementById("UserMenuUrbanFuture").style.visibility="hidden";
        }

        URLBasedProject = activeProjectValue;

        for (var i = 0; i < PublicTwinProjects.features.length; i++) {

            // console.log("publicTwin projects:",PublicTwinProjects.features);

            if (PublicTwinProjects.features[i].properties.title == activeProjectValue) {
                selectedProject = PublicTwinProjects.features[i];
                // console.log("project selected via URL:", selectedProject);
                handleButtonClick(selectedProject.properties.title, selectedProject.geometry.coordinates);
            }
            else {
                // console.log("no project match");
            }

        };

    } else {
        // comment for now will add later:
        // alert('activeProject is not present in the URL');
        // document.getElementById("UserMenuUrbanFuture").style.display="none";
        // document.getElementById("UserMenuUrbanFuture").style.visibility="hidden";
    }



};

function handleButtonClick(title, coordinates, popup) {

    if (selectedProject.properties.status == "active") {



        if (selectedProject.properties.title == "Plac Krakowski") {
            // original mapbox standard style:
            // map.setStyle('mapbox://styles/mapbox/standard');

            // updated and cleaned:
            let isMobile = window.innerWidth <= 768; // Define your mobile breakpoint

            if (isMobile) {

            }

            if (window.self !== window.top) {
                if (map.getStyle().sprite && !map.getStyle().sprite.includes('cmantxs6m01ii01skcbe76l1u')) {
                    map.setStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u');
                }

                map.once('style.load', function () {
                    urbanFutureAddProjectElements();
                });
            } else {

            }



            activeModel = "Plac Krakowski";

            let cameraMoveTo = cameraStartOverview

            flyTowards(cameraMoveTo);

            enterProject(title);
            zoomLevelCheck(cameraMoveTo.zoom);

            // console.log(layers);
            try {
                checkOrder();
            } catch {

            }


            window.addEventListener("load", function () {
                setTimeout(function () {
                    window.scrollTo(0, 1); // Scroll 1px to trigger URL bar hide
                }, 0);
            });

        }

    }
    else {
        accessStatus.innerHTML = "projects is not active!"
    }


}

function enterProject(title) {

    popup.remove();

}




// Utility function to calculate the distance between two touch points
function calculateDistance(point1, point2) {
    const dx = point1.x - point2.x;
    const dy = point1.y - point2.y;
    return Math.sqrt(dx * dx + dy * dy);
}



//camera adjustments:

function flyTowards(target) {

    const isMobile = window.innerWidth <= 768; // Define your mobile breakpoint

    if (isMobile) {
        const isLowEndDevice = () => {
            return navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4;
        };

        if (!isLowEndDevice()) {
            // console.log("on mobile")
            map.easeTo({
                ...target,
                duration: 1000, // Smooth easing with shorter duration
                essential: true
            });

        } else {
            // console.log("on mobile, low-end")
            map.jumpTo(target); // Instant transition for low-end devices
        }


    } else {
        // console.log("not on mobile")
        map.flyTo({
            ...target,
            duration: 2000,
            essential: true,
        });
    }

    setTimeout(() => {
        map.setMaxBounds(bounds);
    }, 2000);


    // map.flyTo({
    //     ...target,
    //     duration:2000,
    //     essential: true,
    //     animate:true,
    // }



}




function checkLoginStatus(fromIframe = false, iframeData = {}) {
    fetch('https://publictwin.info/digital_maquette/php_scripts/check_login_status.php', {
        method: 'GET',
        credentials: 'include',   // <= important
    })
        .then(response => response.json())
        .then(data => {

            // URL verification to check what needs to happen afeter the user loggs in correctly:

            let url = window.location.href;

            // Create a URL object
            let urlObj = new URL(url);

            // Use URLSearchParams to extract the value
            let params = new URLSearchParams(urlObj.search);

            // Retrieve the value of the parameter
            let activeProjectValue = params.get('activeProject');
            console.log(activeProjectValue)




            if (data.isLoggedIn) {
                // document.getElementById("UrbanFutureTopNavbarSelectOptions").click();
                ReadyToStartViaLogin = true;
                document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#003d92";
                document.getElementById("UrbanFutureStartExperienceButton").classList.add("override-color");
                document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
                document.getElementById("StartIncompleteMessage").innerHTML = "";

                document.getElementById("UrbanFutureLoginButton").setAttribute("loggedInStatus", "true");
                document.getElementById("UrbanFutureLoginButton").innerHTML = `<img class="CheckboxMainMenuIcon"
                                src="https://publictwin.info/HavenparkGroningen/content/Icons/UnlockIcon.svg" />
                            <span>panel użytkownika!</span>`;

                document.getElementById("userEmailUF").innerText = data.email;
                document.getElementById("userRoleUF").innerText = data.user_role;
                document.getElementById("userPermissionsUF").innerText = data.user_permissions;

                sessionStorage.setItem('loginUserID', data.user_id);

                userPermissionsStatus = data.user_permissions;
                userProjectPermissionsStatus = data.project_permissions;

                if (userPermissionsStatus == "KOM" || userPermissionsStatus == "admin" || userProjectPermissionsStatus.includes("PKrak")) {
                    showElement(document.getElementById("AnalyticsTriggerButton"));
                }
                document.getElementById("UrbanFutureLoginBack").click();


            } else {
                ReadyToStartViaLogin = false;
                if (ReadyToStart == false) {
                    document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#616161";
                    document.getElementById("UrbanFutureStartExperienceButton").classList.remove("override-color");
                }

                document.getElementById("UrbanFutureLoginButton").setAttribute("loggedInStatus", "false");
                document.getElementById("UrbanFutureLoginButton").innerHTML = `<img class="CheckboxMainMenuIcon"
                                src="https://publictwin.info/HavenparkGroningen/content/Icons/LockIcon.svg" />
                            <span>zaloguj się!</span>`;
                sessionStorage.setItem('loginUserID', "-");

                hideElement(document.getElementById("AnalyticsTriggerButton"));
                hideElement(document.getElementById("reactionsFilteringSystem"));


            }

            if (fromIframe == true) {
                console.log("checking login status via iframe")
                if (iframeData.isLoggedIn == "true") {
                    ReadyToStartViaLogin = true;
                    document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#003d92";
                    document.getElementById("UrbanFutureStartExperienceButton").classList.add("override-color");
                    document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
                    document.getElementById("StartIncompleteMessage").innerHTML = "";
                    // console.log(iframeData);
                    // document.getElementById("UrbanFutureTopNavbarSelectOptions").click();

                    document.getElementById("UrbanFutureLoginButton").setAttribute("loggedInStatus", "true");

                    document.getElementById("userEmailUF").innerText = iframeData.email;
                    document.getElementById("userRoleUF").innerText = iframeData.user_role;
                    document.getElementById("userPermissionsUF").innerText = iframeData.user_permissions;

                    sessionStorage.setItem('loginUserID', iframeData.user_id);

                    userPermissionsStatus = iframeData.user_permissions;
                    userProjectPermissionsStatus = iframeData.project_permissions;

                    document.getElementById("UrbanFutureLoginButton").innerHTML = `<img class="CheckboxMainMenuIcon"
                                src="https://publictwin.info/HavenparkGroningen/content/Icons/UnlockIcon.svg" />
                            <span>panel użytkownika!</span>`;

                    if (userPermissionsStatus == "KOM" || userPermissionsStatus == "admin" || userProjectPermissionsStatus.includes("PKrak")) {
                        showElement(document.getElementById("AnalyticsTriggerButton"));
                    }

                }
                else {
                    ReadyToStartViaLogin = false;
                    if (ReadyToStart == false) {
                        document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#616161";
                        document.getElementById("UrbanFutureStartExperienceButton").classList.remove("override-color");
                    }

                    document.getElementById("UrbanFutureLoginButton").setAttribute("loggedInStatus", "false");
                    sessionStorage.setItem('loginUserID', "-");
                    document.getElementById("UrbanFutureLoginButton").innerHTML = `<img class="CheckboxMainMenuIcon"
                                src="https://publictwin.info/HavenparkGroningen/content/Icons/LockIcon.svg" />
                            <span>login!</span>`;

                    hideElement(document.getElementById("AnalyticsTriggerButton"));
                }

            } else {

            }




        })
        .catch(error => console.error('Error:', error));
}




var PinQuestions = {
    'type': 'FeatureCollection',
    'features': [
    ]
}






// let introOpenedOnce = "false";
if (!sessionStorage.getItem('introOpenedOnce')) {
    sessionStorage.setItem("introOpenedOnce", "false");
}

let locationTypeAction = "PinBased";
let modelTypeSelection = "3Dmodel";
let cameraFunctionActive = false;
locationTypeAction = "PinBased";
if (locationTypeAction == "PinBased") {
    document.getElementById("UFParticipationIcon").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CameraIconGrey.png";
    document.getElementById("UrbanFutureParticipationPhotoCoinIcon").style.display = "none";
    cameraFunctionActive = false;
}
let locationTypeActionNew = "";

let sessionIntroduceComplete = null;
let sessionRoleComplete = null;
let sessionSurveyComplete = null;
let sessionLocationComplete = null;
let lastKnownUserCoords = null;

let sessionUserGender = null;
let sessionUserAge = null;
let sessionUserRelation = null;
let sessionUserRelationBusiness = null;
let sessionUserEmail = "";
let introduceReadyToSave = false;
let ReadyToStart = false;
let roleReadyToSave = false;
let sessionUserRole = null;
let sessionPTCoins = 0;
let UrbanFutureSelectOptionsMenuOpen = false;
let slectedReactionValue = 0;
let slectedReactionComment = "-";
let slectedCommentQuestion = "-"
let dataToSubmit = {};
let capturedState = false;
let openMenu = "";
let selectedQuestion = "";
let selectedReaction = "";

let locatingEnabled = false;
let QuestionImagesLoaded = 0;

document.getElementById("CameraSubmitButton").style.backgroundColor = "#d0af2d";

// to be defined based on user - if logged in should be different than if not:
sessionStorage.setItem('userRole', "partycypacyjny nowicjusz");
sessionUserRole = sessionStorage.getItem('userRole');
document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

const PlacKrakowskiDropPinMarker = new mapboxgl.Marker({
    draggable: true,
    color: "#003d92",
})



const introduceCheckbox = document.getElementById('introduceCheckbox');


if (!sessionStorage.getItem('userPTCoins')) {
    sessionStorage.setItem('userPTCoins', 0);
    sessionPTCoins = parseInt(sessionStorage.getItem('userPTCoins'));
} else {
    sessionPTCoins = parseInt(sessionStorage.getItem('userPTCoins'));
}

function checkCoinsRole() {
    if (sessionStorage.getItem('userPTCoins')) {
        if (parseInt(sessionStorage.getItem('userPTCoins')) >= 1000) {
            sessionStorage.setItem('userRole', "lokalny wizjoner");
            sessionUserRole = sessionStorage.getItem('userRole');
            document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

        } else if (parseInt(sessionStorage.getItem('userPTCoins')) < 1000 && parseInt(sessionStorage.getItem('userPTCoins')) >= 300) {
            sessionStorage.setItem('userRole', "kurator przestrzeni");
            sessionUserRole = sessionStorage.getItem('userRole');
            document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

        } else if (parseInt(sessionStorage.getItem('userPTCoins')) < 300 && parseInt(sessionStorage.getItem('userPTCoins')) >= 150) {
            sessionStorage.setItem('userRole', "miejski tropiciel");
            sessionUserRole = sessionStorage.getItem('userRole');
            document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

        } else {
            sessionStorage.setItem('userRole', "partycypacyjny nowicjusz");
            sessionUserRole = sessionStorage.getItem('userRole');
            document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

        }

    }
}

document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');

sessionIntroduceComplete = sessionStorage.getItem('IntroduceComplete');
sessionSurveyComplete = sessionStorage.getItem('SurveyComplete');
sessionLocationComplete = sessionStorage.getItem('LocationComplete');

checkSessionAndBoxes();

// Main menu buttons:

let UrbanFutureIntroduceButton = document.getElementById("UrbanFutureIntroduceButton")
let UrbanFutureInstructionButton = document.getElementById("UrbanFutureInstructionButton")
let UrbanFutureWebsiteButton = document.getElementById("UrbanFutureWebsiteButton")

let UrbanFutureLocationButton = document.getElementById("UrbanFutureLocationButton")
let UrbanFutureLocationPinButton = document.getElementById("UrbanFutureLocationPinButton")


let UrbanFutureStartExperienceButton = document.getElementById("UrbanFutureStartExperienceButton")
let UrbanFutureSurveyButton = document.getElementById("UrbanFutureSurveyButton")

let UrbanFutureContactButton = document.getElementById("UrbanFutureContactButton");

let UrbanFutureScanningButton = document.getElementById("UrbanFutureScanningButton");

UrbanFutureScanningButton.addEventListener("click", function () {
    window.open('https://publictwin.info/PromptarePlacemakingWeek/scanningApp', '_blank');
});
UrbanFutureWebsiteButton.addEventListener("click", function () {
    window.open('https://slaskiurbanlab.pl/', '_blank');
});



document.getElementById('introduceCheckbox').checked = false;


UrbanFutureIntroduceButton.addEventListener("click", function () {
    document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")
    while (document.getElementById("UrbanFutureIntroduceMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureIntroduceMenu").classList.remove("UrbanFutureDisplayNone")
    }

    function clearSelectToPlaceholder(selectEl) {
        if (!selectEl) return;
        // prefer an option with empty value (your placeholder)
        const idx = Array.from(selectEl.options).findIndex(o => o.value === '');
        if (idx >= 0) {
            const opt = selectEl.options[idx];
            const wasDisabled = opt.disabled;
            // temporarily enable disabled placeholder so it can be selected programmatically
            if (wasDisabled) opt.disabled = false;
            selectEl.selectedIndex = idx;
            if (wasDisabled) opt.disabled = true;
        } else {
            // fallback: clear value and selection
            selectEl.value = '';
            selectEl.selectedIndex = -1;
        }

    }

    // // usage example
    // clearSelectToPlaceholder(document.getElementById('UFFormGender'));
    // clearSelectToPlaceholder(document.getElementById('UFFormAge'));
    // clearSelectToPlaceholder(document.getElementById("UFFormRelation"));


}, true);

function enterInstruction(entered = "viaOther") {
    if (entered == "viaButton") {
        UrbanFutureRoleBack.setAttribute("enteredfrom", "viaButton");
    }
    else if (entered == "viaInform") {
        UrbanFutureRoleBack.setAttribute("enteredfrom", "viaInform");
    } else {
        UrbanFutureRoleBack.setAttribute("enteredfrom", "viaOther");
    }
    document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")
    while (document.getElementById("UrbanFutureChooseRoleMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.remove("UrbanFutureDisplayNone")
    }

}

UrbanFutureInstructionButton.addEventListener("click", function () {
    enterInstruction("viaButton");
}, true);


UrbanFutureLocationButton.addEventListener("click", function () {

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const userLongitude = position.coords.longitude;
            const userLatitude = position.coords.latitude;
            // setCheckboxState(locationCheckbox,true);

            if (!sessionStorage.getItem('LocationComplete')) {
                sessionPTCoins += 25;
                sessionStorage.setItem('userPTCoins', sessionPTCoins);
                checkCoinsRole()

                document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
            }

            sessionStorage.setItem('LocationComplete', "true");
            sessionLocationComplete = sessionStorage.getItem('LocationComplete');

            // document.getElementById("LocationCoinDiv").style.display="none";

            // locationTypeAction = "UserPositionBased";
            // document.getElementById("UrbanFutureLocateUser").click();
            locateUserPositionBasedClick();

            UrbanFutureLocationButton.style.backgroundColor = "#F9D235";
            UrbanFutureLocationPinButton.style.backgroundColor = "#FCEFC7";
            document.getElementById("StartIncompleteMessage").innerHTML = "partycypacja na podstawie lokalizacji";


        },
        (error) => {
            // console.log("Error getting location", error);
            // document.getElementById("StartIncompleteMessage").innerHTML="please, enable location services!";

            console.log("Unable to retrieve your location.");
            console.log("Switching to pin based location system.");
            document.getElementById("StartIncompleteMessage").innerHTML = "zezwól na usługi lokalizacji";

            UrbanFutureLocationButton.style.backgroundColor = "#F9D235";
            UrbanFutureLocationPinButton.style.backgroundColor = "#FCEFC7";

            setTimeout(() => {
                // Your function or code here
                UrbanFutureLocationPinButton.click();
            }, 1000);



        }
    );
    if (navigator.permissions) {
        navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
            if (result.state === 'granted') {
                // User already allowed geolocation
                // console.log("Geolocation permission granted.");

                // setCheckboxState(locationCheckbox,true);
            } else {
                // Not granted yet or denied
                // console.log("Geolocation permission not granted.");
                // document.getElementById("StartIncompleteMessage").innerHTML="please, enable location services!";
            }
        });
    } else {
        // Fallback if Permissions API is not supported
        // console.log("Permissions API not supported.");
    }


}, true);


UrbanFutureLocationPinButton.addEventListener("click", function () {

    // locationTypeAction = "PinBased";
    // document.getElementById("UrbanFutureLocatePin").click();
    locatePinPositionBasedClick();

    UrbanFutureLocationPinButton.style.backgroundColor = "#F9D235";
    UrbanFutureLocationButton.style.backgroundColor = "#FCEFC7";

    sessionStorage.setItem('LocationComplete', "true");
    sessionLocationComplete = sessionStorage.getItem('LocationComplete');
    document.getElementById("StartIncompleteMessage").innerHTML = "partycypacja na podstawie pinezki";

}, true);



UrbanFutureSurveyButton.addEventListener("click", function () {

    document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")

    while (document.getElementById("UrbanFutureSurveyMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureSurveyMenu").classList.remove("UrbanFutureDisplayNone")
    }

}, true);

UrbanFutureContactButton.addEventListener("click", function () {

    document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureSurveyMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")

    while (document.getElementById("UrbanFutureContactMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureContactMenu").classList.remove("UrbanFutureDisplayNone")
    }
    if (sessionStorage.getItem('userEmail')) {
        // let selectedValue = this.value;
        // sessionStorage.setItem('userEmail', selectedValue);
        // sessionUserEmail = sessionStorage.getItem('userEmail');
        document.getElementById("UFFormEmailMessage").value = sessionStorage.getItem('userEmail');
    }

}, true);

document.getElementById("FunctionalitiesIntroMenuContinue").addEventListener("click", function () {
    hideElement(document.getElementById("FunctionalitiesIntroMenu"));
})

document.getElementById("UrbanFutureIntroduceCloseButton").addEventListener("click", function () {
    document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone");
});


UrbanFutureStartExperienceButton.addEventListener("click", function () {
    if (ReadyToStart || ReadyToStartViaLogin) {
        // alert(`ID: ${sessionUserID}\nGender: ${sessionUserGender}\nAge: ${sessionUserAge}\nRelation: ${sessionUserRelation}\nEmail: ${sessionUserEmail}\nRole: ${sessionUserRole}`);

        // NEW: make all zones appear as if they were hovered
        setAllZonesHoverVisual(true);

        // NEW: show a hint toast (auto-hides after 10s; click to dismiss)
        showParticipateHintToast(
            'kliknij w którąś ze <span>stref</span> w aktywnej <span>konfiguracji</span> aby zostawić opinię lub dodać polubienie!',
            { duration: 10000 }
        );

        if (map.getStyle().sprite && !map.getStyle().sprite.includes('cmantxs6m01ii01skcbe76l1u')) {
            map.setStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u');


            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        } else {
            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        }


        map.once('style.load', function () {
        })

        if (sessionStorage.getItem('introOpenedOnce') == "false") {
            showElement(document.getElementById("FunctionalitiesIntroMenu"));
            sessionStorage.setItem('introOpenedOnce', "true");
            setTimeout(() => {
                document.getElementById("FunctionalitiesIntroMenuContinue").click();
            }, 15000);
        }
        else {


        }


        if (locationTypeAction == "PinBased") {
            let cameraMoveTo = cameraStartOverview;
            flyTowards(cameraMoveTo);

        } else {
            UpdateLocationToUser();




        }

        document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone");
        document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone");
        document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")

        document.getElementById("StartIncompleteMessage").innerHTML = "";

        startParticipationUrbanFuture();



        // startLocating();
    }
    else {
        // alert(`ID: ${sessionUserID}\nGender: ${sessionUserGender}\nAge: ${sessionUserAge}\nRelation: ${sessionUserRelation}\nEmail: ${sessionUserEmail}\nRole: ${sessionUserRole}`);
        document.getElementById("StartIncompleteMessage").innerHTML = 'wypełnij sekcje oznaczone <img class="UFIconCoin WithMargins" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/IconSections.png"/>! lub zaloguj się!';

    }
}, true);




let UrbanFutureSurveyBack = document.getElementById("UrbanFutureSurveyBack");
let UrbanFutureSurveySave = document.getElementById("UrbanFutureSurveySave");
document.getElementById("UrbanFutureSurveySave").style.backgroundColor = "#003d92";
document.getElementById("UrbanFutureSurveySave").style.setProperty("color", "white", "important");

UrbanFutureSurveySave.setAttribute("active", "true");

UrbanFutureSurveyBack.addEventListener("click", function () {

    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureSurveyMenu").classList.add("UrbanFutureDisplayNone")

    while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone");

    }

}, true);

UrbanFutureSurveySave.addEventListener("click", function () {

    if (UrbanFutureSurveySave.getAttribute("active") == "true") {

        console.log("clicking the button")
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureSurveyMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")


        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
        }

        submitSurveyResponse();

        if (!sessionStorage.getItem('SurveyComplete')) {
            sessionPTCoins += 75;
            sessionStorage.setItem('userPTCoins', sessionPTCoins);
            checkCoinsRole();
            document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
        }

        sessionStorage.setItem('SurveyComplete', "true");
        sessionSurveyComplete = sessionStorage.getItem('SurveyComplete');

        document.getElementById("SurveyCoinDiv").style.display = "none";

    }
    if (UrbanFutureSurveySave.getAttribute("active") == "true") {
        const reasonOptions = Array.from(document.getElementById("UFFormReason").selectedOptions);
        const reasonValues = reasonOptions.map(opt => opt.value).join(", ");

        const associations = document.getElementById("UFFormAssociations").value || "-";
        const meaningDistrict = document.getElementById("UFSliderClose").value || 3;
        const meaningCampus = document.getElementById("UFSliderUni").value || 3;
        const meaningCity = document.getElementById("UFSliderCity").value || 3;
        const relationWeight = document.getElementById("UFSliderRole").value || 3;
        const campusAnswer = document.getElementById("UFFormCampus").value || "-";
        const elementAnswer = document.getElementById("UFFormElements").value || "-";

        fetch("https://publictwin.info/digital_maquette/php_scripts/PlacKrakowski_User_UpdateSurvey.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ip: userIP,
                Pytanie_1_Cel: reasonValues,
                Pytanie_2_Skojarzenia: associations,
                Pytanie_3a_ZnaczenieDlaDielnicy: meaningDistrict,
                Pytanie_3b_ZnaczenieDlaUczelni: meaningCampus,
                Pytanie_3c_ZnaczenieDlaMiasta: meaningCity,
                Pytanie_4_Powiazanie: relationWeight,
                Pytanie_5_Campus: campusAnswer,
                Pytanie_6_Elementy: elementAnswer
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log("Survey update result:", data.status);
            })
            .catch(error => {
                console.error("Survey update failed:", error);
            });
    }
    if (UrbanFutureSurveySave.getAttribute("active") == "true") {
        setUserSessionActive();
    }

}, true);


// Role menu save buttons:
let UrbanFutureRoleBack = document.getElementById("UrbanFutureRoleBack")
// let UrbanFutureRoleSave = document.getElementById("UrbanFutureRoleSave")



UrbanFutureRoleBack.addEventListener("click", function () {

    if (UrbanFutureRoleBack.getAttribute("enteredfrom") == "viaButton") {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone");

        }
        // setCheckboxState(roleCheckbox,true);        
        // document.getElementById('introduceCheckbox').classList.add('locked-checked');
        if (!sessionStorage.getItem('RoleComplete')) {
            sessionPTCoins += 25;
            checkCoinsRole();
            sessionStorage.setItem('userPTCoins', sessionPTCoins);

            document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
        }
        sessionStorage.setItem('RoleComplete', "true");
        sessionRoleComplete = sessionStorage.getItem('RoleComplete');

        // document.getElementById("RoleCoinDiv").style.display="none";
    }
    else if (UrbanFutureRoleBack.getAttribute("enteredfrom") == "viaInform") {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone");

        }
        UrbanFutureStartExperienceButton.click();
        // setCheckboxState(roleCheckbox,true);        
        // document.getElementById('introduceCheckbox').classList.add('locked-checked');
        if (!sessionStorage.getItem('RoleComplete')) {
            sessionPTCoins += 25;
            checkCoinsRole();
            sessionStorage.setItem('userPTCoins', sessionPTCoins);

            document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
        }
        sessionStorage.setItem('RoleComplete', "true");
        sessionRoleComplete = sessionStorage.getItem('RoleComplete');

    }

}, true);


let UrbanFutureIntroduceSave = document.getElementById("UrbanFutureIntroduceSave")




UrbanFutureIntroduceSave.addEventListener("click", function () {
    if (UrbanFutureIntroduceSave.getAttribute("active") == "true") {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")

            setCheckboxState(introduceCheckbox, true);
            // document.getElementById('introduceCheckbox').classList.add('locked-checked');
            document.getElementById("IntrouceIncompleteMessage").innerHTML = "";

            if (!sessionStorage.getItem('IntroduceComplete')) {
                sessionPTCoins += 25;
                checkCoinsRole();
                sessionStorage.setItem('userPTCoins', sessionPTCoins);

                document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
            }

            sessionStorage.setItem('IntroduceComplete', "true");
            sessionIntroduceComplete = sessionStorage.getItem('IntroduceComplete');

            document.getElementById("IntroductionCoinDiv").style.display = "none";

        }
        document.getElementById("UrbanFutureStartExperienceButton").click();
    } else {
        document.getElementById("IntrouceIncompleteMessage").innerHTML = "*Wybierz opcję w każdym obowiązkowym polu!";
    }

    if (UrbanFutureIntroduceSave.getAttribute("active") == "true") {
        // Get form values
        let age = document.getElementById("UFFormAge").value || "-";
        let gender = document.getElementById("UFFormGender").value || "-";
        let relation = document.getElementById("UFFormRelation").value || "-";

        if (relation === "anders, namelijk:") {
            relation = document.getElementById("UFFormRelationSelf").value || "-";
        } else {
            relation = document.getElementById("UFFormRelation").value || "-";
        }
        let email = document.getElementById("UFFormEmail").value || "-";

        // Send data to PHP backend
        fetch("https://publictwin.info/EngagementAppPrototypes/MainPHP/User_UpdateIntro.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                table: databaseUsersName,
                ip: userIP,
                age_group: age,
                gender: gender,
                relation_to_place: relation,
                email: email,
                user_identifier: sessionStorage.getItem('userID')
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log("Update status:", data.status);
            })
            .catch(err => {
                console.error("Update failed:", err);
            });

        // Continue with UI changes...
        // [same logic as in your current function]
    } else {
        document.getElementById("IntrouceIncompleteMessage").innerHTML = "*Wybierz opcję w każdym obowiązkowym polu!";
    }
    if (UrbanFutureIntroduceSave.getAttribute("active") == "true") {
        setUserSessionActive();
    }

}, true);


// login menu back:
let UrbanFutureLoginBack = document.getElementById("UrbanFutureLoginBack")

UrbanFutureLoginBack.addEventListener("click", function () {

    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureContactMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")


    while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
    }

}, true);



// Introduce menu save buttons:
let UrbanFutureContactBack = document.getElementById("UrbanFutureContactBack")
let UrbanFutureContactSave = document.getElementById("UrbanFutureContactSave")
UrbanFutureContactSave.style.backgroundColor = "#f9d235";
UrbanFutureContactSave.setAttribute("active", "true");



UrbanFutureContactBack.addEventListener("click", function () {

    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureContactMenu").classList.add("UrbanFutureDisplayNone")


    while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
    }

}, true);

UrbanFutureContactSave.addEventListener("click", function () {
    if (UrbanFutureContactSave.getAttribute("active") == "true") {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureContactMenu").classList.add("UrbanFutureDisplayNone")


        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
        }


        document.getElementById("IntrouceIncompleteMessage").innerHTML = "";


        const userEmail = document.getElementById('UFFormEmailMessage').value.trim();
        const userMessage = document.getElementById('UFFormMessage').value.trim();

        fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/sendContactEmail.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                from: userEmail,
                message: userMessage
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // alert("Wiadomość została wysłana!");
                } else {
                    // alert("Wystąpił błąd: " + data.error);
                }
            });

    }
    else {
        document.getElementById("IntrouceIncompleteMessage").innerHTML = "*select an option in each complusory field!"
    }

}, true);


document.getElementById('UFFormGender').addEventListener('change', function () {
    let selectedValue = this.value;

    // console.log("Selected gender:", selectedValue);

    // Set session gender item:
    sessionStorage.setItem('userGender', selectedValue);
    sessionUserGender = sessionStorage.getItem('userGender');

    checkIfIntroReady();


});
function checkIfIntroReady() {
    // console.log("gender form value:", document.getElementById("UFFormGender").value);

    if (sessionUserGender != null && sessionUserRelation != null && sessionUserAge != null && sessionUserID != null) {
        introduceReadyToSave = true;



        if (introduceReadyToSave) {
            document.getElementById("UrbanFutureIntroduceSave").style.backgroundColor = "#003d92";
            document.getElementById("UrbanFutureIntroduceSave").style.setProperty("color", "white", "important");
            document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
            document.getElementById("IntrouceIncompleteMessage").innerHTML = ""

        }
    }
    else {
        introduceReadyToSave = false;
        document.getElementById("UrbanFutureIntroduceSave").style.backgroundColor = "#616161";
        document.getElementById("UrbanFutureIntroduceSave").style.setProperty("color", "black", "important");
    }
}

document.getElementById('UFFormRelation').addEventListener('change', function () {
    let selectedValue = this.value;

    // console.log("Selected relation:", selectedValue);

    // Set session gender item:
    sessionStorage.setItem('userRelation', selectedValue);
    sessionUserRelation = sessionStorage.getItem('userRelation');

    checkIfIntroReady();




});


document.getElementById('UFFormAge').addEventListener('change', function () {
    let selectedValue = this.value;
    // console.log("Selected age:", selectedValue);

    // Set session gender item:
    sessionStorage.setItem('userAge', selectedValue);
    sessionUserAge = sessionStorage.getItem('userAge');

    checkIfIntroReady();



});

document.getElementById('UFFormEmail').addEventListener('change', function () {
    let selectedValue = this.value;
    sessionStorage.setItem('userEmail', selectedValue);
    sessionUserEmail = sessionStorage.getItem('userEmail');
})

function onSelectConfirm(el, handler) {
    const run = () => handler(el.value);

    el.addEventListener('change', run);              // value changed
    el.addEventListener('click', run);               // reselect same value (mouse/tap)
    el.addEventListener('keydown', (e) => {          // keyboard confirm
        if (e.key === 'Enter' || e.key === ' ') run();
    });
}

// --- Usage with your fields ---
const relationEl = document.getElementById('UFFormRelation');
const ageEl = document.getElementById('UFFormAge');
const emailEl = document.getElementById('UFFormEmail'); // input (keep change only)

onSelectConfirm(relationEl, (val) => {
    sessionStorage.setItem('userRelation', val);
    sessionUserRelation = val;
    checkIfIntroReady();
});

onSelectConfirm(ageEl, (val) => {
    sessionStorage.setItem('userAge', val);
    sessionUserAge = val;
    checkIfIntroReady();
});

// For inputs like email, reselect isn't a thing — keep change/input:
emailEl.addEventListener('change', function () {
    const val = this.value;
    sessionStorage.setItem('userEmail', val);
    sessionUserEmail = val;
});



function restartSession() {

    sessionStorage.removeItem('userID');
    sessionStorage.removeItem('userPTCoins');
    sessionStorage.removeItem('userRole');
    sessionStorage.removeItem('LocationComplete');
    sessionStorage.removeItem('SurveyComplete');
    sessionStorage.removeItem('IntroduceComplete');
    sessionStorage.removeItem('RoleComplete');
    sessionStorage.removeItem('introOpenedOnce');

    if (!sessionStorage.getItem('introOpenedOnce')) {
        sessionStorage.setItem("introOpenedOnce", "false");
    }

    // document.getElementById("RoleCoinDiv").style.display="block";
    // document.getElementById("IntroductionCoinDiv").style.display = "block";
    // document.getElementById("SurveyCoinDiv").style.display = "block";
    // document.getElementById("LocationCoinDiv").style.display="block";



    code = Math.floor(10000000 + Math.random() * 90000000).toString();

    userID = projectCode + String(code);

    // Set item (if its not set already):
    if (!sessionStorage.getItem('userID')) {
        sessionStorage.setItem('userID', userID);
    }

    sessionUserID = sessionStorage.getItem('userID');

    sessionPTCoins = 0;
    // checkCoinsRole();
    sessionStorage.setItem('userPTCoins', sessionPTCoins);
    document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
    document.getElementById("yourCoinsInApp").innerHTML = sessionStorage.getItem('userPTCoins');

    sessionStorage.setItem('userRole', "partycypacyjny nowicjusz");
    sessionUserRole = sessionStorage.getItem('userRole');
    document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

    // sessionStorage.setItem('LocationComplete', "false");
    sessionLocationComplete = "false";

    // Clear Introduce form
    document.getElementById("UFFormAge").value = "";
    document.getElementById("UFFormGender").value = "";
    document.getElementById("UFFormRelation").value = "";
    document.getElementById("UFFormEmail").value = "";

    // Clear Survey form
    document.getElementById("UFFormReason").selectedIndex = -1; // Deselect all in multiselect
    Array.from(document.getElementById("UFFormReason").options).forEach(opt => opt.selected = false);
    document.getElementById("UFFormAssociations").value = "";
    document.getElementById("UFFormCampus").value = "";
    document.getElementById("UFFormElements").value = "";

    // Reset sliders
    document.getElementById("UFSliderClose").value = 3;
    document.getElementById("UFSliderUni").value = 3;
    document.getElementById("UFSliderCity").value = 3;
    document.getElementById("UFSliderRole").value = 3;

    UrbanFutureIntroduceSave.setAttribute("active", "false");
    getUserIPAndCheck();
    checkSessionAndBoxes();

}
function resetIntroAndSurveyFields() {
    // --- Intro Fields ---
    document.getElementById("UFFormAge").value = "";
    document.getElementById("UFFormGender").value = "";
    document.getElementById("UFFormRelation").value = "";
    document.getElementById("UFFormEmail").value = "";

    // --- Survey Fields ---
    const reasonOptions = document.getElementById("UFFormReason").options;
    for (let i = 0; i < reasonOptions.length; i++) {
        reasonOptions[i].selected = false;
    }

    document.getElementById("UFFormAssociations").value = "";
    document.getElementById("UFSliderClose").value = 3;
    document.getElementById("UFSliderUni").value = 3;
    document.getElementById("UFSliderCity").value = 3;
    document.getElementById("UFSliderRole").value = 3;
    document.getElementById("UFFormCampus").value = "";
    document.getElementById("UFFormElements").value = "";
}



function checkSessionAndBoxes() {


    if (sessionStorage.getItem('IntroduceComplete')) {
        setCheckboxState(introduceCheckbox, true)
        document.getElementById("IntroductionCoinDiv").style.display = "none";
        // introduceCheckbox.checked=true;

    } else {
        // introduceCheckbox.checked=false;
        setCheckboxState(introduceCheckbox, false)
    }


    if (sessionStorage.getItem('RoleComplete')) {
        // setCheckboxState(roleCheckbox,true)
        // document.getElementById("RoleCoinDiv").style.display="none";
        // roleCheckbox.checked=true;

    } else {
        // roleCheckbox.checked=false;
        // setCheckboxState(roleCheckbox,false)
    }

    if (sessionStorage.getItem('LocationComplete')) {
        // setCheckboxState(locationCheckbox,true)
        // document.getElementById("LocationCoinDiv").style.display="none";
        // locationCheckbox.checked=true;

    } else {
        // roleCheckbox.checked=false;
        // setCheckboxState(locationCheckbox,false)
    }

}

function setCheckboxState(checkbox, state) {
    checkbox.checked = state;
    onCheckboxStateChange(checkbox);
}

function onCheckboxStateChange(checkbox) {


    if (sessionStorage.getItem('IntroduceComplete')) {
        introduceCheckbox.checked = true;
    }
    if (sessionStorage.getItem('RoleComplete')) {
        // roleCheckbox.checked=true;

    }
    if (sessionStorage.getItem('LocationComplete')) {
        // locationCheckbox.checked=true;
    }
    // checkSessionAndBoxes();

    // console.log(checkbox);
    if (checkbox.checked) {
        checkbox.classList.add("checkedStyle")
    }
    else {
        while (checkbox.classList.contains("checkedStyle")) {
            checkbox.classList.remove("checkedStyle")
        }
    }
    // roleCheckbox.checked==true

    if (introduceCheckbox.checked == true) {

        ReadyToStart = true;

        if (ReadyToStart) {
            document.getElementById("StartIncompleteMessage").innerHTML = "";
            document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#003d92";
            document.getElementById("UrbanFutureStartExperienceButton").classList.add("override-color");
            document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
            // document.getElementById("StartIncompleteMessage").innerHTML="";

        }
    }
    else {
        ReadyToStart = false;
        document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#616161";
        document.getElementById("UrbanFutureStartExperienceButton").classList.remove("override-color");
        // document.getElementById("UrbanFutureStartExperienceButtonSegment").style.setProperty("color", "black", "important");
        console.log("not all elements are set")
    }

}

function urbanFutureAddProjectElements() {

    if (!map.getSource('UrbanFuture-region-boundary')) {
        map.addSource('UrbanFuture-region-boundary', {
            type: 'geojson',
            data: {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: [projectAreaCoordinates]
                }
            }
        });
    }

    // Add a fill layer to show the region
    if (!map.getLayer('UrbanFuture-region-fill')) {
        map.addLayer({
            id: 'UrbanFuture-region-fill',
            type: 'fill',
            source: 'UrbanFuture-region-boundary',
            layout: {},
            paint: {
                'fill-color': '#f9d235',
                'fill-opacity': 0.1
            }
        });
    }

    // Optional: add a border line
    if (!map.getLayer('UrbanFuture-region-outline')) {
        map.addLayer({
            id: 'UrbanFuture-region-outline',
            type: 'line',
            source: 'UrbanFuture-region-boundary',
            layout: {},
            paint: {
                'line-color': '#f9d235',
                'line-width': 2
            }
        });
    }
    if (!map.getSource('UrbanFuture-walk-path')) {
        map.addSource('UrbanFuture-walk-path', {
            type: 'geojson',
            data: {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: [[

                        [4.415196678145662, 51.906970462672916],
                        [4.419091791795466, 51.906221459833034],
                        [4.4201109758257076, 51.90782519224152],
                        [4.4205451043420965, 51.908491942512626],
                        [4.420463877984844, 51.908527147160925],
                        [4.424592864183268, 51.91252814767134],
                        [4.4139492202727695, 51.91318137208694],
                        [4.411710313328825, 51.91098319495117],
                        [4.414031990134092, 51.908050872443596],
                        [4.4142608062008435, 51.90812499267457],
                        [4.415196678145662, 51.906970462672916]
                    ]]
                }
            }
        });
    }

    if (!map.getLayer('UrbanFuture-walk-path')) {
        map.addLayer({
            id: 'UrbanFuture-walk-path',
            type: 'line',
            source: 'UrbanFuture-walk-path',
            layout: {},
            paint: {
                'line-color': '#d0af2d',
                'line-width': 3,
                'line-dasharray': [2, 2]  // 2px dash, 4px gap
            }
        });
    }
    if (!map.getLayer('UrbanFuture-walk-fill')) {
        map.addLayer({
            id: 'UrbanFuture-walk-fill',
            type: 'fill',
            source: 'UrbanFuture-walk-path',
            layout: {},
            paint: {
                'fill-color': '#ffffff',
                'fill-opacity': 0.2
            }
        });
    }

    if (!map.getSource('eraser')) {

        // clip layer (eraser)
        map.addSource('eraser', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'Polygon',
                            coordinates: [projectRemove3DElements

                            ]
                        }
                    }
                ]
            }
        });


    }

    if (!map.getLayer('eraser')) {
        map.addLayer({
            id: 'eraser',
            type: 'clip',
            source: 'eraser',
            layout: { 'clip-layer-types': ['symbol', 'model'] }
        });
    }




    map.moveLayer('UrbanFuture-region-fill');
    map.moveLayer('UrbanFuture-region-outline');
    map.moveLayer('UrbanFuture-walk-path');
    if (map.getLayer('PTProjects'))
        map.moveLayer('PTProjects');

    loadPinQuestionImages();


}
function urbanFutureMoveLayersToFront() {
    map.moveLayer('UrbanFuture-region-fill');
    map.moveLayer('UrbanFuture-region-outline');
    map.moveLayer('UrbanFuture-walk-path');
    if (map.getLayer('PinQuestions'))
        map.moveLayer('PinQuestions');
    if (map.getLayer('PTProjects'))
        map.moveLayer('PTProjects');
}

function startParticipationUrbanFuture() {

    try {
        if (sessionStorage.getItem('userRole')) {

            if (sessionStorage.getItem('userRole') == "GreenGuardian") {

                document.getElementById("yourRoleInApp").innerHTML = "Green Guardian";

            } else if (sessionStorage.getItem('userRole') == "AccessInspector") {

                document.getElementById("yourRoleInApp").innerHTML = "Access Inspector";

            } else if (sessionStorage.getItem('userRole') == "ActivityScout") {
                document.getElementById("yourRoleInApp").innerHTML = "Activity Scout";

            }

        }
    } catch {
    }
    try {
        document.getElementById("yourCoinsInApp").innerHTML = sessionStorage.getItem('userPTCoins')
    } catch {

    }

    document.getElementById("TopNavbarUrbanFuture").style.display = "block";
    document.getElementById("BottomMenuUrbanFuture").style.display = "block";
    showElement(document.getElementById("BottomLocateUser"));
    showElement(document.getElementById("BottomStyleSwitch"))
}


document.getElementById("UrbanFutureTopNavbarSelectOptions").addEventListener("click", function () {

    if (!UrbanFutureSelectOptionsMenuOpen) {
        document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display = "flex";
        document.getElementById("UrbanFutureTopNavbarOpenClose").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CloseMenu.png";

        // Closing the Participate Panel:

        // hideElement(document.getElementById("UrbanFutureMainMenu"));

        hideElement(document.getElementById("ParticipateMenuWrapper"));

        hideElement(document.getElementById("BotomActionsUrbanReaction"));
        hideElement(document.getElementById("BotomActionsUrbanComment"));
        hideElement(document.getElementById("BotomActionsUrbanPhoto"));
        hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
        hideElement(document.getElementById("UrbanFutureWalkshopThank"));



        hideElement(document.getElementById("UrbanFutureConfirmLocation"));
        hideElement(document.getElementById("UserLoginMenuUrbanFuture"));
        whiteFrame();
        try {
            if (document.getElementById("zones-close")) {
                document.getElementById("zones-close").click();
            }
        } catch { }


    } else {
        document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display = "none";
        hideElement(document.getElementById("UserLoginMenuUrbanFuture"))
        document.getElementById("UrbanFutureTopNavbarOpenClose").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/OpenMenu.png";
    }

    UrbanFutureSelectOptionsMenuOpen = !UrbanFutureSelectOptionsMenuOpen

})


document.getElementById("UrbanFutureMainMenuButton").addEventListener("click", function () {


    document.getElementById("UrbanFutureTopNavbarSelectOptions").click();


    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")

    while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
    }
    while (document.getElementById("UserMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UserMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone")
    }

    // document.getElementById("UserMenuUrbanFuture").style.display="block";
    // document.getElementById("UserMenuUrbanFuture").style.visibility="visible";



});


document.getElementById("UrbanFutureReCenterButton").addEventListener("click", function () {


    document.getElementById("UrbanFutureTopNavbarSelectOptions").click();



    let cameraMoveTo = cameraStartOverview;

    flyTowards(cameraMoveTo);


});


document.getElementById("UrbanFutureEndTourButton").addEventListener("click", function () {

    showElement(document.getElementById("UrbanFutureWalkshopConclusion"))
});


document.getElementById('UrbanFutureLearnMoreButton').addEventListener('click', function () {
    document.getElementById("UrbanFutureTopNavbarSelectOptions").click();
    window.open('https://eoxsnlhinp7.typeform.com/to/r0rGuJYy', '_blank');
});








document.getElementById("UrbanFutureParticipationConfirmPin").addEventListener('click', function () {

    if (openMenu == "ReactionMenu") {
        reactionSubmitToDatabase();
        // lanuchReactionMenu();
    } else if (openMenu == "CommentMenu") {
        commentSubmitToDatabase();
        // launchCommentMenu();
    } else {
        photoSubmitToDatabase();
        // launchPhotoMenu();
    }
});

document.getElementById("TourCloseButton").addEventListener('click', function () {
    hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
});


document.getElementById("TourSubmitButton").addEventListener('click', function () {
    hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
    submitScore();

    const table = databaseUsersName;
    const uid = sessionStorage.getItem('userID') || '-';

    const ensureIp = () =>
        (window.userIP && window.userIP !== '')
            ? Promise.resolve({ ip: window.userIP })
            : fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php').then(r => r.json());

    ensureIp().then(({ ip }) => {
        // End session
        const endSession = fetch("https://publictwin.info/EngagementAppPrototypes/MainPHP/User_EndSession.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ip, uid, table })
        }).then(r => r.json());

        return Promise.all([endSession]);
    })
        .then(([endRes]) => {
            console.log("End session:", endRes);
            resetIntroAndSurveyFields(); // clear frontend fields
        })
        .catch(err => console.error("Finalize session failed:", err));

    document.getElementById("UrbanFutureMainMenuButton").click();
    restartSession();
});


document.getElementById("TypeformButton").addEventListener('click', function () {
    window.open("https://eoxsnlhinp7.typeform.com/to/DZUDal7b", "_blank"); // "_blank" opens in a new tab
});





const reactionIcons = document.querySelectorAll('.UrbanFutureReactionIcon');

reactionIcons.forEach(icon => {
    icon.addEventListener('click', () => {
        // Remove 'whiteBorder' from all icons
        reactionIcons.forEach(el => el.classList.remove('whiteBorder'));

        // Add 'whiteBorder' to the clicked one
        icon.classList.add('whiteBorder');

        console.log(document.getElementById("BotomActionsUrbanReaction").getAttribute("apeneded"))

        if (document.getElementById("BotomActionsUrbanReaction").getAttribute("apeneded") == "false") {

            while (document.getElementById("CommentWrapper").classList.contains("UrbanFutureDisplayNone")) {
                document.getElementById("CommentWrapper").classList.remove("UrbanFutureDisplayNone");
            }
            document.getElementById("BotomActionsUrbanReaction").setAttribute("apeneded", "true");

        }

        slectedReactionValue = icon.getAttribute("score");

    });



});

// Show Element Logic Needs to be simplified:

function showElement(element) {
    while (element.classList.contains("UrbanFutureDisplayNone")) {

        element.classList.remove("UrbanFutureDisplayNone")
    }
    element.setAttribute("menuOpened", "true");

    if (element.id == "BotomActionsUrbanReaction") {
        document.getElementById("CommentWrapper").classList.add("UrbanFutureDisplayNone");
        document.getElementById("BotomActionsUrbanReaction").setAttribute("apeneded", "false");



        document.getElementById("UrbanFutureParticipationReact").classList.add("whiteBorder");

        while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
        }
        hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
        hideElement(document.getElementById("UrbanFutureWalkshopThank"));
        map.setLayoutProperty('PinQuestions', 'visibility', 'none');



    }
    if (element.id == "BotomActionsUrbanComment") {

        document.getElementById("UrbanFutureParticipationComment").classList.add("whiteBorder");

        while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
        }
        hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
        hideElement(document.getElementById("UrbanFutureWalkshopThank"));
        map.setLayoutProperty('PinQuestions', 'visibility', 'none');


    }
    if (element.id == "BotomActionsUrbanPhoto") {

        document.getElementById("UrbanFutureParticipationPhoto").classList.add("whiteBorder");

        while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
        }
        hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
        hideElement(document.getElementById("UrbanFutureWalkshopThank"));
        map.setLayoutProperty('PinQuestions', 'visibility', 'none');



    }
    if (element.id == "UrbanFutureConfirmLocation") {
        map.setLayoutProperty('PinQuestions', 'visibility', 'none');
    }
    if (element.id == "UserLoginMenuUrbanFuture") {
        // hideElement(document.getElementById("TopNavbarUrbanFutureSelectOptions"))

    } else {
    }


    // if(UrbanFutureSelectOptionsMenuOpen){

    //     document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display="none";
    //     document.getElementById("UrbanFutureTopNavbarOpenClose").src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/OpenMenu.png";

    //     UrbanFutureSelectOptionsMenuOpen=!UrbanFutureSelectOptionsMenuOpen;
    // }

}

function whiteFrame(element = "none") {
    if (element == "none") {

        document.getElementById('BotomActionsUrbanReaction').setAttribute("menuIniciated", "false");
        document.getElementById('BotomActionsUrbanComment').setAttribute("menuIniciated", "false");
        document.getElementById('BotomActionsUrbanPhoto').setAttribute("menuIniciated", "false");


        while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
        }
        map.setLayoutProperty('PinQuestions', 'visibility', 'visible');
        // map.setLayoutProperty('PinQuestions', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');


    } else {

        if (element.id == "BotomActionsUrbanReaction") {
            document.getElementById("CommentWrapper").classList.add("UrbanFutureDisplayNone");
            document.getElementById("BotomActionsUrbanReaction").setAttribute("apeneded", "false");


            document.getElementById('BotomActionsUrbanPhoto').setAttribute("menuIniciated", "false");
            document.getElementById('BotomActionsUrbanComment').setAttribute("menuIniciated", "false");

            document.getElementById("UrbanFutureParticipationReact").classList.add("whiteBorder");

            while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
            }
            while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
            }
            hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
            hideElement(document.getElementById("UrbanFutureWalkshopThank"));



        }
        if (element.id == "BotomActionsUrbanComment") {
            document.getElementById('BotomActionsUrbanPhoto').setAttribute("menuIniciated", "false");
            document.getElementById('BotomActionsUrbanReaction').setAttribute("menuIniciated", "false");

            document.getElementById("UrbanFutureParticipationComment").classList.add("whiteBorder");

            while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
            }
            while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
            }
            hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
            hideElement(document.getElementById("UrbanFutureWalkshopThank"));


        }
        if (element.id == "BotomActionsUrbanPhoto") {
            document.getElementById('BotomActionsUrbanReaction').setAttribute("menuIniciated", "false");
            document.getElementById('BotomActionsUrbanComment').setAttribute("menuIniciated", "false");

            document.getElementById("UrbanFutureParticipationPhoto").classList.add("whiteBorder");



            while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
            }
            while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
            }
            hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
            hideElement(document.getElementById("UrbanFutureWalkshopThank"));



        }
    }
}

function hideElement(element) {
    element.classList.add("UrbanFutureDisplayNone");
    element.setAttribute("menuOpened", "false");

    if (element.id == "BotomActionsUrbanReaction") {

        while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
        }

    }
    if (element.id == "BotomActionsUrbanComment") {

        while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
        }


    }
    if (element.id == "BotomActionsUrbanPhoto") {

        while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
        }
        let capturedState = false;
        document.getElementById("CameraSubmitButton").style.backgroundColor = "#d0af2d";
        stopCamera();


    }
}







const video = document.getElementById('video');
const canvas = document.getElementById('canvas');
const captureBtn = document.getElementById('captureBtn');
const retakeBtn = document.getElementById('retakeBtn');

let stream = null;



async function startCamera() {
    try {
        stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: 'environment' },
            audio: false
        });

        video.srcObject = stream;
        video.play();

        video.style.display = 'block';
        canvas.style.display = 'none';
        retakeBtn.style.display = 'none';
        captureBtn.style.display = 'flex';
    } catch (error) {
        console.log('Error accessing camera:', error);
    }
}

function stopCamera() {
    if (stream) {
        stream.getTracks().forEach(track => {
            track.stop(); // Fully stop the camera hardware
        });
        stream = null;
    }

    if (video) {
        video.pause();
        video.srcObject = null;
        video.style.display = 'none';
    }

    // Reset visual state
    canvas.style.display = 'none';
    captureBtn.style.display = 'flex';
    retakeBtn.style.display = 'none';

    capturedState = false;
    document.getElementById("CameraSubmitButton").style.backgroundColor = "#d0af2d";
}


function captureImage() {
    const context = canvas.getContext('2d');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Stop the video stream (freeze)
    video.pause();
    video.style.display = 'none';
    canvas.style.display = 'block';
    captureBtn.style.display = 'none';
    retakeBtn.style.display = 'flex';

    capturedState = true;
    document.getElementById("CameraSubmitButton").style.backgroundColor = "#003d92"
}

function retakeImage() {
    video.play();
    video.style.display = 'block';
    canvas.style.display = 'none';
    captureBtn.style.display = 'flex';
    retakeBtn.style.display = 'none';

    capturedState = false;
    document.getElementById("CameraSubmitButton").style.backgroundColor = "#d0af2d"
}




captureBtn.addEventListener('click', captureImage);
retakeBtn.addEventListener('click', retakeImage);



let userMarker = new mapboxgl.Marker({ color: 'blue' });
userMarker.getElement().style.opacity = '0';
userMarker.getElement().style.display = 'none';




// === Location Functionalities: === 


function updateLocation(position) {
    try {
        const lng = position.coords.longitude;
        const lat = position.coords.latitude;

        userMarker.setLngLat([lng, lat]).addTo(map);
        userMarker.getElement().style.opacity = '0';
        userMarker.getElement().style.display = 'none';
    } catch {

    }

    // map.setCenter([lng, lat]);
}

function centerUpdateLocation() {
    try {
        // userMarker.setLngLat([lng, lat]).addTo(map);
        const coords = userMarker.getLngLat();
        // console.log(coords.lng, coords.lat);
        map.easeTo({
            center: [coords.lng, coords.lat],
            bearing: 0, // Reset rotation to north
            pitch: 0,   // Reset any tilt
            duration: 1000 // smooth animation (optional)
        });

    }
    catch {

    }

}
function UpdateLocationToUser() {
    try {
        // userMarker.setLngLat([lng, lat]).addTo(map);
        const coords = userMarker.getLngLat();
        // console.log(coords.lng, coords.lat);
        map.easeTo({
            center: [coords.lng, coords.lat],
            bearing: 0, // Reset rotation to north
            pitch: 45,   // Reset any tilt
            zoom: 16.5,
            duration: 1000 // smooth animation (optional)
        });

    }
    catch {

    }

}



function handleError(error) {
    console.error("Geolocation error:", error.message);
    // alert("Unable to get your location. Please enable location access.");
}


function startLocating() {
    if (navigator.geolocation) {


        navigator.geolocation.watchPosition(updateLocation, handleError, {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: 3000 //10000
        });

        // Initialize the geolocate control.
        const geolocate = new mapboxgl.GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true
            },
            trackUserLocation: true,
            showUserHeading: true
        });
        // Add the control to the map.
        map.addControl(geolocate);
        locatingEnabled = true;

        setTimeout(() => {
            geolocate.trigger();
            // UpdateLocationToUser();
        }, 300);


        // Optionally hide the default control container
        const ctrl = document.querySelector('.mapboxgl-ctrl-top-right');
        if (ctrl) ctrl.style.display = 'none';



    } else {
        // alert("Geolocation is not supported by this browser.");
    }
}


document.getElementById("BottomLocateUser").addEventListener("click", function () {
    if (locationTypeAction == "PinBased") {
        locateUserPositionBasedClick();

    } else {
        locatePinPositionBasedClick();
    }






})


const GEOLOCATION_REFRESH_INTERVAL = 30000; // 30 seconds

setInterval(() => {
    if (locationTypeAction !== "UserPositionBased") return;

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const coords = [position.coords.longitude, position.coords.latitude];
            console.log("Refreshed user location:", coords);

            lastKnownUserCoords = coords;

            if (userMarker) {
                userMarker.setLngLat(coords);
            } else {
                userMarker = new mapboxgl.Marker().setLngLat(coords).addTo(map);
            }

            // Optional: Center camera if user moved a lot (e.g. >50m)
            // waitForUserMarkerThenUpdateCamera();
        },
        (error) => {
            console.warn("Geolocation refresh failed:", error);
        },
        {
            enableHighAccuracy: false,
            timeout: 10000,
            maximumAge: 0
        }
    );
}, GEOLOCATION_REFRESH_INTERVAL);



//  === Location Switch: ===

function locateUserPositionBasedClick() {
    locationTypeActionNew = "UserPositionBased";

    UrbanFutureLocationButton.style.backgroundColor = "#F9D235";
    UrbanFutureLocationPinButton.style.backgroundColor = "#FCEFC7";
    document.getElementById("StartIncompleteMessage").innerHTML = "remote participation";

    let fallbackTriggered = false;

    // ⏱ Start timeout for fallback (1 second)
    const fallbackTimeout = setTimeout(() => {
        fallbackTriggered = true;
        if (lastKnownUserCoords) {
            console.warn("Geolocation took too long, using last known user coords.");
            applyUserLocation(lastKnownUserCoords);
        } else {
            console.warn("No known user location to fall back to.");
            locatePinPositionBasedClick();
        }
    }, 1000);

    navigator.geolocation.getCurrentPosition(
        (position) => {
            if (fallbackTriggered) return; // already fell back

            clearTimeout(fallbackTimeout);

            const coords = [position.coords.longitude, position.coords.latitude];
            lastKnownUserCoords = coords;

            const isSwitching = (locationTypeAction !== locationTypeActionNew);
            locationTypeAction = "UserPositionBased";

            if (isSwitching) {
                toggleSelectionButtons("User");
                startOrUpdateLocating();
                // updateCameraStatusIfWithinDistance();
                waitForUserMarkerThenUpdateCamera();
                clearLocationActionUI();
            } else {
                startOrUpdateLocating();
                // updateCameraStatusIfWithinDistance();
                waitForUserMarkerThenUpdateCamera();
            }
        },
        () => {
            if (fallbackTriggered) return;
            clearTimeout(fallbackTimeout);

            toggleSelectionButtons("User");
            locationTypeAction = "UserPositionBased";
            clearLocationActionUI();
            showErrorMessage("enable location services");

            setTimeout(() => {
                locatePinPositionBasedClick();
            }, 1000);
        },
        {
            enableHighAccuracy: false,
            timeout: 10000,
            maximumAge: 0
        }
    );
}

function locatePinPositionBasedClick() {
    locationTypeActionNew = "PinBased";

    UrbanFutureLocationPinButton.style.backgroundColor = "#F9D235";
    UrbanFutureLocationButton.style.backgroundColor = "#FCEFC7";
    document.getElementById("StartIncompleteMessage").innerHTML = "remote participation";

    const isSwitching = (locationTypeAction !== locationTypeActionNew);
    locationTypeAction = "PinBased";

    if (isSwitching) {
        toggleSelectionButtons("Pin");
        disableCameraFunction();
        ProjectReCenter();
        clearLocationActionUI();
    } else {
        disableCameraFunction();
        ProjectReCenter();
    }
}

// === Utility Functions: ===

function waitForUserMarkerThenUpdateCamera(retries = 8) {
    try {
        if (
            userMarker &&
            typeof userMarker.getLngLat === "function" &&
            userMarker.getLngLat() &&
            typeof userMarker.getLngLat().lng === "number"
        ) {
            updateCameraStatusIfWithinDistance();
        } else if (retries > 0) {
            setTimeout(() => waitForUserMarkerThenUpdateCamera(retries - 1), 300);
        } else {
            console.warn("userMarker never became valid for camera check.");
        }
    } catch (e) {
        console.warn("Error in waitForUserMarkerThenUpdateCamera():", e);
    }
}

function applyUserLocation(coords) {
    if (!coords) return;

    // Set userMarker if needed or fly camera there
    if (userMarker) {
        userMarker.setLngLat(coords);
    } else {
        // Create marker if not available
        userMarker = new mapboxgl.Marker().setLngLat(coords).addTo(map);
    }

    map.flyTo({ center: coords, zoom: 16 });

    toggleSelectionButtons("User");
    startOrUpdateLocating();
    // updateCameraStatusIfWithinDistance();
    waitForUserMarkerThenUpdateCamera();
    clearLocationActionUI();
    locationTypeAction = "UserPositionBased";
}

function toggleSelectionButtons(type) {
    const userBtn = document.getElementById("UrbanFutureLocateUser");
    const pinBtn = document.getElementById("UrbanFutureLocatePin");

    if (type === "User") {
        userBtn.classList.add("SelectdToggleButton");
        pinBtn.classList.remove("SelectdToggleButton");
    } else {
        pinBtn.classList.add("SelectdToggleButton");
        userBtn.classList.remove("SelectdToggleButton");
    }
}

function startOrUpdateLocating() {
    if (locatingEnabled) {
        UpdateLocationToUser();
    } else {
        startLocating();
    }
}

function updateCameraStatusIfWithinDistance() {
    try {
        if (!userMarker || typeof userMarker.getLngLat !== "function") {
            console.warn("userMarker is not ready or invalid.");
            return;
        }

        const lngLat = userMarker.getLngLat();

        if (!lngLat || typeof lngLat.lng !== "number" || typeof lngLat.lat !== "number") {
            console.warn("userMarker.getLngLat() returned invalid value:", lngLat);
            return;
        }

        const userCoords = [lngLat.lng, lngLat.lat];
        const targetCoords = [18.6732, 50.2916];
        const distance = getDistanceInKm(userCoords, targetCoords);

        console.log("Distance to target:", distance);

        if (distance <= 2.79) {
            document.getElementById("UFParticipationIcon").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CameraIcon.png";
            document.getElementById("UrbanFutureParticipationPhotoCoinIcon").style.display = "block";
            cameraFunctionActive = true;
        }
    } catch (e) {
        console.warn("Error in updateCameraStatusIfWithinDistance():", e);
    }
}

function disableCameraFunction() {
    document.getElementById("UFParticipationIcon").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CameraIconGrey.png";
    document.getElementById("UrbanFutureParticipationPhotoCoinIcon").style.display = "none";
    cameraFunctionActive = false;
}

function clearLocationActionUI() {
    whiteFrame();
    hideElement(document.getElementById("BotomActionsUrbanReaction"));
    hideElement(document.getElementById("BotomActionsUrbanComment"));
    hideElement(document.getElementById("BotomActionsUrbanPhoto"));
    hideElement(document.getElementById("UrbanFutureConfirmLocation"));
}

function getDistanceInKm(coord1, coord2) {
    const R = 6371;
    const toRad = deg => deg * (Math.PI / 180);

    const [lon1, lat1] = coord1;
    const [lon2, lat2] = coord2;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a = Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

function ProjectReCenter() {
    const cameraMoveTo = {
        zoom: 16,
        pitch: 45,
        bearing: 0,
        center: [18.6656, 50.2941] // for Gliwice
    };

    flyTowards(cameraMoveTo);
}

function centerUpdatePin() {
    const coordinates = PlacKrakowskiDropPinMarker.getLngLat();
    const screenPoint = map.project(coordinates);

    screenPoint.y += 30; // offset down by 30px

    const offsetCenter = map.unproject(screenPoint);

    const cameraMoveTo = {
        zoom: 16.5,
        pitch: 0,
        bearing: 0,
        center: [offsetCenter.lng, offsetCenter.lat]
    };

    flyTowards(cameraMoveTo);
}




function loadPinQuestionImages() {
    // Load images
    if (map.hasImage('IconLike') && map.hasImage('IconDislike') && map.hasImage('IconIdentity') && map.hasImage('IconActivity')) {
        addPinQuestions();
        return;
    } else {
        map.loadImage('./res/map/IconLike.png', (error, image) => {
            if (error) throw error;
            map.addImage('IconLike', image);
            addPinQuestions();
        });

        map.loadImage('./res/map/IconDislike.png', (error, image) => {
            if (error) throw error;
            map.addImage('IconDislike', image);
            addPinQuestions();
        });
        map.loadImage('./res/map/IconIdentity.png', (error, image) => {
            if (error) throw error;
            map.addImage('IconIdentity', image);
            addPinQuestions();
        });
        map.loadImage('./res/map/IconActivity.png', (error, image) => {
            if (error) throw error;
            map.addImage('IconActivity', image);
            addPinQuestions();
        });
    }

}

function addPinQuestions() {
    QuestionImagesLoaded++;
    if (QuestionImagesLoaded >= 4) {



        if (!map.getSource('PinQuestions')) {
            map.addSource('PinQuestions', {
                'type': 'geojson',
                'data': PinQuestions
            });
        }
        if (!map.getLayer('PinQuestions')) {
            map.addLayer({
                'id': 'PinQuestions',
                'type': 'symbol',
                'source': 'PinQuestions',
                'layout': {
                    'icon-image': [
                        'case',
                        ['==', ['get', 'icon'], 'IconLike'], 'IconLike',
                        ['==', ['get', 'icon'], 'IconDislike'], 'IconDislike',
                        ['==', ['get', 'icon'], 'IconIdentity'], 'IconIdentity',
                        ['==', ['get', 'icon'], 'IconActivity'], 'IconActivity',
                        'logo1'
                    ],
                    'icon-size': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        11, 0.005,     // At zoom 9 → size 0.1
                        17, 0.10    // At zoom 16 → size 0.25
                    ],
                    'icon-padding': 0,
                    'icon-allow-overlap': true
                }
            });
        }




        map.on('click', 'PinQuestions', (e) => {
            // map.getCanvas().style.cursor = 'pointer';
            popupQuestions.remove();

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const question = e.features[0].properties.question;
            selectedQuestion = e.features[0].properties.title;



            //         'properties': {
            //   'title': 'Pytania_Otwarte_01',
            //   'icon': 'IconLike',
            //   'question': 'Czym Plac Cię zachęca? Które elementy są dla Ciebie ważne?',
            //   "origin":[18.6737,50.2926],
            //   "cameraReset":{
            //     center: [18.6737,50.2926],
            //     zoom: 16.00,
            //     bearing: 45,
            //     pitch:45,
            //   },

            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            // map.stop();

            setTimeout(() => {
                map.flyTo({
                    center: coordinates,
                    zoom: 16.5,
                    pitch: 45,
                    bearing: 0,
                    essential: true,
                    duration: 1000,
                });
            }, 50);



            popupQuestions
                .setLngLat(coordinates)
                .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>${e.features[0].properties.question}</h3>
                        </div>

                        <div>
                            <textarea placeholder="twoja odpowiedź..." rows="2" id="questionAnswer-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionComment QuestionFinalize" autocomplete="off" tabindex="-1"></textarea>
                        </div>

                        <div class="UrbanFutureReactionFinalize QuestionFinalize">
                            <button id="closeQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionsClose UrbanFutureReactions">zamknij!</button>
                            <div class="marginUrbanFuture"></div>
                            <button id="submitQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionsSubmit UrbanFutureReactions">zapisz!</button>
                        </div>
                    `)
                .addTo(map);

            map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'none');
            map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'none');
            map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'none');



            const textarea = document.getElementById(`questionAnswer-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
            if (document.activeElement === textarea) {
                textarea.blur();
            }
            // document.getElementsByClassName("questionTitleDiv")[0].click();
            // document.getElementsByClassName("questionTitleDiv")[0].focus();

            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');

            const enterButton = document.getElementById(`submitQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
            const closeButton = document.getElementById(`closeQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}`);


            if (enterButton) {
                enterButton.addEventListener('click', () => {
                    dataToSubmit.open_question_name = selectedQuestion;
                    dataToSubmit.open_question_answer = textarea.value && textarea.value.trim() !== "" ? textarea.value : "-";
                    submitOpenQuestionResponse(dataToSubmit);
                    map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
                    map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
                    map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');
                });
            }
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    popupQuestions.remove();
                    map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
                    map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
                    map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');

                });
            }


            popupReactions.remove();
            popupContent.classList.add("openQuestions");
            popupTip.classList.add("openQuestions");


            popupContent.classList.remove("reactionsPopUp");
            popupTip.classList.remove("reactionsPopUp");

            popupContent.classList.remove("ParticipateAppPopUp");
            popupTip.classList.remove("ParticipateAppPopUp");

            popupContent.classList.remove("Rating0");
            popupContent.classList.remove("Rating1");
            popupContent.classList.remove("Rating2");
            popupContent.classList.remove("Rating3");
            popupContent.classList.remove("Rating4");
            popupContent.classList.remove("Rating5");

            popupContent.classList.remove("maquetteInDevelopment");
            popupTip.classList.remove("maquetteInDevelopment");
            popupContent.classList.remove("activeMaquette");
            popupTip.classList.remove("activeMaquette");


        });

        map.on('touchstart', 'PinQuestions', (e) => {
            if (multitouchDetected == false && raycast == true) {
                // map.getCanvas().style.cursor = 'pointer';
                popupQuestions.remove();

                // selectedProject = e.features[0];
                const coordinates = e.features[0].geometry.coordinates.slice();
                const question = e.features[0].properties.question;
                selectedQuestion = e.features[0].properties.title;



                //         'properties': {
                //   'title': 'Pytania_Otwarte_01',
                //   'icon': 'IconLike',
                //   'question': 'Czym Plac Cię zachęca? Które elementy są dla Ciebie ważne?',
                //   "origin":[18.6737,50.2926],
                //   "cameraReset":{
                //     center: [18.6737,50.2926],
                //     zoom: 16.00,
                //     bearing: 45,
                //     pitch:45,
                //   },

                if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }
                }

                // map.stop();

                setTimeout(() => {
                    map.flyTo({
                        center: coordinates,
                        zoom: 16.5,
                        pitch: 45,
                        bearing: 0,
                        essential: true,
                        duration: 1000,
                    });
                }, 50);



                popupQuestions
                    .setLngLat(coordinates)
                    .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>${e.features[0].properties.question}</h3>
                        </div>

                        <div>
                            <textarea placeholder="twoja odpowiedź..." rows="2" id="questionAnswer-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionComment QuestionFinalize" autocomplete="off" tabindex="-1"></textarea>
                        </div>

                        <div class="UrbanFutureReactionFinalize QuestionFinalize">
                            <button id="closeQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionsClose UrbanFutureReactions">zamknij!</button>
                            <div class="marginUrbanFuture"></div>
                            <button id="submitQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionsSubmit UrbanFutureReactions">zapisz!</button>
                        </div>
                    `)
                    .addTo(map);

                map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'none');
                map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'none');
                map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'none');



                const textarea = document.getElementById(`questionAnswer-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
                if (document.activeElement === textarea) {
                    textarea.blur();
                }
                // document.getElementsByClassName("questionTitleDiv")[0].click();
                // document.getElementsByClassName("questionTitleDiv")[0].focus();

                const popupContent = document.querySelector('.mapboxgl-popup-content');
                const popupTip = document.querySelector('.mapboxgl-popup-tip');

                const enterButton = document.getElementById(`submitQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
                const closeButton = document.getElementById(`closeQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}`);


                if (enterButton) {
                    enterButton.addEventListener('click', () => {
                        dataToSubmit.open_question_name = selectedQuestion;
                        dataToSubmit.open_question_answer = textarea.value && textarea.value.trim() !== "" ? textarea.value : "-";
                        submitOpenQuestionResponse(dataToSubmit);
                        map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
                        map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
                        map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');
                    });
                }
                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        popupQuestions.remove();
                        map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
                        map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
                        map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');

                    });
                }


                popupReactions.remove();
                popupContent.classList.add("openQuestions");
                popupTip.classList.add("openQuestions");


                popupContent.classList.remove("reactionsPopUp");
                popupTip.classList.remove("reactionsPopUp");

                popupContent.classList.remove("ParticipateAppPopUp");
                popupTip.classList.remove("ParticipateAppPopUp");

                popupContent.classList.remove("Rating0");
                popupContent.classList.remove("Rating1");
                popupContent.classList.remove("Rating2");
                popupContent.classList.remove("Rating3");
                popupContent.classList.remove("Rating4");
                popupContent.classList.remove("Rating5");

                popupContent.classList.remove("maquetteInDevelopment");
                popupTip.classList.remove("maquetteInDevelopment");
                popupContent.classList.remove("activeMaquette");
                popupTip.classList.remove("activeMaquette");
            }

        });


        map.on('mouseleave', 'PinQuestions', () => {
            map.getCanvas().style.cursor = '';
        });
        map.on('mouseenter', 'PinQuestions', () => {
            map.getCanvas().style.cursor = 'pointer';
        });
    }
}


function addInfomationPopup() {

    if (locationTypeAction == "PinBased") {




        const coordinates = PlacKrakowskiDropPinMarker.getLngLat();


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }



        popupParticipateApp
            .setLngLat(coordinates)
            .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>ustaw pinezkę w miejscu w którym chcesz zapisać reakcję</h3>
                        </div>
                    `)
            .addTo(map);



        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');




        popupReactions.remove();
        popupContent.classList.add("ParticipateAppPopUp");
        popupTip.classList.add("ParticipateAppPopUp");

        popupContent.classList.remove("reactionsPopUp");
        popupTip.classList.remove("reactionsPopUp");

        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");




    } else {
        const coordinates = userMarker.getLngLat();


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }



        popupParticipateApp
            .setLngLat(coordinates)
            .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>twoja reakcja zostanie zapisana w miejscu twojej lokalizacji</h3>
                        </div>
                    `)
            .addTo(map);



        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');


        popupReactions.remove();
        popupContent.classList.add("ParticipateAppPopUp");
        popupTip.classList.add("ParticipateAppPopUp");

        popupContent.classList.remove("reactionsPopUp");
        popupTip.classList.remove("reactionsPopUp");

        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");

        setTimeout(() => {
            popupParticipateApp.remove()
        }, 3000)



    }

}

function showErrorMessage(message) {
    showElement(document.getElementById("ErrorMessageDiv"));
    document.getElementById("ErrorMessageDiv").innerHTML = message;

    document.getElementById("AnalyticsTriggerButton").style.top = "130px"

    setTimeout(() => {
        hideElement(document.getElementById("ErrorMessageDiv"));
        document.getElementById("ErrorMessageDiv").innerHTML = "";
        document.getElementById("AnalyticsTriggerButton").style.top = "105px"

    }, 2500)

}
function showSuccessMessage(message) {
    showElement(document.getElementById("ErrorMessageDiv"));
    document.getElementById("ErrorMessageDiv").innerHTML = message;
    document.getElementById("AnalyticsTriggerButton").style.top = "130px"

    setTimeout(() => {
        hideElement(document.getElementById("ErrorMessageDiv"));
        document.getElementById("ErrorMessageDiv").innerHTML = "";
        document.getElementById("AnalyticsTriggerButton").style.top = "105px"

    }, 3500)

}







function switchMapStyle(styleUrl) {
    // Save camera state
    const camera = {
        center: map.getCenter(),
        zoom: map.getZoom(),
        bearing: map.getBearing(),
        pitch: map.getPitch()
    };

    // Switch map style
    map.setStyle(styleUrl);

    map.once('style.load', function () {
        imagesLoaded = 0;
        // Restore camera position
        map.jumpTo(camera);

        // Re-add necessary sources
        if (!map.getSource('UrbanFuture-region-boundary')) {
            map.addSource('UrbanFuture-region-boundary', {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: [projectAreaCoordinates]
                    }
                }
            });
        }

        if (!map.getSource('UrbanFuture-walk-path')) {
            map.addSource('UrbanFuture-walk-path', {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: [[
                            [4.415196678145662, 51.906970462672916],
                            [4.419091791795466, 51.906221459833034],
                            [4.4201109758257076, 51.90782519224152],
                            [4.4205451043420965, 51.908491942512626],
                            [4.420463877984844, 51.908527147160925],
                            [4.424592864183268, 51.91252814767134],
                            [4.4139492202727695, 51.91318137208694],
                            [4.411710313328825, 51.91098319495117],
                            [4.414031990134092, 51.908050872443596],
                            [4.4142608062008435, 51.90812499267457],
                            [4.415196678145662, 51.906970462672916]
                        ]]
                    }
                }
            });
        }


        // Re-add layers if needed
        if (!map.getLayer('UrbanFuture-walk-path')) {
            map.addLayer({
                id: 'UrbanFuture-walk-path',
                type: 'line',
                source: 'UrbanFuture-walk-path',
                layout: {},
                paint: {
                    'line-color': '#d0af2d',
                    'line-width': 3,
                    'line-dasharray': [2, 2]
                }
            });
        }
        if (!map.getLayer('UrbanFuture-walk-fill')) {
            map.addLayer({
                id: 'UrbanFuture-walk-fill',
                type: 'fill',
                source: 'UrbanFuture-walk-path',
                layout: {},
                paint: {
                    'fill-color': '#ffffff',
                    'fill-opacity': 0.2
                }
            });
        }

        if (!map.getLayer('UrbanFuture-region-fill')) {
            map.addLayer({
                id: 'UrbanFuture-region-fill',
                type: 'fill',
                source: 'UrbanFuture-region-boundary',
                layout: {},
                paint: {
                    'fill-color': '#f9d235',
                    'fill-opacity': 0.1
                }
            });
        }

        if (!map.getLayer('UrbanFuture-region-outline')) {
            map.addLayer({
                id: 'UrbanFuture-region-outline',
                type: 'line',
                source: 'UrbanFuture-region-boundary',
                layout: {},
                paint: {
                    'line-color': '#f9d235',
                    'line-width': 2
                }
            });
        }



        if (!map.getSource('eraser')) {

            // clip layer (eraser)
            map.addSource('eraser', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: [
                        {
                            type: 'Feature',
                            properties: {},
                            geometry: {
                                type: 'Polygon',
                                coordinates: [projectRemove3DElements
                                ]
                            }
                        }
                    ]
                }
            });


        }

        if (!map.getLayer('eraser')) {
            map.addLayer({
                id: 'eraser',
                type: 'clip',
                source: 'eraser',
                layout: { 'clip-layer-types': ['symbol', 'model'] }
            });
        }


        function checkImagesLoaded() {
            // console.log("running check images loaded!")
            imagesLoaded++;
            if (imagesLoaded >= 2) { // Number of images
                // Add the source and layer after images are loaded
                map.addSource('PTProjects', {
                    'type': 'geojson',
                    'data': PublicTwinProjects
                });

                map.addLayer({
                    'id': 'PTProjects',
                    'type': 'symbol',
                    'source': 'PTProjects',
                    'layout': {
                        'icon-image': [
                            'case',
                            ['==', ['get', 'activeStatus'], 'maquetteInDevelopment'], 'logo2',
                            ['==', ['get', 'activeStatus'], 'activeMaquette'], 'logo1',
                            'logo1'
                        ],
                        'icon-size': 0.025,
                        'icon-padding': 0,
                        'icon-allow-overlap': true
                    }
                });

                map.moveLayer("PTProjects")
                zoomLevelCheck(camera.zoom);
            }
        }
        // console.log(PublicTwinProjects);

        // Load images
        map.loadImage('./res/map/PublicTwin_Marker_Logo_Yellow.png', (error, image) => {
            if (error) throw error;
            map.addImage('logo1', image);
            checkImagesLoaded();
        });

        map.loadImage('./res/map/PublicTwin_Marker_Logo_Grey.png', (error, image) => {
            if (error) throw error;
            map.addImage('logo2', image);
            checkImagesLoaded();
        });










    });

    reAddCustom3DModels();
}




document.getElementById("BottomStyleSwitch").addEventListener("click", function () {
    if (modelTypeSelection == "3Dmodel") {
        switchToSatelite();

    } else {
        switchTo3DModel();
    }

})

function switchToSatelite() {
    switchMapStyle('mapbox://styles/dripvisual/cmboqxo4600u301s594k89ie0')
    modelTypeSelection = "Satelite";

    document.getElementById("UrbanFutureSateliteMap").classList.add("SelectdToggleButton")
    while (document.getElementById("UrbanFuture3DmodelMap").classList.contains("SelectdToggleButton")) {
        document.getElementById("UrbanFuture3DmodelMap").classList.remove("SelectdToggleButton")
    }
}
function switchTo3DModel() {
    switchMapStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u')
    modelTypeSelection = "3Dmodel";
    document.getElementById("UrbanFuture3DmodelMap").classList.add("SelectdToggleButton")
    while (document.getElementById("UrbanFutureSateliteMap").classList.contains("SelectdToggleButton")) {
        document.getElementById("UrbanFutureSateliteMap").classList.remove("SelectdToggleButton")
    }
}



document.getElementById("SwitchToLogin").addEventListener("click", function () {

    toggleLogInFunctionUF();

})
document.getElementById("SwitchToRegister").addEventListener("click", function () {

    toggleSignUpFunctionUF();

})
document.getElementById("forgotPasswordUF").addEventListener("click", function () {

    toggleRemindFunctionUF();

})
document.getElementById("forgotPasswordLoginUF").addEventListener("click", function () {

    toggleLogInFunctionUF();

})



//SignUp/Login Menu Toggles:
function toggleLogInFunctionUF() {
    // console.log("toggle Log In!");
    document.getElementById("menuSignUpDivUF").style.display = "none";
    document.getElementById("menuLogInDivUF").style.display = "block";
    document.getElementById("passwordResetRequestDivUF").style.display = "none";
    document.getElementById("passwordResetDivUF").style.display = "none";

}
function toggleRemindFunctionUF() {
    document.getElementById("menuSignUpDivUF").style.display = "none";
    document.getElementById("menuLogInDivUF").style.display = "none";
    document.getElementById("passwordResetRequestDivUF").style.display = "block";
}
function toggleSignUpFunctionUF() {
    // console.log("toggle Sign Up!");
    document.getElementById("menuSignUpDivUF").style.display = "block";
    document.getElementById("menuLogInDivUF").style.display = "none";
    document.getElementById("passwordResetRequestDivUF").style.display = "none";
    document.getElementById("passwordResetDivUF").style.display = "none";
}
function toggleRemindTokenFunctionUF() {
    document.getElementById("menuSignUpDivUF").style.display = "none";
    document.getElementById("menuLogInDivUF").style.display = "none";
    document.getElementById("passwordResetRequestDivUF").style.display = "none";
    document.getElementById("passwordResetDivUF").style.display = "block";

}



//login actions PublicTwin Participate App:


document.getElementById('menuSignUpFormUF').addEventListener('submit', function (event) {
    event.preventDefault();

    const formData = new FormData(this);
    formData.append('user_role', '-');

    const password = String(formData.get('password'));
    const confirmPassword = String(formData.get('confirm_password'));
    const areEqual = password === confirmPassword;
    const signUpMessage = document.getElementById('signUpMessageUF');

    // Client-side wachtwoordcontrole (zelfde regels als server)
    function validatePassword(pw) {
        const hasUpperCase = /[A-Z]/.test(pw);
        const hasDigit = /\d/.test(pw);
        return pw.length >= 8 && hasUpperCase && hasDigit;
    }
    const isPasswordValid = validatePassword(password);

    if (!isPasswordValid) {
        signUpMessage.style.color = 'red';
        signUpMessage.innerText = 'Wachtwoord moet minstens 8 tekens bevatten, één hoofdletter en één cijfer.';
        return;
    }

    if (!areEqual) {
        signUpMessage.style.color = 'red';
        signUpMessage.innerText = 'Wachtwoorden komen niet overeen!';
        return;
    }

    // Helper: vertaal bekende serverberichten naar NL
    const toDutch = (msg) => {
        switch (msg) {
            case 'Sign up successful!':
                return 'Registratie gelukt!';
            case 'Email is already in use!':
                return 'Er bestaat al een gebruiker met dit e-mailadres!';
            case 'Passwords do not match!':
                return 'Wachtwoorden komen niet overeen!';
            case 'Password does not meet complexity requirements':
                return 'Wachtwoord moet minstens 8 tekens bevatten, één hoofdletter en één cijfer.';
            case 'Registration failed!':
                return 'Registratie mislukt. Probeer het opnieuw.';
            case 'Invalid email address':
                return 'Ongeldig e-mailadres.';
            case 'Server error':
                return 'Er is een serverfout opgetreden. Probeer het later opnieuw.';
            default:
                return msg || 'Er is iets misgegaan.';
        }
    };

    fetch('https://publictwin.info/digital_maquette/php_scripts/registerEngagement.php', {
        method: 'POST',
        body: formData,
        credentials: 'include'
    })
        .then(async (response) => {
            // Probeer JSON te lezen, ook bij non-2xx
            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
                const msg = toDutch(data.message);
                throw new Error(msg);
            }
            return data;
        })
        .then((data) => {
            if (data.success) {
                signUpMessage.style.color = 'green';
                signUpMessage.innerText = toDutch(data.message);

                setTimeout(function () {
                    if (window.self !== window.top) {
                        // In een iframe
                        try {
                            window.parent.postMessage({
                                type: 'userLoggedIn',
                                payload: {
                                    user_id: data.user.user_id,
                                    email: data.user.email,
                                    role: data.user.user_role,
                                    user_permissions: data.user.user_permissions,
                                    project_permissions: data.user.project_permissions,
                                }
                            }, '*');
                        } catch {
                            // noop
                        }
                    } else {
                        // Top-level
                        checkLoginStatus();
                    }
                }, 500);
            } else {
                signUpMessage.style.color = 'red';
                signUpMessage.innerText = toDutch(data.message);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            signUpMessage.style.color = 'red';
            signUpMessage.innerText = error.message || 'Coś poszło nie tak.';
        });

    posthog.capture('userSignUp');
});



// --- LOGIN ---
document.getElementById('menuLogInFormUF').addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    const loginMessage = document.getElementById('loginMessageUF');

    fetch('https://publictwin.info/digital_maquette/php_scripts/login.php', {
        method: 'POST',
        body: formData,
        credentials: 'include',
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                loginMessage.style.color = 'green';
                loginMessage.innerText = 'Pomyślnie zalogowano!';

                setTimeout(function () {
                    if (window.self !== window.top) {
                        // In iframe → inform parent
                        try {
                            window.parent.postMessage({
                                type: 'userLoggedIn',
                                payload: {
                                    user_id: data.user.user_id,
                                    email: data.user.email,
                                    role: data.user.user_role,
                                    user_permissions: data.user.user_permissions,
                                    project_permissions: data.user.project_permissions,
                                }
                            }, '*');
                        } catch { }
                    } else {
                        // Top-level
                        checkLoginStatus();
                    }
                }, 500);

            } else {
                loginMessage.style.color = 'red';
                if (data.message === 'Login failed, incorrect password!') {
                    loginMessage.innerText = 'Nieprawidłowe hasło! Spróbuj ponownie.';
                } else {
                    loginMessage.innerText = data.message || 'Logowanie nie powiodło się.';
                }
            }
        })
        .catch(error => {
            console.error('Error:', error);
            loginMessage.style.color = 'red';
            loginMessage.innerText = 'Logowanie nie powiodło się. Spróbuj ponownie.';
        });

    posthog.capture('userLogin');
});


// --- PASSWORD RESET REQUEST (send link) ---
document.getElementById('passwordResetRequestFormUF').addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(this);

    // Include the page we’re on, so the email link comes back here
    formData.append('return_url', window.location.href);

    // Preserve activeProject if present
    const urlParams = new URLSearchParams(window.location.search);
    const activeProject = urlParams.get('activeProject') || '';
    if (activeProject) formData.append('activeProject', activeProject);

    // Determine language: from URL (?lang=pl), or fallback to 'en'
    const lang = (urlParams.get('lang') || 'pl').toLowerCase();
    formData.append('lang', (lang === 'pl') ? 'pl' : 'pl');

    fetch('https://publictwin.info/digital_maquette/php_scripts/password_Reset_EngagementPrototypes.php', {
        method: 'POST',
        body: formData
    })
        .then(r => r.json())
        .then(data => {
            const resetMessage = document.getElementById('resetRequestMessageUF');
            resetMessage.style.color = data.success ? 'green' : 'red';
            resetMessage.innerText = data.message || (data.success
                ? (lang === 'pl'
                    ? 'Wysłano link do zresetowania hasła na Twój e-mail.'
                    : 'A password reset link has been sent to your email.')
                : (lang === 'pl'
                    ? 'Wysłanie e-maila nie powiodło się. Spróbuj ponownie.'
                    : 'Failed to send the email. Please try again.'));
        })
        .catch(() => {
            const resetMessage = document.getElementById('resetRequestMessageUF');
            resetMessage.style.color = 'red';
            resetMessage.innerText = (lang === 'pl')
                ? 'Wysłanie e-maila nie powiodło się. Spróbuj ponownie.'
                : 'Failed to send the email. Please try again.';
        });
});



// --- PASSWORD RESET (set new password) ---
document.getElementById('passwordResetFormUF').addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(this);
    const resetMessage = document.getElementById('resetMessageUF');
    const newPassword = document.getElementById('newPasswordUF').value;
    const confirmPassword = document.getElementById('confirmNewPasswordUF').value;

    // Validatie: minimaal 8, hoofdletter, cijfer
    if (newPassword.length < 8 || !/[A-Z]/.test(newPassword) || !/[0-9]/.test(newPassword)) {
        resetMessage.style.color = 'red';
        resetMessage.innerText = 'Hasło musi zawierać co najmniej 8 znaków, jedną wielką literę i cyfrę!';
        return;
    }
    if (newPassword !== confirmPassword) {
        resetMessage.style.color = 'red';
        resetMessage.innerText = 'Hasła nie są takie same!';
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/reset_password.php', {
        method: 'POST',
        body: formData,
        credentials: 'include',
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                resetMessage.style.color = 'green';
                resetMessage.innerText =
                    (data.message === 'Password has been reset successfully.')
                        ? 'Nowe hasło zostało zapisane!'
                        : (data.message || 'Nowe hasło zostało zapisane!');
                setTimeout(function () {
                    checkLoginStatus();
                    toggleLogInFunctionUF();
                }, 800);
            } else {
                resetMessage.style.color = 'red';
                if (data.message === 'Invalid or expired token.') {
                    resetMessage.innerText = 'Twój link do resetowania hasła wygasł!';
                } else {
                    resetMessage.innerText = data.message || 'Resetowanie nie powiodło się.';
                }
            }
        });

    posthog.capture('passwordReset');
});



document.getElementById("togglePasswordUF").addEventListener('click', () => {
    const password = document.querySelector('#passwordUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordUF").classList.toggle("bi-eye");
});

document.getElementById("togglePasswordConfirmUF").addEventListener('click', () => {
    const password = document.querySelector('#confirm_passwordUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordConfirmUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordConfirmUF").classList.toggle("bi-eye");
});


document.getElementById("togglePasswordLoginUF").addEventListener('click', () => {
    const password = document.querySelector('#passwordLogInUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordLoginUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordLoginUF").classList.toggle("bi-eye");
});


document.getElementById("togglePasswordResetUF").addEventListener('click', () => {
    const password = document.querySelector('#newPasswordUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordResetUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordResetUF").classList.toggle("bi-eye");
});

document.getElementById("togglePasswordResetConfirmUF").addEventListener('click', () => {
    const password = document.querySelector('#confirmNewPasswordUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordResetConfirmUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordResetConfirmUF").classList.toggle("bi-eye");
});


const cancelResetBtn = document.getElementById('cancelPasswordResetUF');
if (cancelResetBtn) {
    cancelResetBtn.addEventListener('click', () => {
        PasswordReset = false; // turn off reset mode
        // Show regular login view
        document.getElementById("menuSignUpDivUF").style.display = "none";
        document.getElementById("menuLogInDivUF").style.display = "block";
        document.getElementById("passwordResetRequestDivUF").style.display = "none";
        document.getElementById("passwordResetDivUF").style.display = "none";
        document.getElementById("userPanelUF").style.display = "none";

        // (Optional) remove token from URL so the page doesn't re-enter reset mode on refresh
        try {
            const url = new URL(window.location.href);
            url.searchParams.delete('token');
            history.replaceState({}, '', url.toString());
        } catch { }
    });
}

document.getElementById('UrbanFutureLoginButton').addEventListener('click', function () {
    // document.getElementById("UrbanFutureTopNavbarSelectOptions").click();

    let status = document.getElementById("UrbanFutureLoginButton").getAttribute("loggedInStatus");
    console.log(status); // "false" or "true"

    if (status == "false") {


        document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UserLoginMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UserLoginMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone")
        }

        document.getElementById("menuSignUpDivUF").style.display = "none";
        document.getElementById("menuLogInDivUF").style.display = "block";
        document.getElementById("passwordResetRequestDivUF").style.display = "none";
        document.getElementById("passwordResetDivUF").style.display = "none";
        document.getElementById("userPanelUF").style.display = "none";

        document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display = "none";
    }
    else {
        console.log("showing account panel");

        document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UserLoginMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UserLoginMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone")
        }

        document.getElementById("menuSignUpDivUF").style.display = "none";
        document.getElementById("menuLogInDivUF").style.display = "none";
        document.getElementById("passwordResetRequestDivUF").style.display = "none";
        document.getElementById("passwordResetDivUF").style.display = "none";
        document.getElementById("userPanelUF").style.display = "block";


        document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display = "none";
    }


    try {
        const urlParams = new URLSearchParams(window.location.search);
        let resetToken = urlParams.get('token');
        if (resetToken) {
            document.getElementById("menuSignUpDivUF").style.display = "none";
            document.getElementById("menuLogInDivUF").style.display = "none";
            document.getElementById("passwordResetRequestDivUF").style.display = "none";
            document.getElementById("passwordResetDivUF").style.display = "block";
            document.getElementById("userPanelUF").style.display = "none";


        }

    } catch {
        console.log("no reset token found");
    }

});

document.getElementById("logoutButtonUF").addEventListener('click', function () {


    if (window.self !== window.top) {
        // This is running in an iframe
        try {
            window.parent.postMessage({
                type: 'userLoggedOut',
                payload: {
                    user_id: "none"
                }
            }, '*');
        } catch {

        }

    } else {

    }
    // Get the current URL
    var currentUrl = window.location.href;

    // Encode the URL to make it safe to pass as a query parameter
    var encodedUrl = encodeURIComponent(currentUrl);

    // Redirect to the PHP script with the current URL as a parameter
    window.location.href = 'https://publictwin.info/digital_maquette/php_scripts/logout.php?current_url=' + encodedUrl;

    setTimeout(
        checkLoginStatus(), 500
    )


});
document.getElementById("deleteAccountButtonUF").addEventListener('click', function () {
    console.log("deleting user account!");
    showElement(document.getElementById("confirmUserDelete"));
    document.getElementById("userPanelUF").style.display = "none";
    // hideElement(document.getElementById("userPanelUF"));
});
document.getElementById("UrbanFutureConfirmDelete").addEventListener('click', function () {
    console.log("confirming deleting user account!");
    deleteUser();

});
document.getElementById("UrbanFutureDeleteBack").addEventListener('click', function () {
    hideElement(document.getElementById("confirmUserDelete"));
    document.getElementById("userPanelUF").style.display = "block";
    // showElement(document.getElementById("userPanelUF"));
});



document.getElementById("AnalyticsTriggerButton").addEventListener('click', function () {
    if (adminPanel.classList.contains("UrbanFutureDisplayNone")) {
        adminPanel.classList.remove("UrbanFutureDisplayNone");
        openAdminPanel();

        hideElement(document.getElementById("BotomActionsUrbanPhoto"));
        hideElement(document.getElementById("BotomActionsUrbanReaction"));
        hideElement(document.getElementById("BotomActionsUrbanComment"));
        hideElement(document.getElementById("UrbanFutureConfirmLocation"));
        hideElement(document.getElementById("FunctionalitiesIntroMenu"));
        endPinPlacKrakowskifFunction();
        whiteFrame();
    } else {
        adminPanel.classList.add("UrbanFutureDisplayNone")
    }

    if (userPermissionsStatus == "KOM" || userPermissionsStatus == "admin" || userProjectPermissionsStatus.includes("PKrak")) {
        showElement(document.getElementById("reactionsFilteringSystem"));
    } else {
        hideElement(document.getElementById("reactionsFilteringSystem"));
    }
});

document.getElementById("CloseAnalyticsMenuUF").addEventListener('click', function () {
    adminPanel.classList.add("UrbanFutureDisplayNone")
});


document.getElementById("CloseUserPanel").addEventListener('click', function () {
    document.getElementById("UrbanFutureTopNavbarSelectOptions").click();
});

window.addEventListener("message", function (event) {
    if (event.data && event.data.type === 'loginStatus') {
        const user = event.data.user;
        checkLoginStatus(true, user);
        // console.log(user);
    }

});

function deleteUser() {
    const userId = sessionStorage.getItem('loginUserID');

    if (!userId || userId === "none") {
        console.warn("User ID missing; cannot delete.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/delete_user.php', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `user_id=${encodeURIComponent(userId)}`
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                console.log("User deleted.");
                document.getElementById("logoutButtonUF").click();

            } else {
                console.warn("Delete failed:", data.message);
            }
        })
        .catch(error => {
            console.error("Delete error:", error);
        });
}



document.getElementById("introduce").addEventListener('click', function () {
    console.log("introduceCheckbox clicked");
    document.getElementById("UrbanFutureIntroduceButton").click();
});




// ───────────────────────────────────────────────────────────────────────────────
// Mobile landscape → ask user to rotate to portrait
// ───────────────────────────────────────────────────────────────────────────────
(function initRotateHint() {
    const id = 'rotate-hint';
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement('div');
        el.id = id;
        el.innerHTML = `
      <div class="box">
        <div style="font-size:20px;margin-bottom:4px;">Korzystaj w orientacji pionowej.</div>
        <div style="font-size:14px;opacity:.9;">Obróć urządzenie, by przejść do doświadczenia!</div>
      </div>`;
        document.body.appendChild(el);
    }
    const mq = window.matchMedia('(max-width: 960px) and (orientation: landscape)');
    const update = () => { el.classList.toggle('is-open', mq.matches); };
    update();
    mq.addEventListener('change', update);
    window.addEventListener('resize', update, { passive: true });
})();






// === config ===

// Inline SVGs (inherit currentColor)
const ICONS = {
    messenger: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M12 2C6.48 2 2 6 2 10.86c0 2.73 1.39 5.2 3.72 6.8v3.34l3.4-1.87c.93.26 1.92.4 2.88.4 5.52 0 10-4 10-8.86S17.52 2 12 2Zm1.54 10.69-2.52-2.69-5.14 2.69 5.67-6.03 2.52 2.69 5.14-2.69-5.67 6.03Z"/>
    </svg>`,
    whatsapp: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M20.52 3.48A11.85 11.85 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.55 4.16 1.6 5.98L0 24l6.2-1.62A12 12 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52ZM12 22c-1.81 0-3.56-.49-5.08-1.42l-.36-.22-3.17.83.85-3.09-.23-.38A9.96 9.96 0 0 1 2 12C2 6.49 6.49 2 12 2c2.66 0 5.17 1.04 7.06 2.94A9.95 9.95 0 0 1 22 12c0 5.51-4.49 10-10 10Zm5.08-6.41c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.62.14-.19.28-.72.9-.88 1.08-.16.19-.33.21-.61.07-.28-.14-1.19-.44-2.27-1.41-.84-.75-1.41-1.68-1.58-1.96-.16-.28-.02-.43.12-.57.12-.12.28-.33.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.62-1.49-.85-2.04-.22-.53-.45-.46-.62-.47l-.53-.01c-.19 0-.49.07-.75.35-.26.28-1 1-1 2.45s1.03 2.84 1.17 3.03c.14.19 2.02 3.09 4.89 4.33.68.29 1.21.47 1.63.6.69.22 1.31.19 1.8.12.55-.08 1.65-.68 1.89-1.34.23-.66.23-1.22.16-1.34-.07-.12-.25-.19-.53-.33Z"/>
    </svg>`,
    email: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM4 8l8 5 8-5v10H4V8Zm16-2-8 5-8-5h16Z"/>
    </svg>`,
    copy: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M16 1H4a2 2 0 0 0-2 2v12h2V3h12V1Zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16H8V7h11v14Z"/>
    </svg>`
};

const SHARE_ICON_URL = 'https://publictwin.info/HavenparkGroningen/content/Icons/ShareIconWhite.svg';

const APP_SHARE_URL = window.APP_SHARE_URL || (location.origin + location.pathname);
const APP_SHARE_TITLE = window.APP_SHARE_TITLE || 'Plac Krakowski: Etap II - partycypacja!';
const APP_SHARE_TEXT = window.APP_SHARE_TEXT || 'Podziel się swoją opinią na temat przyszłości Placu Krakowskiego!';

const USE_SYSTEM_SHARE_ON_MOBILE = true; // keep true
const FORCE_WEB_ONLY_WHATSAPP = true;  // set true to avoid whatsapp:// auto-open
const FORCE_WEB_ONLY_MESSENGER = false;  // set true to avoid fb-messenger:// auto-open

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);


// Popups for map pins - indicating categories:
// Category -> emoji (or swap for your own small icon URLs)
const CATEGORY_ICONS = {
    nature: '🌿',
    housing: '🏠',
    economy: '💼',
    heritage: '🏛️',
    biodiversity: '🦋',
    climate: '🌍',
    tourism: '🧭',
    accessibility: '♿',
    infrastructure: '🏗️',
    leisure: '🎈',
    activities: '🎯',
    mobility: '🚲',
    privacy: '🔐',
    sports: '🏃',
    aesthetics: '🎨',
    comfort: '🛋️',
    safety: '🛡️',
    experience: '✨',
    identity: '🧭',
    fun: '😄',
    other: '❓'
};
// Category -> Dutch display label
const CATEGORY_LABELS_NL = {
    nature: 'natuur',
    housing: 'wonen',
    economy: 'economie',
    heritage: 'erfgoed',
    biodiversity: 'biodiversiteit',
    climate: 'klimaat',
    tourism: 'toerisme',
    accessibility: 'toegankelijkheid',
    infrastructure: 'infrastructuur',
    leisure: 'vrije tijd',
    activities: 'activiteiten',
    mobility: 'mobiliteit',
    privacy: 'privacy',
    sports: 'sport',
    aesthetics: 'esthetiek',
    comfort: 'comfort',
    safety: 'veiligheid',
    experience: 'beleving',
    identity: 'identiteit',
    fun: 'plezier',
    other: 'anders'
};

// helpers
function labelNL(cat) {
    return CATEGORY_LABELS_NL[cat] || cat;
}
function iconFor(cat) {
    return CATEGORY_ICONS[cat] || '•';
}

// Keep a single popup instance so only one appears at a time
let __pinPopupEl = null;
function closePinPopup() { __pinPopupEl?.remove?.(); __pinPopupEl = null; }


// Robust copy (works in http dev via execCommand fallback)
async function copyToClipboardSmart(text, btn) {
    try {
        if (navigator.clipboard?.writeText && (location.protocol === 'https:' || location.hostname === 'localhost')) {
            await navigator.clipboard.writeText(text);
        } else {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy'); // best-effort fallback
            document.body.removeChild(ta);
        }
        if (btn) {
            const prev = btn.textContent; btn.textContent = 'Skopiowano!'; setTimeout(() => btn.textContent = prev, 1200);
        }
    } catch {
        window.prompt('Copy this link:', text); // last resort
    }
}

// === util: try app scheme first, then fallback to web ===
function openThenFallback(appHref, webHref) {
    const t0 = Date.now();
    window.location.assign(appHref);
    setTimeout(() => {
        if (Date.now() - t0 < 1500) window.open(webHref, '_blank', 'noopener');
    }, 700);
}

// ==== Mobile detection (robust) ====
function isMobilePlatform() {
    // 1) UA hints (new-ish)
    if (navigator.userAgentData?.mobile) return true;

    // 2) Classic UA check
    const ua = navigator.userAgent || navigator.vendor || '';
    if (/android|iphone|ipad|ipod/i.test(ua)) return true;

    // 3) Coarse pointer + small viewport — “mobile enough”
    const coarse = window.matchMedia?.('(pointer: coarse)').matches;
    const small = Math.min(window.innerWidth, window.innerHeight) <= 820;
    return !!(coarse && small);
}

// ==== Native system share on mobile ====
async function trySystemShareMobile(anchorEl) {
    const url = window.APP_SHARE_URL || (location.origin + location.pathname);
    const title = window.APP_SHARE_TITLE || 'udostępnij Plac Krakowski: Etap II!';
    const text = window.APP_SHARE_TEXT || '';

    if (!navigator.share) return false;   // not supported -> caller will fallback

    try {
        await navigator.share({ title, text, url });
        return true; // user saw system sheet
    } catch (err) {
        // user canceled or the call failed; treat as “handled”
        return true;
    }
}



// === build share button (reuse coin styles) ===
function initShareButton(container) {
    const host =
        container ||
        // document.getElementById('UrbanFutureTopNavbarMainMenuTitle') ||
        document.body;

    if (document.getElementById('ShareAppButton')) return;

    const SHARE_ICON_URL = 'https://publictwin.info/HavenparkGroningen/content/Icons/ShareIconWhite.svg';

    const btn = document.createElement('button');
    btn.id = 'ShareAppButton';
    btn.className = 'PTcoinDiv ShareInAppDiv clickableButton';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'share with a friend');
    btn.innerHTML = `
    <img class="UFIconCoin" src="${SHARE_ICON_URL}" alt="" />
    <span class="ShareInAppLabel">udostępnij</span>
  `;
    host.appendChild(btn);

    btn.addEventListener('click', async (e) => {
        e.stopPropagation();

        // If on mobile, try native system share. If available, do NOT open our menu.
        if (isMobilePlatform()) {
            const handled = await trySystemShareMobile(btn);
            if (handled) return;  // system share shown or user canceled
            // If not supported (very old browser), fall back to our sheet:
            openShareSheet(btn);
            return;
        }

        // Desktop (or not-mobile): open our share sheet
        openShareSheet(btn);
    });

    // Click-away to close sheet on desktop
    document.addEventListener('click', (ev) => {
        const sheet = document.getElementById('ShareSheet');
        if (!sheet) return;
        if (!sheet.contains(ev.target) && ev.target !== btn) sheet.remove();
    });
}

// ==== Boot ====
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initShareButton());
} else {
    initShareButton();
}

// === share sheet with Instagram / Messenger / WhatsApp / Email / Copy ===
function openShareSheet(anchorEl) {
    let sheet = document.getElementById('ShareSheet');
    if (sheet) sheet.remove();

    const url = APP_SHARE_URL;
    const text = APP_SHARE_TEXT;
    const title = APP_SHARE_TITLE;

    const encURL = encodeURIComponent(url);
    const encText = encodeURIComponent(text);
    const encSubj = encodeURIComponent(title);

    // Deep links + fallbacks
    const msApp = `fb-messenger://share?link=${encURL}`;
    const msWeb = `https://m.me/?link=${encURL}`;

    const waApp = `whatsapp://send?text=${encText}%20${encURL}`;
    const waWeb = `https://api.whatsapp.com/send?text=${encText}%20${encURL}`;

    const mailTo = `mailto:?subject=${encSubj}&body=${encText}%0A%0A${encURL}`;

    sheet = document.createElement('div');
    sheet.id = 'ShareSheet';
    sheet.className = 'ShareSheetPopover';
    sheet.innerHTML = `
  <div class="share-row">
    <button class="share-link" data-app="messenger">
      <span class="share-ico brand-messenger">${ICONS.messenger}</span>
      <span>Messenger</span>
    </button>
    <button class="share-link" data-app="whatsapp">
      <span class="share-ico brand-whatsapp">${ICONS.whatsapp}</span>
      <span>WhatsApp</span>
    </button>
    <button class="share-link" data-app="email" data-mailto="${mailTo}">
      <span class="share-ico">${ICONS.email}</span>
      <span>Email</span>
    </button>
    <button class="share-copy" type="button">
      <span class="share-ico">${ICONS.copy}</span>
      <span>Skopiuj link!</span>
    </button>
  </div>
`;

    document.body.appendChild(sheet);
    positionShareSheet(sheet, anchorEl);

    // Click handlers
    sheet.querySelector('.share-row').addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-app], .share-copy');
        if (!btn) return;

        const url = APP_SHARE_URL;
        const text = APP_SHARE_TEXT;
        const title = APP_SHARE_TITLE;

        // 1) Prefer native system share on mobile -> single system UI, no extra prompts
        if (USE_SYSTEM_SHARE_ON_MOBILE && isMobile() && navigator.share) {
            try { await navigator.share({ title, text, url }); } catch (_) { }
            return;
        }

        const app = btn.getAttribute('data-app');

        if (app === 'messenger') {
            const encURL = encodeURIComponent(url);
            const web = `https://m.me/?link=${encURL}`;
            if (FORCE_WEB_ONLY_MESSENGER) {
                window.open(web, '_blank', 'noopener'); // avoids immediate app launch
            } else {
                // may open app immediately on Android (expected)
                openThenFallback(`fb-messenger://share?link=${encURL}`, web);
            }
        } else if (app === 'whatsapp') {
            const encTxt = encodeURIComponent(`${text} ${url}`);
            const web = `https://api.whatsapp.com/send?text=${encTxt}`;
            if (FORCE_WEB_ONLY_WHATSAPP) {
                window.open(web, '_blank', 'noopener'); // avoids immediate app launch
            } else {
                // may open app immediately on Android (expected)
                openThenFallback(`whatsapp://send?text=${encTxt}`, web);
            }
        } else if (app === 'email') {
            const encSubj = encodeURIComponent(title);
            const encBody = encodeURIComponent(`${text}\n\n${url}`);
            window.location.href = `mailto:?subject=${encSubj}&body=${encBody}`;
        } else if (btn.classList.contains('share-copy')) {
            copyToClipboardSmart(url, btn);
        }
    });

    // Copy link
    sheet.querySelector('.share-copy')?.addEventListener('click', () => {
        copyToClipboard(url, sheet.querySelector('.share-copy'));
    });

    // Reposition on resize/scroll
    const onScroll = () => positionShareSheet(sheet, anchorEl);
    window.addEventListener('resize', onScroll, { passive: true, once: true });
    window.addEventListener('scroll', onScroll, { passive: true, once: true });
}


function positionShareSheet(sheet, anchorEl) {
    const r = anchorEl.getBoundingClientRect();

    // Prepare for measuring
    sheet.style.visibility = 'hidden';
    sheet.style.top = '0px';
    sheet.style.left = '0px';

    requestAnimationFrame(() => {
        const gap = 6;

        // Measure popup size after layout
        const w = sheet.offsetWidth;
        const h = sheet.offsetHeight;

        // Prefer ABOVE the anchor
        const preferredTop = r.top + window.scrollY - h - gap;
        let top = preferredTop;

        // Right-align to the anchor, same as before
        let left = r.right + window.scrollX - w;

        // Keep it on-screen horizontally (8px padding)
        left = Math.max(8, Math.min(left, window.scrollX + window.innerWidth - w - 8));

        // If there's not enough room above, fall back below
        const minTop = window.scrollY + 8;
        const useBelow = top < minTop;
        if (useBelow) {
            top = r.bottom + window.scrollY + gap;
        }

        // Optional: toggle classes for arrow styling
        sheet.classList.toggle('is-above', !useBelow);
        sheet.classList.toggle('is-below', useBelow);

        sheet.style.top = `${top}px`;
        sheet.style.left = `${left}px`;
        sheet.style.visibility = 'visible';
    });
}





// Boot
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initShareButton());
} else {
    initShareButton();
}




// Add custom model functions:
// --- add inside/after your existing map.on('load') ---
async function addCustom3DModels() {
    // PROPOSAL VARIANT(S)
    await ensureProposalLoaded(DEFAULT_PROPOSAL_KEY);
    setActiveProposal(DEFAULT_PROPOSAL_KEY);


    // CONTEXT (bigger light, your styling rules)
    if (!map.getLayer('UF-context')) {
        UFModels.context = createGLTFLayer({
            id: 'UF-context',
            modelUrl: `${MODEL_BASE}PKrakowski_Context_Model.glb`,
            originLngLat: MODEL_ORIGIN,
            interaction: 'none',
            meshStyle: styleContextMesh,   // your function; optional

            // Light & shadows
            lightConfig: { intensity: 1.6 },   // optional tweak
            shadowConfig: {
                enabled: false,
                mapSize: 4096,
                bias: -0.00045,
                normalBias: 0.02,
                camera: { near: 0.5, far: 700, left: -350, right: 550, top: 1000, bottom: -550 },
                autoFit: true,          // 🔥 auto-size frustum
                autoFitMargin: 30
            },
            debugLight: {
                key: '`',
                startVisible: false,
                helperSize: 1
            },
            shadowPlane: true,
            bigContextLight: true
        });
        map.addLayer(UFModels.context);
    }


    ensureModelsOnTop();
    updateTreesVisibilityAcross3D();
}
// --- put this near addCustom3DModels() ---
// make these available where you create the layers
function reAddCustom3DModels() {
    // 1) Rebuild context if missing
    const cOpts = UFModels.context?.__opts;
    if (cOpts && !map.getLayer(cOpts.id)) {
        UFModels.context = createGLTFLayer(cOpts);
        map.addLayer(UFModels.context);
    }
    const zOpts = UFModels.zones?.__opts;
    if (zOpts && !map.getLayer(zOpts.id)) {
        UFModels.zones = createGLTFLayer(zOpts);
        map.addLayer(UFModels.zones);
    }

    // 2) Rebuild every proposal layer we ever loaded
    for (const [key, entry] of UFModels._proposalLayers.entries()) {
        const { opts } = entry;
        if (!map.getLayer(opts.id)) {
            const layer = createGLTFLayer(opts);
            map.addLayer(layer);
            UFModels._proposalLayers.set(key, { layer, opts });
        }
        // keep enabled state consistent
        const enabled = (key === _currentProposalKey);
        UFModels._proposalLayers.get(key).layer.setEnabled(enabled);
        if (enabled) UFModels.proposal = UFModels._proposalLayers.get(key).layer;
    }

    ensureModelsOnTop();
    update3DVisibilityForZoom(map.getZoom());

    reflectTreesSwitchUI();
    updateTreesVisibilityAcross3D();
}


// install resilience once
let _modelsPersistenceInstalled = false;

function installStylePersistence() {
    if (_modelsPersistenceInstalled) return;
    _modelsPersistenceInstalled = true;

    // when a new style loads, the old custom layers are gone → rebuild
    map.on('style.load', reAddCustom3DModels);

    // whenever style finishes laying out, keep them on top
    map.on('idle', ensureModelsOnTop);
}

// put models above region layers (or simply to very top)
function ensureModelsOnTop() {
    // context first


    // then every proposal (active last so it's topmost)
    const keys = Array.from(UFModels._proposalLayers.keys());
    keys.forEach(k => {
        const id = proposalLayerId(k);
        if (map.getLayer(id)) map.moveLayer(id);
    });
    if (map.getLayer('UF-context')) map.moveLayer('UF-context');
    if (map.getLayer('UF-zones')) map.moveLayer('UF-zones');
    if (map.getLayer("PTProjects")) map.moveLayer("PTProjects");
}

function createProposalLayerForKey(key, url) {
    const token = showModelDownloadPill();
    const id = proposalLayerId(key);
    return createGLTFLayer({
        id,
        modelUrl: url,
        originLngLat: MODEL_ORIGIN,
        interaction: 'none',
        meshStyle: styleProposalMesh,

        lightConfig: { intensity: 1.3 },
        shadowConfig: {
            enabled: false,
            mapSize: 4096,
            bias: -0.00045,
            normalBias: 0.02,
            camera: { near: 0.5, far: 700, left: -350, right: 950, top: 1000, bottom: -150 },
            autoFit: true,
            autoFitMargin: 30
        },
        debugLight: { key: '`', startVisible: false, helperSize: 12 },
        shadowPlane: true,
        bigContextLight: true,
        onProgress: (ratio) => {
            // ratio in [0..1] or null when unknown
            updateModelDownloadPill(token, ratio);
            if (ratio === 1) hideModelDownloadPill(token);
        }
    });
}


async function ensureProposalLoaded(key) {
    const reg = PROPOSAL_OPTIONS.find(o => o.key === key);
    if (!reg) return false;

    // already have it?
    let entry = UFModels._proposalLayers.get(key);
    if (!entry) {
        const layer = createProposalLayerForKey(key, reg.url);
        // remember opts for style persistence
        const opts = layer.__opts;
        UFModels._proposalLayers.set(key, { layer, opts });
        map.addLayer(layer);
    } else {
        // make sure it's present (in case of style change)
        if (!map.getLayer(entry.layer.id)) {
            entry.layer = createGLTFLayer(entry.opts);
            map.addLayer(entry.layer);
            // re-cache updated instance
            UFModels._proposalLayers.set(key, entry);
        }
    }
    return true;
}

function setActiveProposal(key) {
    if (_currentProposalKey === key) return;

    // disable previous
    if (_currentProposalKey) {
        const prev = UFModels._proposalLayers.get(_currentProposalKey);
        prev?.layer?.setEnabled(false);
    }

    _currentProposalKey = key;

    // enable new
    const cur = UFModels._proposalLayers.get(key);
    cur?.layer?.setEnabled(true);

    // keep on top
    ensureModelsOnTop();

    // expose current convenience pointer
    UFModels.proposal = cur?.layer || null;

    // at the end of setActiveProposal(key)
    _treesVisible = true;
    reflectTreesSwitchUI();              // updates the pill UI classes
    updateTreesVisibilityAcross3D();
}


function buildProposalSwitcherUI() {
    // Try to mount next to an existing control; fall back to body
    const anchors = ['#UrbanFutureTopNavbarMainMenuTitle', '#BottomStyleSwitch', '.UrbanFutureOptionsButton'];
    const anchor = anchors.map(sel => document.querySelector(sel)).find(Boolean) || document.body;

    const wrap = document.createElement('div');
    wrap.id = 'UF-ProposalSwitcher';
    wrap.className = 'uf-proposal-switcher';

    if (anchor === document.body) {
        wrap.classList.add('is-fixed');
    } else {
        // ensure absolute positioning has a reference frame
        const parent = anchor.parentElement;
        if (parent && getComputedStyle(parent).position === 'static') {
            parent.style.position = 'relative';
        }
    }

    const label = document.createElement('span');
    label.className = 'uf-proposal-label';
    label.textContent = 'Proposal:';

    const select = document.createElement('select');
    select.className = 'uf-proposal-select';
    select.ariaLabel = 'Select proposal option';

    PROPOSAL_OPTIONS.forEach(o => {
        const opt = document.createElement('option');
        opt.value = o.key;
        opt.textContent = o.label;
        if (o.key === DEFAULT_PROPOSAL_KEY) opt.selected = true;
        select.appendChild(opt);
    });

    select.addEventListener('change', async (e) => {
        const key = e.target.value;
        await ensureProposalLoaded(key);
        setActiveProposal(key);
        if (ZoneCtrl?.index != null) {
            refreshZoneStatsUI();
        }
        zoomLevelCheck(map.getZoom());

        ZoneCtrl?.refreshPlaceholder?.();
        ZoneCtrl?.refreshZoneDescription?.();
        ZoneLabels.reload();

    });

    wrap.appendChild(label);
    wrap.appendChild(select);

    if (anchor === document.body) {
        document.body.appendChild(wrap);
    } else {
        anchor.appendChild(wrap);
    }
}



// === tree visibility toggle ===

// Icons
const TREES_ICON_VISIBLE = 'https://publictwin.info/PlacKrakowski/res/icons/TreesIcon.svg';
const TREES_ICON_HIDDEN = 'https://publictwin.info/PlacKrakowski/res/icons/HiddenIcon.svg';

// Global desired state (default ON)
let _treesVisible = true;

// Name matcher (case-insensitive)
// Detect tree parts by name (proposal + context)
function isTreePartByName(obj) {
    const n = (obj?.userData?.name || obj?.name || '').toLowerCase();
    return n.includes('crown') || n.includes('trunk');
}

// Apply current trees state (_treesVisible) to a single custom layer
function applyTreesVisibilityToLayer(layer, visible) {
    if (!layer) return;

    const apply = () => {
        layer.model?.traverse?.(o => {
            if (o.isMesh && isTreePartByName(o)) {
                o.visible = !!visible;
            }
        });
        layer.map?.triggerRepaint?.();
    };

    if (layer.modelLoaded) apply();
    else {
        // Wait briefly for model to finish loading (handles first-time loads)
        const tick = setInterval(() => {
            if (layer.modelLoaded) {
                clearInterval(tick);
                apply();
            }
        }, 100);
        setTimeout(() => clearInterval(tick), 5000); // safety
    }
}

// Apply to proposal (active) + context
function updateTreesVisibilityAcross3D() {
    applyTreesVisibilityToLayer(UFModels.proposal, _treesVisible);
    applyTreesVisibilityToLayer(UFModels.context, _treesVisible);
}


// Apply visibility to ONLY the active proposal layer
function updateTreesVisibilityForActive() {
    const layer = UFModels.proposal;
    if (!layer) return;

    const apply = () => {
        layer.model?.traverse?.(o => {
            if (o.isMesh && isTreePartByName(o)) o.visible = !!_treesVisible;
        });
        layer.map?.triggerRepaint?.();
    };
    if (layer.modelLoaded) apply();
    else requestAnimationFrame(apply);
}
// Mutators like your style switch
function switchTreesHidden() {
    _treesVisible = false;
    updateTreesVisibilityForActive();
    const hiddenEl = document.getElementById('UFTreesHidden');
    const visibleEl = document.getElementById('UFTreesVisible');
    hiddenEl?.classList.add('SelectdToggleButton');
    visibleEl?.classList.remove('SelectdToggleButton');
}
function switchTreesVisible() {
    _treesVisible = true;
    updateTreesVisibilityForActive();
    const hiddenEl = document.getElementById('UFTreesHidden');
    const visibleEl = document.getElementById('UFTreesVisible');
    visibleEl?.classList.add('SelectdToggleButton');
    hiddenEl?.classList.remove('SelectdToggleButton');
}
function toggleTreesSwitch() {
    _treesVisible = !_treesVisible;
    reflectTreesSwitchUI();
    updateTreesVisibilityAcross3D();
}
// Build the DOM to mirror BottomStyleSwitch
function buildTreesSwitchUI() {
    if (document.getElementById('BottomTreesSwitch')) return;

    const wrap = document.createElement('div');
    wrap.id = 'BottomTreesSwitch';
    wrap.setAttribute('role', 'button');
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('aria-pressed', 'true'); // ON by default

    const icon = document.createElement('img');
    icon.id = 'TreesSwitchIcon';
    icon.className = 'UFParticipationIcon';
    icon.alt = 'Toggle trees';
    wrap.appendChild(icon);

    // click/tap toggles
    wrap.addEventListener('click', toggleTreesSwitch);
    // keyboard toggle
    wrap.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleTreesSwitch();
        }
    });

    document.body.appendChild(wrap);

    // initial paint
    reflectTreesSwitchUI();
    updateTreesVisibilityForActive();
}

function reflectTreesSwitchUI() {
    const wrap = document.getElementById('BottomTreesSwitch');
    const icon = document.getElementById('TreesSwitchIcon');
    if (!wrap || !icon) return;

    if (_treesVisible) {
        wrap.classList.remove('is-off');
        wrap.setAttribute('aria-pressed', 'true');
        icon.src = TREES_ICON_VISIBLE;
        icon.title = 'Trees: visible';
    } else {
        wrap.classList.add('is-off');
        wrap.setAttribute('aria-pressed', 'false');
        icon.src = TREES_ICON_HIDDEN;
        icon.title = 'Trees: hidden';
    }
}

// Expose helpers you already call during zoom
function applyZoomVisibilityTo3DUI(show) {
    const els = [
        document.getElementById('UF-ProposalSwitcher'),
        document.getElementById('BottomTreesSwitch'),
        document.getElementById('ShareAppButton')
    ].filter(Boolean);
    els.forEach(el => {
        el.style.display = show ? '' : 'none';
        el.style.pointerEvents = show ? 'auto' : 'none';
    });
}


// === ZONES (final, simple & robust) ==========================================

// 1) Helpers over the CURRENT list (no stale indexes)
function getZones() {
    if (Array.isArray(window.participationZones)) return window.participationZones;
    if (typeof participationZones !== 'undefined' && Array.isArray(participationZones)) return participationZones;
    return [];
}

// "Zone_02_Strefa_..."  ->  "zone_02"
function extractZoneIdFromName(name = '') {
    const m = String(name).toLowerCase().match(/zone[\s_\-]*([0-9]+)/);
    if (!m) return null;
    return `zone_${m[1].padStart(2, '0')}`;
}

function findZoneIndexById(id) {
    const k = String(id).toLowerCase();
    const zones = getZones();
    for (let i = 0; i < zones.length; i++) {
        if (String(zones[i].id).toLowerCase() === k) return i;
    }
    return -1;
}

function getZoneMeshByIndex(i) {
    const L = UFModels?.zones;
    const z = getZones()[i];
    if (!L || !L.pickables || !z) return null;
    const wantId = String(z.id).toLowerCase();
    return L.pickables.find(o => extractZoneIdFromName(o.userData?.name || o.name || '') === wantId) || null;
}

// 2) Hover / selection (single hover, single select)
function zonesClearHover() {
    const L = UFModels?.zones;
    if (!L) return;

    const h = L._hovered;
    if (h && !h.selected) {
        // restore base look + base edge opacity
        applyBaseMaterial(h);
        addEdgeLinesZones(h, ZONE_EDGE_COLOR, ZONE_EDGE_OPACITY_BASE);
    }
    L._hovered = null;
    L.map?.triggerRepaint?.();
}


function zonesClearSelection() {
    const L = UFModels?.zones;
    if (!L) return;

    for (const o of L._selected) {
        // restore base fill + base edge opacity
        applyBaseMaterial(o);
        addEdgeLinesZones(o, ZONE_EDGE_COLOR, ZONE_EDGE_OPACITY_BASE);
    }
    L._selected.clear();
    L.map?.triggerReprint?.(); // if you had a typo, keep `triggerRepaint` instead
}


function highlightZoneByIndex(i) {
    const L = UFModels?.zones;
    if (!L) return false;

    const mesh = getZoneMeshByIndex(i);
    if (!mesh) return false;

    // ensure meshes have per-mesh opacity numbers on the mesh object
    zonesEnforceOpacityProps?.();

    // fully reset previous visuals on previously selected (back to base + base edge opacity)
    for (const o of (L._selected || new Set())) {
        applyBaseMaterial(o);
        addEdgeLinesZones(o, ZONE_EDGE_COLOR, ZONE_EDGE_OPACITY_BASE);
    }
    L._selected?.clear?.();

    // reset all non-selected meshes to base style + base edge opacity
    for (const o of (L.pickables || [])) {
        if (o !== mesh) {
            applyBaseMaterial(o);
            addEdgeLinesZones(o, ZONE_EDGE_COLOR, ZONE_EDGE_OPACITY_BASE);
        }
    }

    // highlight the target: keep selected fill, but soften its edge to 0.10
    applySelectedMaterial?.(mesh);
    addEdgeLinesZones(mesh, ZONE_EDGE_COLOR, ZONE_EDGE_OPACITY_SELECTED);
    L._selected.add(mesh);

    // forget any current hover reference
    L._hovered = null;

    L.map?.triggerRepaint?.();
    return true;
}


function _zoneDictLookup(dict, z) {
    if (!dict || !z) return null;
    const byId = dict[String(z.id || '').toLowerCase()];
    if (byId != null) return byId;
    const byKey = dict[inferZoneKeyFromZoneObject(z)];
    return byKey ?? null;
}
// If you already have this, keep yours; this version is backward-friendly
function getZoneTextFor(cfgId, zoneOrKey) {
    const key = (typeof zoneOrKey === 'string')
        ? zoneOrKey
        : inferZoneKeyFromZoneObject(zoneOrKey);
    const raw = ZONE_TEXT?.[cfgId]?.[key];
    // Works whether ZONE_TEXT contains strings (current) or objects (future-proof)
    return (typeof raw === 'string') ? raw : (raw?.text || '');
}

// New: label lookup mirroring the API of getZoneTextFor
function getZoneLabelFor(cfgId, zoneOrKey) {
    const key = (typeof zoneOrKey === 'string')
        ? zoneOrKey
        : inferZoneKeyFromZoneObject(zoneOrKey);
    return ZONE_LABELS?.[cfgId]?.[key] || '';
}





function flyToZoneIndex(i) {
    const z = getZones()[i]; if (!z) return;
    zoomLevelCheck(isMobileDevice() ? (z.zoom - 1.2) : z.zoom);
    map.easeTo({
        center: z.center,
        zoom: isMobileDevice() ? (z.zoom - 1.2) : z.zoom,
        pitch: z.pitch ?? 60, bearing: z.bearing ?? 0,
        duration: 1000
    });
}

function computeZonePlaceholderHTML(z) {
    const cfg = getActiveConfigurationId();
    const cfgStr = cfg < 10 ? `0${cfg}` : String(cfg);
    const zoneName = (z?.displayName || z?.id || '')
        .replace(/^Strefa\s*/i, '')
        .trim();

    // Only formatting, no content change from your string
    return `Zostaw swoją opinię o strefie <strong>${zoneName || '—'}</strong> w konfiguracji <strong>${cfgStr}</strong>… <span class="hiddenOnMobile">możesz też zostawić dla niej polubienie klikając ♥</span>`;
}

/* Shows/hides the faux placeholder depending on focus/value */
function bindFauxPlaceholderBehavior(textareaEl, placeholderHostEl) {
    const update = () => {
        const hasText = !!(textareaEl.value && textareaEl.value.trim().length);
        const focused = document.activeElement === textareaEl;
        placeholderHostEl.classList.toggle('hidden', hasText || focused);
    };
    textareaEl.addEventListener('input', update);
    textareaEl.addEventListener('focus', update);
    textareaEl.addEventListener('blur', update);
    // initial
    update();
}


// 3) Unified controller (arrows & clicks share the same path)
const ZoneCtrl = (() => {
    const st = { idx: null, wrap: null };

    function computeZonePlaceholder(z) {
        const cfg = getActiveConfigurationId();
        const cfgStr = cfg < 10 ? `0${cfg}` : String(cfg);
        const zoneName = (z?.displayName || z?.id || '')
            .replace(/^Strefa\s*/i, '')  // drop leading "Strefa"
            .trim();
        const suffix = zoneName ? ` ${zoneName}` : '';
        return `Zostaw swoją opinię o strefie${suffix} w konfiguracji ${cfgStr}… możesz też zostawić dla niej polubienie klikając ♥`;
    }

    function refreshPlaceholder() {
        if (!st.wrap || st.idx == null) return;
        const z = getZones()[st.idx];

        // Keep the native placeholder empty to avoid double text behind the overlay
        const inputEl = st.wrap.querySelector('#zones-input');
        if (z && inputEl) inputEl.setAttribute('placeholder', '');

        // Update the rich (styled) overlay text
        const phTextEl = st.wrap.querySelector('#zones-faux-placeholder .zones-ph-text');
        if (phTextEl) phTextEl.innerHTML = computeZonePlaceholderHTML(z);

        // Ensure visibility state reflects current value/focus
        const faux = st.wrap.querySelector('#zones-faux-placeholder');
        if (inputEl && faux) {
            // force a quick visibility update
            const hasText = !!(inputEl.value && inputEl.value.trim().length);
            const focused = document.activeElement === inputEl;
            faux.classList.toggle('hidden', hasText || focused);
        }
    }


    function ensurePanelDOM() {
        if (!st.wrap) {
            st.wrap = document.getElementById('ParticipateZonesWrapper');
            if (!st.wrap) {
                st.wrap = document.createElement('div');
                st.wrap.id = 'ParticipateZonesWrapper';
                document.body.appendChild(st.wrap);
            }
        }
        st.wrap.classList.add('is-open');
        st.wrap.innerHTML = `
    <div class="participate-panel">
      <button id="zones-close" class="participate-close clickableButton" aria-label="Close">
        <img class="participateIcon"
             src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CloseMenu.png" />
      </button>

      <div id="zones-stats">
        <div id="zones-inner-stats">
          <div class="stat stat-answers" title="Liczba odpowiedzi">
            <img class="participateIcon" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/PersonIcon.svg" />
            <span id="zones-answers-count">0</span>
          </div>

          <button id="zones-like-btn" class="stat stat-like" type="button" aria-label="Polub tę strefę" data-liked="0">
            <img id="zone-like-icon" class="participateIcon"
                 src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/HearthEmptyIcon.svg" />
            <span id="zones-likes-count">0</span>
          </button>
        </div>
      </div>

      <div id="participate-nav" class="participate-nav-abs" aria-label="Navigate zones">
        <button id="zones-prev" class="participate-nav-btn" aria-label="Previous" title="Previous">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/PreviousIcon.svg" />
        </button>
        <h3 id="zones-title">Strefa</h3>
        <button id="zones-next" class="participate-nav-btn" aria-label="Next" title="Next">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/NextIcon.svg" />
        </button>
      </div>

       <div class="participate-input-wrapper">
          <textarea id="zones-input" class="participate-input" placeholder=""></textarea>
          <button id="zones-submit" class="participate-submit clickableButton">
            <img class="participateIcon"
                 src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/SendIconMainWhite.svg" />
          </button>

          <!-- Faux styled placeholder overlay -->
          <div id="zones-faux-placeholder" class="zones-placeholder">
            <span class="pulse-dot"></span>
            <span class="zones-ph-text"></span>
          </div>
        </div>

      <div class="participate-body" id="zones-body">
        <!-- status host goes here -->

        <div id="zones-description" class="zones-description" style="margin-top:12px; white-space:pre-wrap;"></div>
      </div>
    </div>`;

        // Initialize like button neutral state
        const likeBtnInit = st.wrap.querySelector('#zones-like-btn');
        const likeIconInit = st.wrap.querySelector('#zone-like-icon');
        if (likeBtnInit) {
            likeBtnInit.disabled = true;
            likeBtnInit.classList.remove('is-liked');
            likeBtnInit.dataset.liked = '0';
            if (likeIconInit) likeIconInit.src = HEART_EMPTY;
        }

        // Wire faux placeholder behavior
        const inputEl = st.wrap.querySelector('#zones-input');
        const faux = st.wrap.querySelector('#zones-faux-placeholder');
        if (inputEl && faux) {
            // Fill initial rich text
            const z = getZones()[st.idx ?? 0];
            const phTextEl = faux.querySelector('.zones-ph-text');
            if (phTextEl) phTextEl.innerHTML = computeZonePlaceholderHTML(z);
            // Bind show/hide behavior
            bindFauxPlaceholderBehavior(inputEl, faux);
        }
        const zonesBody = st.wrap.querySelector('#zones-body');
        attachMobileScrollBarInline(zonesBody);
    }


    function renderPanelFor(i) {
        const z = getZones()[i]; if (!z) return;
        const title = (z.displayName || z.id);
        st.wrap.querySelector('#zones-title').textContent = title;

        const many = getZones().length > 1;
        const prevBtn = st.wrap.querySelector('#zones-prev');
        const nextBtn = st.wrap.querySelector('#zones-next');
        prevBtn.disabled = !many;
        nextBtn.disabled = !many;

        prevBtn.onclick = () => step(-1);
        nextBtn.onclick = () => step(+1);
        st.wrap.querySelector('#zones-close').onclick = close;

        // make sure status container exists
        ensureZoneStatusHost();

        const submitEl = st.wrap.querySelector('#zones-submit');
        const inputEl = st.wrap.querySelector('#zones-input');
        let isSubmitting = false;

        refreshPlaceholder();
        refreshZoneDescription();

        submitEl.onclick = async (ev) => {
            ev.preventDefault();
            if (isSubmitting) return;

            const answer_text = (inputEl.value || '').trim();
            if (!answer_text) {
                inputEl.focus();
                inputEl.setAttribute('placeholder', 'Napisz coś konkretnego (min. 5 znaków)…');
                return;
            }

            // UI lock
            isSubmitting = true;
            submitEl.disabled = true;
            submitEl.classList.add('is-loading');

            const fetchJSON = async (url, options = {}, timeoutMs = 15000) => {
                const ctrl = new AbortController();
                const to = setTimeout(() => ctrl.abort(), timeoutMs);
                try {
                    const res = await fetch(url, { ...options, signal: ctrl.signal });
                    const json = await res.json().catch(() => ({}));
                    return { ok: res.ok, status: res.status, json };
                } finally { clearTimeout(to); }
            };

            try {
                // 1) Classify
                showZoneStatusHTML('Analizujemy Twoją opinię…', 'loading');
                const cls = await fetchJSON(
                    CLASSIFY_URL,
                    { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ answer_text }) },
                    15000
                );
                if (!cls.ok || cls.json?.status !== 'ok') {
                    showZoneStatusHTML('Nie udało się sklasyfikować - spróbuj ponownie.', 'error');
                    return;
                }

                const answer_text_en = typeof cls.json.answer_text_en === 'string' ? cls.json.answer_text_en : '-';
                const language = typeof cls.json.language === 'string' ? cls.json.language : 'und';
                const sentiment = typeof cls.json.sentiment === 'string' ? cls.json.sentiment : 'not for classification';
                const categories = Array.isArray(cls.json.categories) ? cls.json.categories : ['other'];
                const insight_score = Number.isFinite(cls.json.insight_score)
                    ? Math.max(0, Math.min(100, Math.trunc(cls.json.insight_score))) : 0;

                // 2) Gather extra fields
                const question_id = Number.isFinite(z.questionId) ? Number(z.questionId) : 0;
                const configuration_id = getActiveConfigurationId();  // <-- from proposal switcher
                const zone_id = getActiveZoneIdInt();        // <-- from current zone

                const uid = sessionStorage.getItem('userID') || '-';
                const age_group = sessionStorage.getItem('userAge') || window.sessionUserAge || '-';
                const relation_to_place = sessionStorage.getItem('userRelation') || window.sessionUserRelation || '-';
                const gender = sessionStorage.getItem('userGender') || window.sessionUserGender || '-';
                const logged_in_user_id = sessionStorage.getItem('loginUserID') || '-';

                // ip (fast path, else fetch)
                let user_IP = window.userIP || '-';
                if (!user_IP) {
                    try {
                        const ipRes = await fetchJSON('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php', {}, 8000);
                        user_IP = ipRes.json?.ip || '-';
                    } catch { }
                }

                // 3) Insert
                const insertBody = {
                    table: databaseAnswersName,   // "PlacKrakowskiEtapIIAnswers"
                    question_id,
                    configuration_id,
                    zone_id,

                    answer_text,
                    answer_text_en,
                    language,
                    sentiment,
                    categories,
                    insight_score,

                    user_IP,
                    user_identifier: uid,
                    logged_in_user_id,

                    age_group,
                    relation_to_place,
                    gender,

                    source: 'app'
                };

                const ins = await fetchJSON(
                    INSERT_URL,
                    { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(insertBody) },
                    15000
                );

                if (ins.ok && ins.json?.status === 'ok') {
                    inputEl.value = '';
                    // tiny feedback chips (optional)
                    const chips = (categories || []).slice(0, 3).map(c => {
                        const lbl = (typeof labelNL === 'function') ? labelNL(c) : c;
                        const ico = (typeof iconFor === 'function') ? iconFor(c) : '•';
                        return `<span class="cat-chip"><span class="cat-ico">${ico}</span><span class="cat-lbl">${lbl}</span></span>`;
                    }).join(' ');

                    showZoneStatusHTML(`Twoja odpowiedź została zapisana! ✔`, 'ok');
                    hideZoneStatus(5000);

                    updateAnswerBadgesAll?.();
                    updateCategoryChipsAll?.();
                } else {
                    showZoneStatusHTML(ins.json?.message || 'Nie udało się zapisać — spróbuj ponownie.', 'error');
                }
            } catch (err) {
                const aborted = err?.name === 'AbortError';
                showZoneStatusHTML(aborted ? 'Przekroczono czas — spróbuj ponownie.' : 'Błąd sieci — spróbuj ponownie.', 'error');
            } finally {
                isSubmitting = false;
                submitEl.disabled = false;
                submitEl.classList.remove('is-loading');
            }
        };

        const likeBtnEl = document.getElementById('zones-like-btn');
        if (likeBtnEl && !likeBtnEl._boundToggle) {
            likeBtnEl._boundToggle = true;
            likeBtnEl.addEventListener('click', (ev) => {
                ev.preventDefault(); ev.stopPropagation();
                toggleLikeCurrentZone();
            }, { passive: true });
        }
        // refresh counts for the current zone+config
        neutralizeLikeUI();
        refreshZoneStatsUI();
    }

    function openAt(idx) {
        const zones = getZones();
        if (!zones.length) return false;

        const len = zones.length;
        st.idx = ((idx % len) + len) % len;

        document.body.classList.add('body--panel-open');   // <— add

        ensurePanelDOM();
        highlightZoneByIndex(st.idx);
        flyToZoneIndex(st.idx);
        renderPanelFor(st.idx);


        return true;

    }

    function selectZoneById(id) {
        const i = findZoneIndexById(id);
        removeParticiaptionHint();
        return (i >= 0) ? openAt(i) : false;
    }

    function selectZoneByMesh(meshName) {
        const id = extractZoneIdFromName(meshName);
        return id ? selectZoneById(id) : false;
    }

    function step(dir) {
        if (st.idx == null) return openAt(0);
        return openAt(st.idx + dir);
    }

    function close() {
        zonesClearSelection();
        zonesClearHover();
        st.idx = null;
        st.wrap?.classList.remove('is-open');
        document.body.classList.remove('body--panel-open'); // <— remove
        const zb = st.wrap?.querySelector('#zones-body');
        SCROLLBAR_STATE.get(zb)?.destroy();
    }
    function refreshZoneDescription() {
        if (!st.wrap || st.idx == null) return;
        const el = st.wrap.querySelector('#zones-description'); if (!el) return;

        const cfgId = getActiveConfigurationId();
        const z = getZones()[st.idx];

        const txt = getZoneTextFor(cfgId, z);
        el.innerHTML = '';
        if (txt) {
            const strong = document.createElement('strong');
            strong.textContent = 'Opis:';
            el.appendChild(strong);
            el.appendChild(document.createTextNode(' ' + txt));
            el.style.display = '';
        } else {
            el.style.display = 'none';
        }
    }






    return { openAt, selectZoneById, selectZoneByMesh, step, close, refreshPlaceholder, refreshZoneDescription, get index() { return st.idx; } };
})();

// ===== Floating 3-word labels over zones (Mapbox) =====
const ZoneLabels = (() => {
  const st = { layer: null, items: [], onMove: null, visible: true };

  function ensureLayer() {
    if (st.layer && document.body.contains(st.layer)) return st.layer;
    const layer = document.createElement('div');
    layer.id = 'zone-label-layer';
    Object.assign(layer.style, {
      position: 'fixed',
      inset: '0',
      pointerEvents: 'none',
      zIndex: 100004,
      display: 'none' // start hidden until setVisible(true)
    });
    document.body.appendChild(layer);
    st.layer = layer;
    return layer;
  }

  function bind() {
    if (st.onMove) return;
    st.onMove = () => updatePositions();
    map.on('move', st.onMove);
    map.on('resize', st.onMove);
  }
  function unbind() {
    if (!st.onMove) return;
    map.off('move', st.onMove);
    map.off('resize', st.onMove);
    st.onMove = null;
  }

  function setVisible(on) {
    st.visible = !!on;
    ensureLayer().style.display = st.visible ? 'block' : 'none';
    if (st.visible) { bind(); updatePositions(); }
    else { unbind(); }
  }

  function makeEl(text) {
    const el = document.createElement('div');
    el.className = 'zone-label';
    el.textContent = text;
    // anchor dead-center above point
    el.style.transform = 'translate(-50%, -100%)';
    return el;
  }

  function rebuild() {
    const layer = ensureLayer();
    layer.innerHTML = '';
    st.items = [];
    const cfgId = getActiveConfigurationId();
    for (const z of getZones()) {
      const label = getZoneLabelFor(cfgId, z);
      if (!label) continue;
      const el = makeEl(label);
      layer.appendChild(el);
      st.items.push({ z, el });
    }
    updatePositions();
  }

  function updatePositions() {
    if (!st.visible || !window.map) return;
    for (const { z, el } of st.items) {
      const p = map.project(z.center);
      el.style.transform = `translate(${Math.round(p.x)}px, ${Math.round(p.y - 14)}px) translate(-50%, -100%)`;
    }
  }

  function start(){ ensureLayer(); rebuild(); setVisible(true); }
  function stop(){ setVisible(false); st.layer?.remove(); st.layer=null; st.items=[]; }
  function reload(){ rebuild(); }

  return { start, stop, reload, updatePositions, setVisible };
})();




// 4) Layer hooks (hover) + our own canvas click (no internal click)
function isZoneMesh(obj) {
    const n = (obj?.userData?.name || obj?.name || '');
    return !!extractZoneIdFromName(n);
}
function styleZoneMesh(mesh) {
    // Base fill
    mesh.material = M_BASE_ZONE;

    // Ensure/refresh base-state edges at ~0.40 opacity
    addEdgeLinesZones(mesh, ZONE_EDGE_COLOR, ZONE_EDGE_OPACITY_BASE);
}

function zoneOnHover(hit) {
    const L = UFModels?.zones;
    map.getCanvas().style.cursor = hit ? 'pointer' : '';
    if (!L) return;

    const obj = hit?.object || null;
    if (obj?.selected && obj.material && L.hoverStyle === 'opacity') {
        const sel = obj._selectedOpacity ?? L.__opts?.selectedOpacity ?? 0.40;
        if (Math.abs((obj.material.opacity ?? sel) - sel) > 1e-3) {
            obj.material.opacity = sel;
            L.map?.triggerRepaint?.();
        }
    }
}


// Our own click (uses the layer’s private raycaster; avoids internal selection)
function zonesCanvasClick(ev) {
    const L = UFModels?.zones;
    if (!L || !L.modelLoaded) return;

    // ignore clicks not on the canvas (defensive)
    const canvas = map.getCanvas();
    const r = canvas.getBoundingClientRect();
    const x = ev.clientX - r.left, y = ev.clientY - r.top;
    const hits = L._raycastAt({ x, y });

    const first = hits && hits[0];
    if (!first) {
        // outside any zone: same as closing panel
        ZoneCtrl.close();
        return;
    }

    const raw = first.object.userData?.name || first.object.name || '';
    ZoneCtrl.selectZoneByMesh(raw);
}


function addZonesLayerIfMissing() {
    if (map.getLayer('UF-zones')) return;

    UFModels.zones = createGLTFLayer({
        id: 'UF-zones',
        modelUrl: `${MODEL_BASE}PKrakowski_Zones.glb`,
        originLngLat: MODEL_ORIGIN,

        interaction: 'hover',        // we keep using our own click
        hoverStyle: 'opacity',
        baseOpacity: 0.02,
        hoverOpacity: 0.30,
        selectedOpacity: 0.08,
        retainHighlightOnSelect: true,

        pickFilter: (o) => o.isMesh && isZoneMesh(o),
        meshStyle: styleZoneMesh,
        onHover: zoneOnHover,

        lightConfig: { intensity: 1.1 },
        shadowConfig: { enabled: false },
        shadowPlane: false,
        bigContextLight: false
    });

    map.addLayer(UFModels.zones);

    // ⬇️ ensure per-mesh opacity props exist (prevents selected = 1.0 fallback)
    whenZonesModelReady(() => zonesEnforceOpacityProps());
}


let _zonesClickBound = false;
function bindZonesClicks() {
    if (_zonesClickBound) return;
    map.getCanvas().addEventListener('click', zonesCanvasClick, { passive: true });
    _zonesClickBound = true;
}
function unbindZonesClicks() {
    if (!_zonesClickBound) return;
    map.getCanvas().removeEventListener('click', zonesCanvasClick);
    _zonesClickBound = false;
}

// --- 3D centroid helpers ----------------------------------------------------
function computeMeshWorldCentroid(mesh) {
    if (!mesh?.geometry) return null;
    const g = mesh.geometry;
    if (!g.boundingBox) g.computeBoundingBox();
    const c = g.boundingBox.getCenter(new THREE.Vector3());
    return mesh.localToWorld(c.clone()); // world-space Vector3
}

// Try layer-provided conversion first; else Mapbox conversion with origin
function worldVec3ToLngLat(L, v3) {
    if (!v3 || !L) return null;

    // If your GLTF layer exposes a direct converter, prefer it.
    if (typeof L.worldToLngLat === 'function') {
        try { return L.worldToLngLat(v3); } catch { /* fall through */ }
    }

    // Fallback: convert world (meters) → Mercator → LngLat.
    // Assumptions match Mapbox three.js example:
    // +X = east, +Y = up, +Z = south  (so -Z = north)
    const origin = L.__opts?.originLngLat || (typeof MODEL_ORIGIN !== 'undefined' ? MODEL_ORIGIN : null);
    if (!origin || !mapboxgl?.MercatorCoordinate) return null;

    const mc0 = mapboxgl.MercatorCoordinate.fromLngLat(origin, 0);
    const m2mc = mc0.meterInMercatorCoordinateUnits();

    const mc = new mapboxgl.MercatorCoordinate(
        mc0.x + v3.x * m2mc,   // east-west
        mc0.y - v3.z * m2mc,   // north-south (note the minus sign for Z south)
        mc0.z + v3.y * m2mc    // altitude
    );
    return mc.toLngLat();
}

function _groupPickablesByZoneId(L) {
  const groups = new Map();
  for (const mesh of (L.pickables || [])) {
    const id = extractZoneIdFromName(mesh?.userData?.name || mesh?.name || '');
    if (!id) continue;
    if (!groups.has(id)) groups.set(id, []);
    groups.get(id).push(mesh);
  }
  return groups;
}

// area-weighted surface centroid for ONE mesh (world space)
// returns THREE.Vector3 or null if no valid triangles
function _areaCentroidWorldForMesh(mesh) {
  const g = mesh?.geometry;
  if (!g?.attributes?.position) return null;

  const pos = g.attributes.position;
  const idx = g.index ? g.index.array : null;

  const a = new THREE.Vector3(), b = new THREE.Vector3(), c = new THREE.Vector3();
  const ab = new THREE.Vector3(), ac = new THREE.Vector3();
  const triCentroid = new THREE.Vector3();

  let weighted = new THREE.Vector3(0, 0, 0);
  let totalArea = 0;

  const fetch = (i, out) => {
    out.fromBufferAttribute(pos, i);
    return mesh.localToWorld(out); // world space
  };

  if (idx) {
    for (let i = 0; i < idx.length; i += 3) {
      fetch(idx[i], a); fetch(idx[i + 1], b); fetch(idx[i + 2], c);
      ab.copy(b).sub(a);
      ac.copy(c).sub(a);
      const area = ab.cross(ac).length() * 0.5;
      if (area > 0) {
        triCentroid.set((a.x + b.x + c.x) / 3, (a.y + b.y + c.y) / 3, (a.z + b.z + c.z) / 3);
        weighted.addScaledVector(triCentroid, area);
        totalArea += area;
      }
    }
  } else {
    // non-indexed: positions are consecutive triples
    for (let i = 0; i < pos.count; i += 3) {
      fetch(i, a); fetch(i + 1, b); fetch(i + 2, c);
      ab.copy(b).sub(a);
      ac.copy(c).sub(a);
      const area = ab.cross(ac).length() * 0.5;
      if (area > 0) {
        triCentroid.set((a.x + b.x + c.x) / 3, (a.y + b.y + c.y) / 3, (a.z + b.z + c.z) / 3);
        weighted.addScaledVector(triCentroid, area);
        totalArea += area;
      }
    }
  }

  if (totalArea <= 0) return null;
  return weighted.multiplyScalar(1 / totalArea);
}

// union world AABB for a set of meshes, returns center (THREE.Vector3) or null
function _worldAabbCenterForMeshes(meshes) {
  const box = new THREE.Box3();
  let any = false;

  for (const m of meshes) {
    const mb = new THREE.Box3().setFromObject(m); // world-space box (includes children)
    if (!isFinite(mb.min.x) || !isFinite(mb.max.x)) continue;
    if (!any) { box.copy(mb); any = true; } else { box.union(mb); }
  }
  return any ? box.getCenter(new THREE.Vector3()) : null;
}

function computeZoneLabelAnchorsFromModel() {
  const L = UFModels?.zones; if (!L) return {};
  const byId = _groupPickablesByZoneId(L);
  const anchors = {};

  for (const [id, meshes] of byId.entries()) {
    // 1) precise: area-weighted centroid across all meshes
    let totalArea = 0;
    const acc = new THREE.Vector3(0, 0, 0);
    for (const m of meshes) {
      const c = _areaCentroidWorldForMesh(m);
      if (!c) continue;

      // estimate area for weighting using world AABB of this mesh as a cheap proxy,
      // OR recompute triangle area again here mesh-by-mesh (heavier). We'll approximate:
      const bb = new THREE.Box3().setFromObject(m);
      const sx = Math.max(0, bb.max.x - bb.min.x);
      const sy = Math.max(0, bb.max.y - bb.min.y);
      const sz = Math.max(0, bb.max.z - bb.min.z);
      const approxArea = sx * sz + sx * sy + sz * sy; // crude but ok for weighting

      acc.addScaledVector(c, approxArea);
      totalArea += approxArea;
    }

    let worldCenter = null;
    if (totalArea > 0) {
      worldCenter = acc.multiplyScalar(1 / totalArea);
    } else {
      // 2) fallback: union world AABB center across meshes
      worldCenter = _worldAabbCenterForMeshes(meshes);
    }

    if (worldCenter) {
      const ll = worldVec3ToLngLat(L, worldCenter);
      if (ll) anchors[id] = ll;
    }
  }

  L._labelAnchors = anchors;
  return anchors;
}


// Convenience for later
function getZoneAnchorLngLat(z) {
    const L = UFModels?.zones;
    const id = String(z?.id || '').toLowerCase();
    return (L && L._labelAnchors && L._labelAnchors[id]) ? L._labelAnchors[id] : (z?.center || null);
}


// 6) Init / teardown hooks
function initZonesFeature() {
    addZonesLayerIfMissing();
    bindZonesClicks();

    ZoneLabels.start();  // ⬅️ add

    window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') ZoneCtrl.close();
    });
    map.on('zoomend', () => {
        if (map.getZoom() < zoomLevelThreshold) ZoneCtrl.close();
        ZoneLabels.updatePositions(); // keep positions crisp
    });

    // Rebuild labels when the GLTF model is ready (centers may be refined)
    whenZonesModelReady(() => {
        computeZoneLabelAnchorsFromModel(); // <-- new
        ZoneLabels.reload();                // rebuild labels with mesh-centroids
    });
}



function whenZonesModelReady(cb) {
    const L = UFModels?.zones;
    if (!L) return;
    if (L.modelLoaded) { cb(L); return; }
    const t = setInterval(() => {
        if (UFModels?.zones?.modelLoaded) {
            clearInterval(t);
            cb(UFModels.zones);
        }
    }, 50);
}

// make sure every pickable has _base/_hover/_selected opacities set,
// and reset all *non-selected* meshes to base.
function zonesEnforceOpacityProps() {
    const L = UFModels?.zones; if (!L) return;
    const base = L.__opts?.baseOpacity ?? 0.02;
    const hov = L.__opts?.hoverOpacity ?? 0.20;
    const sel = L.__opts?.selectedOpacity ?? 0.40;

    for (const o of (L.pickables || [])) {
        if (!o?.material) continue;
        o.material.transparent = true;
        o._baseOpacity = base;
        o._hoverOpacity = hov;
        o._selectedOpacity = sel;
        if (!o.selected) o.material.opacity = base; // kill any ghost hover
    }
    L.map?.triggerRepaint?.();
}


// Always use per-mesh material instances (no sharing!)
function applyBaseMaterial(mesh) {
    if (!mesh?.material) return;
    const L = UFModels?.zones;
    const base = L?.__opts?.baseOpacity ?? 0.02;

    const m = M_BASE_ZONE.clone();
    m.transparent = true;
    m.opacity = base;         // ensure base opacity
    mesh.material = m;
    mesh.selected = false;
}

function applySelectedMaterial(mesh) {
    if (!mesh?.material) return;
    const L = UFModels?.zones;
    const sel = L?.__opts?.selectedOpacity ?? 0.40;

    const m = M_SELECT_ZONE.clone();
    m.transparent = true;
    m.opacity = sel;          // ensure selected opacity
    mesh.material = m;
    addEdgeLinesZones(mesh);
    mesh.selected = true;
}



// ---- helpers for config + zone ids ----

// --- Zones panel status helpers ---------------------------------------------
function ensureZoneStatusHost() {
    const wrapper = document.getElementById('ParticipateZonesWrapper');
    if (!wrapper) return null;

    // Reuse if already created anywhere inside the zones wrapper
    let bar = wrapper.querySelector('#zones-status');
    if (!bar) {
        bar = document.createElement('div');
        bar.id = 'zones-status';
        bar.className = 'participate-status';
        Object.assign(bar.style, {
            margin: '8px 0 10px',
            fontSize: '0.95rem',
            lineHeight: '1.3',
            display: 'none'
        });
    }

    const inputWrap = wrapper.querySelector('.participate-input-wrapper');

    // If we have the input wrapper, place the bar right after it
    if (inputWrap) {
        inputWrap.insertAdjacentElement('afterend', bar);
        if (bar._mo) { bar._mo.disconnect(); bar._mo = null; } // clean up any prior observer
        return bar;
    }

    // Fallback: keep the bar inside the wrapper for now and watch for the wrapper to appear
    if (!bar.parentElement) wrapper.appendChild(bar);

    if (!bar._mo) {
        const mo = new MutationObserver(() => {
            const target = wrapper.querySelector('.participate-input-wrapper');
            if (target) {
                target.insertAdjacentElement('afterend', bar);
                mo.disconnect();
                bar._mo = null;
            }
        });
        mo.observe(wrapper, { childList: true, subtree: true });
        bar._mo = mo;
    }

    return bar;
}


function showZoneStatusHTML(html, mode = 'info') {
    const bar = ensureZoneStatusHost();
    if (!bar) return;

    // reset like pins: base class + mode
    bar.className = 'participate-status';
    bar.classList.add(mode);

    // set content & show
    bar.innerHTML = html;
    bar.style.display = '';

    // add spinner automatically when loading (same as pins)
    if (mode === 'loading' && !bar.querySelector('.spinner')) {
        const spin = document.createElement('span');
        spin.className = 'spinner';
        bar.prepend(spin);
    }
}

// convenience wrapper if you want to pass plain text
function showZoneStatus(text, mode = 'info') {
    showZoneStatusHTML(String(text), mode);
}

function hideZoneStatus(delay = 0) {
    const bar = document.querySelector('#zones-status');
    if (!bar) return;
    const hide = () => { bar.style.display = 'none'; bar.innerHTML = ''; };
    delay > 0 ? setTimeout(hide, delay) : hide();
}

// --- Active proposal → configuration_id -------------------------------------
function getActiveProposalKey() {
    // prefer global state if you set it inside setActiveProposal(...)
    if (typeof window.ACTIVE_PROPOSAL_KEY === 'string' && window.ACTIVE_PROPOSAL_KEY) {
        return window.ACTIVE_PROPOSAL_KEY;
    }
    // else read the select
    const sel = document.querySelector('#UF-ProposalSwitcher .uf-proposal-select');
    //   console.log('getActiveProposalKey sel=', sel.value);
    if (sel && sel.value) return sel.value;

    // fallbacks
    if (typeof DEFAULT_PROPOSAL_KEY === 'string') return DEFAULT_PROPOSAL_KEY;
    const first = (window.PROPOSAL_OPTIONS || [])[0];
    return first?.key || '';
}

/**
 * Returns an integer configuration id:
 * - If your PROPOSAL_OPTIONS items have { configId: number }, we use that.
 * - Otherwise we use 1-based index in PROPOSAL_OPTIONS (stable + simple).
 */
function getActiveConfigurationId() {
    const key = getActiveProposalKey();
    const opts = PROPOSAL_OPTIONS || [];
    const idx = opts.findIndex(o => (o?.key || '') === key);
    console.log('getActiveConfigurationId key=', key, ' idx=', idx);
    //   if (idx < 0) return 0;

    const explicit = opts[idx]?.configId;
    return Number.isInteger(explicit) ? explicit : (idx + 1);
}

// --- Active zone → zone_id (int) --------------------------------------------
function getActiveZoneIdInt() {
    // ZoneCtrl.index is exposed by your controller
    const i = ZoneCtrl?.index ?? null;
    if (i == null) return 0;

    const z = (typeof getZones === 'function' ? getZones() : window.participationZones || [])[i];
    const idStr = z?.id || '';                 // e.g. "zone_02"
    const m = String(idStr).match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
}




// --- minimal styles (only once) ---

function ensureModelDownloadPill() {
    // mount just below the proposal switcher; fallback to body fixed
    const host = document.querySelector('#UrbanFutureTopNavbarSelectOptions') || document.body;

    let wrap = document.getElementById('UF-ModelDownload');
    if (!wrap) {
        wrap = document.createElement('div');
        wrap.id = 'UF-ModelDownload';
        wrap.innerHTML = `
      <span>pobieranie modelu</span>
      <div class="pp-track"><div class="pp-fill"></div></div>
      <span class="pp-pct">0%</span>
    `;
        if (host === document.body) {
            Object.assign(wrap.style, { position: 'fixed', left: '12px', bottom: '12px', zIndex: 9999 });
            document.body.appendChild(wrap);
        } else {
            host.insertAdjacentElement('afterend', wrap);
        }
    }
    return wrap;
}

let MODEL_DL_TOKEN = 0;

function showModelDownloadPill() {
    const el = ensureModelDownloadPill();
    el.style.display = 'flex';
    el.querySelector('.pp-fill').style.width = '0%';
    el.querySelector('.pp-pct').textContent = '0%';
    return ++MODEL_DL_TOKEN;
}
function updateModelDownloadPill(token, ratio /* 0..1 or null */) {
    if (token !== MODEL_DL_TOKEN) return;
    const el = document.getElementById('UF-ModelDownload'); if (!el) return;
    const fill = el.querySelector('.pp-fill');
    const pct = el.querySelector('.pp-pct');

    if (typeof ratio !== 'number' || !isFinite(ratio)) {
        // no Content-Length: just keep it visible with “—%”
        pct.textContent = '—%';
        return;
    }
    const v = Math.max(0, Math.min(100, Math.round(ratio * 100)));
    fill.style.width = v + '%';
    pct.textContent = v + '%';
}
function hideModelDownloadPill(token) {
    if (token !== MODEL_DL_TOKEN) return;
    const el = document.getElementById('UF-ModelDownload'); if (!el) return;
    el.querySelector('.pp-fill').style.width = '100%';
    el.querySelector('.pp-pct').textContent = '100%';
    setTimeout(() => { if (token === MODEL_DL_TOKEN) el.style.display = 'none'; }, 250);
}
function failModelDownloadPill(token) {
    if (token !== MODEL_DL_TOKEN) return;
    const el = document.getElementById('UF-ModelDownload'); if (!el) return;
    el.querySelector('.pp-fill').style.width = '0%';
    el.querySelector('.pp-pct').textContent = 'ERR';
    setTimeout(() => { if (token === MODEL_DL_TOKEN) el.style.display = 'none'; }, 900);
}


// === API base (unchanged) ====================================================
const PLAC_API = 'https://publictwin.info/EngagementAppPrototypes/PlacKrakowskiPHP';

const LIKE_TOGGLE_URL = `${PLAC_API}/Like_Toggle_PlacKrakowski.php`;

// ==== identity helpers =======================================================
function getSessionUserIdentifier() {
    // Your session convention: projectCode + String(code)
    // Already stored in sessionStorage as 'userID' in your app.
    const ss = sessionStorage.getItem('userID');
    if (ss && ss !== '-') return ss;

    // fallback anon (persistent)
    let anon = localStorage.getItem('anon_uid');
    if (!anon) {
        anon = 'anon-' + Math.random().toString(36).slice(2);
        localStorage.setItem('anon_uid', anon);
    }
    return anon;
}

function getLoggedInUserId() {
    // Use your existing login storage key if present
    const lid = sessionStorage.getItem('loginUserID') || window.sessionLoginUserID || '';
    return (lid && lid !== '-') ? String(lid) : '';
}

async function fetchJSON(url, options = {}, timeoutMs = 12000) {
    const ctrl = new AbortController(); const t = setTimeout(() => ctrl.abort(), timeoutMs);
    try {
        const res = await fetch(url, { ...options, signal: ctrl.signal });
        const json = await res.json().catch(() => ({}));
        return { ok: res.ok, status: res.status, json };
    } finally { clearTimeout(t); }
}

function currentZoneAndConfig() {
    const configuration_id = getActiveConfigurationId();
    const z = getZones()[ZoneCtrl?.index ?? -1];
    const idStr = z?.id || ''; const m = String(idStr).match(/\d+/);
    const zone_id = m ? parseInt(m[0], 10) : 0;
    return { configuration_id, zone_id };
}
// Normalizer and zone-key inference (handles diacritics)
const _norm = (s) => (s || '')
    .toString()
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

function inferZoneKeyFromZoneObject(z) {
    const name = _norm(z?.displayName || z?.id || '');
    if (name.includes('klon')) return 'Klony';
    if (name.includes('akadem')) return 'Akademicka';
    if (name.includes('gornicz')) return 'Górniczy';   // "górniczy"
    if (name.includes('gor')) return name.includes('gornicz') ? 'Górniczy' : null;
    if (name.includes('luzy') || name.includes('luzyc') || name.includes('luz') || name.includes('yckiej')) return 'Łużycka';
    if (name.includes('centralna')) return 'Centrum';
    return null; // not recognized – will hide description
}



let _zoneStatsReqToken = 0;

async function refreshZoneStatsUI() {
    const { configuration_id, zone_id } = currentZoneAndConfig();
    const answersEl = document.getElementById('zones-answers-count');
    const likesEl = document.getElementById('zones-likes-count');
    const likeBtn = document.getElementById('zones-like-btn');
    const likeIcon = document.getElementById('zone-like-icon');
    if (!answersEl || !likesEl || !likeBtn || configuration_id <= 0 || zone_id <= 0) return;

    // stamp this request & lock the button
    const token = ++_zoneStatsReqToken;
    likeBtn.disabled = true;

    const uid = getSessionUserIdentifier();
    const lid = getLoggedInUserId();

    const q = new URLSearchParams({
        configuration_id,
        zone_id,
        user_identifier: uid,
        logged_in_user_id: lid,
        _: Date.now().toString()        // cache buster to avoid stale GETs
    });

    try {
        const r = await fetchJSON(`${PLAC_API}/Get_Zone_Stats_PlacKrakowski.php?${q.toString()}`);

        // ignore if a newer request started while we were waiting
        if (token !== _zoneStatsReqToken) return;

        if (r.ok && r.json?.status === 'ok') {
            const liked = !!r.json.user_liked;

            answersEl.textContent = r.json.answers_count ?? 0;
            likesEl.textContent = r.json.likes_count ?? 0;

            likeBtn.classList.toggle('is-liked', liked);
            likeBtn.dataset.liked = liked ? '1' : '0';
            likeIcon.src = liked ? HEART_FULL : HEART_EMPTY;
        } else {
            answersEl.textContent = '0';
            likesEl.textContent = '0';
            likeBtn.classList.remove('is-liked');
            likeBtn.dataset.liked = '0';
            likeIcon.src = HEART_EMPTY;
        }
    } catch (e) {
        if (token !== _zoneStatsReqToken) return;
        // safe fallback UI on error
        answersEl.textContent = answersEl.textContent || '0';
        likesEl.textContent = likesEl.textContent || '0';
        likeBtn.classList.remove('is-liked');
        likeBtn.dataset.liked = '0';
        likeIcon.src = HEART_EMPTY;
        console.error(e);
    } finally {
        if (token === _zoneStatsReqToken) likeBtn.disabled = false;
    }
}



// ==== TOGGLE like/unlike (optimistic) =======================================
async function toggleLikeCurrentZone() {
    const { configuration_id, zone_id } = currentZoneAndConfig();
    const likeBtn = document.getElementById('zones-like-btn');
    const likesEl = document.getElementById('zones-likes-count');
    const likeIcon = document.getElementById('zone-like-icon');
    if (!likeBtn || !likesEl || configuration_id <= 0 || zone_id <= 0) return;

    const uid = getSessionUserIdentifier();
    const lid = getLoggedInUserId();

    const wasLiked = likeBtn.dataset.liked === '1';
    const prevCount = parseInt(likesEl.textContent || '0', 10) || 0;

    // optimistic flip
    const nextLiked = !wasLiked;
    likeBtn.classList.toggle('is-liked', nextLiked);
    likeBtn.dataset.liked = nextLiked ? '1' : '0';
    likesEl.textContent = String(Math.max(0, prevCount + (nextLiked ? +1 : -1)));
    likeIcon.src = nextLiked ? HEART_FULL : HEART_EMPTY;

    likeBtn.disabled = true;
    try {
        const body = {
            configuration_id, zone_id,
            user_identifier: uid,
            logged_in_user_id: lid,
            user_IP: window.userIP || '-',
            action: 'toggle'
        };
        const r = await fetchJSON(`${PLAC_API}/Like_Toggle_PlacKrakowski.php`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });

        if (r.ok && r.json?.status === 'ok') {
            // lock to server truth
            const liked = !!r.json.user_liked;
            likeBtn.classList.toggle('is-liked', liked);
            likeBtn.dataset.liked = liked ? '1' : '0';
            likesEl.textContent = String(Number(r.json.likes_count ?? likesEl.textContent));
            likeIcon.src = liked ? HEART_FULL : HEART_EMPTY;

            if (typeof window.debouncedRefresh === 'function') {
                window.debouncedRefresh();
            } else if (typeof window.refreshParticipationResults === 'function') {
                window.refreshParticipationResults();
            }

            // (optional) event route
            document.dispatchEvent(new CustomEvent('plac:likes-changed', {
                detail: { configuration_id, zone_id, liked }
            }));


        } else {
            // revert on failure
            likeBtn.classList.toggle('is-liked', wasLiked);
            likeBtn.dataset.liked = wasLiked ? '1' : '0';
            likesEl.textContent = String(prevCount);
            likeIcon.src = wasLiked ? HEART_FULL : HEART_EMPTY;
            console.warn('Like toggle failed:', r.json?.message || r.status);
        }
    } catch (e) {
        // revert on network error
        likeBtn.classList.toggle('is-liked', wasLiked);
        likeBtn.dataset.liked = wasLiked ? '1' : '0';
        likesEl.textContent = String(prevCount);
        likeIcon.src = wasLiked ? HEART_FULL : HEART_EMPTY;
        console.error(e);
    } finally {
        likeBtn.disabled = false;
    }
}

function neutralizeLikeUI() {
    const likeBtn = document.getElementById('zones-like-btn');
    const likeIcon = document.getElementById('zone-like-icon');
    const likesEl = document.getElementById('zones-likes-count');

    if (likeBtn) {
        likeBtn.disabled = true;            // block clicks until DB state arrives
        likeBtn.classList.remove('is-liked');
        likeBtn.dataset.liked = '0';
    }
    if (likeIcon) likeIcon.src = HEART_EMPTY;
    if (likesEl) likesEl.textContent = likesEl.textContent || '0';
}

function setAllZonesHoverVisual(on = true) {
    const L = UFModels?.zones;
    if (!L || !Array.isArray(L.pickables)) return;

    // Make sure per-mesh opacity props exist
    if (typeof zonesEnforceOpacityProps === 'function') zonesEnforceOpacityProps();

    const hov = L.__opts?.hoverOpacity ?? 0.20;
    const base = L.__opts?.baseOpacity ?? 0.02;

    for (const mesh of L.pickables) {
        if (!mesh?.material) continue;
        mesh.selected = false;                           // ensure not selected
        mesh.material.opacity = on ? (mesh._hoverOpacity ?? hov) : (mesh._baseOpacity ?? base);
        // keep edge visibility clear & readable (base edge opacity works well)
        if (typeof addEdgeLinesZones === 'function') {
            const EDGE_COL = (typeof ZONE_EDGE_COLOR !== 'undefined') ? ZONE_EDGE_COLOR : 0xffd04c;
            const EDGE_OPA = (typeof ZONE_EDGE_OPACITY_BASE !== 'undefined') ? ZONE_EDGE_OPACITY_BASE : 0.40;
            addEdgeLinesZones(mesh, EDGE_COL, EDGE_OPA);
        }
    }

    // Clear any internal refs and repaint
    L._selected?.clear?.();
    L._hovered = null;
    L.map?.triggerRepaint?.();
}

let _participateToastTimer = null;

function showParticipateHintToast(text, { duration = 10000 } = {}) {
    try {
        document.getElementById("zones-close").click();
    } catch { }
    let el = document.getElementById('participate-hint-toast');
    if (!el) {
        el = document.createElement('div');
        el.id = 'participate-hint-toast';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.addEventListener('click', () => {
            clearTimeout(_participateToastTimer);
            el.style.opacity = '0';
            setTimeout(() => el.remove(), 250);
        });
        document.body.appendChild(el);
        // small fade-in
        requestAnimationFrame(() => { el.style.opacity = '1'; });
    }
    el.innerHTML = text;

    clearTimeout(_participateToastTimer);
    _participateToastTimer = setTimeout(() => {
        const n = document.getElementById('participate-hint-toast');
        if (!n) return;
        n.style.opacity = '0';
        setTimeout(() => n.remove(), 300);
    }, duration);
}
function removeParticiaptionHint() {
    const n = document.getElementById('participate-hint-toast');
    if (!n) return;
    n.style.opacity = '0';
    setTimeout(() => n.remove(), 300);
}



// === Konfiguracje: dane (zdjęcie + sekcje stref) =============================
const CONFIG_PHOTOS = {
  // ← podmień ścieżki na swoje pliki/URL-e (jeśli brak, obrazek zostanie pominięty)
  1: 'https://publictwin.info/PlacKrakowski/res/images/Konfiguracja_01.jpg',
  2: 'https://publictwin.info/PlacKrakowski/res/images/Konfiguracja_02.jpg',
  3: 'https://publictwin.info/PlacKrakowski/res/images/Konfiguracja_03.jpg',
  4: 'https://publictwin.info/PlacKrakowski/res/images/Konfiguracja_04.jpg',
  5: 'https://publictwin.info/PlacKrakowski/res/images/Konfiguracja_05.jpg'
};

const CONFIG_LONG_INFO = {
  1: {
    title: 'Konfiguracja 1',
    zones: [
      {
        heading: 'Strefa 1: Klony przy ulicy Wrocławskiej',
        text: `W miejsce jednej z trybun część skweru rekreacyjnego, z placem zabaw dla dzieci. Nad pozostałymi trybunami zacieniające dachy. Dużo nowych drzew. Pod starymi klonami węższe niż obecnie przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew. Miejsce na targ (niebieskie namioty). Więcej wygodnych ławek.
W miejscu starej toalety nowy pawilon gastronomiczny z toaletą publiczną, w nim miejsce spotkań Rady Dzielnicy. Zamiast starej fontanny podświetlane tryskacze w posadzce.`
      },
      {
        heading: 'Strefa 2 : Przestrzeń obecnego skateparku od strony ulicy Akademickiej',
        text: `Skatepark jako część ogólnodostępnego skweru. Przeszkody to rzeźbiarskie formy dekoracyjne (tu wstępne propozycje ich kształtu, do dyskusji), które kierują ruch w taki sposób, aby osoby jeżdżące na deskach, rolkach lub tp. nie zagrażały przechodniom. 
Duży słup ogłoszeniowy. 
Pergola zacieniająca nad przejściem - na istniejących stalowych ramach zamontowane linki dla pnączy. 
Zadaszenia zacieniające nad trybunami. Trybuna w sąsiedztwie skateparku przecięta, co umożliwia przejazd przez nią na otwartą część placu, na której część posadzki jest wykonana z nawierzchni wygodnej dla rolkarzy.`
      },
      {
        heading: 'Strefa 3: Przestrzeń wzdłuż budynku Rektoratu/Wydziału Górniczego',
        text: `Aleja Pamięci równoległa do budynku Wydziału Górniczego, czyli wyodrębniona z placu przestrzeń dla Pomnika Powstań Polskich. Od otwartej części placu pomnik jest oddzielony drzewami. Od strony ulic Łużyckiej i Akademickiej znajduje się na osi widokowej proponowanej alei. Wejścia do alei z narożników placu.`
      },
      {
        heading: 'Strefa 4: Przestrzeń wzdłuż ulicy Łużyckiej',
        text: `Skwer z ławkami i pawilonem gastronomicznym (w nim miejsce spotkań Rady Dzielnicy) oraz z toaletą publiczną. Tarasy z miejscami do siedzenia i duży ogród deszczowy (oznaczenie - ciemna zieleń). Miejsce dla targu (niebieskie namioty) również częściowo przewidziane  w tej strefie.`
      },
      {
        heading: 'Strefa 5: Plac - otwarta przestrzeń na środku',
        text: `Otwarta część placu jest zmniejszona w stosunku do obecnej przez zieleniec w miejscu jednej z trybun. Dwa rodzaje posadzki - ułożone na nowo stare płyty (ciemniejsze) i nawierzchnia do jazdy na rolkach na części obok skateparku (jaśniejsze oznaczenie).`
      }
    ]
  },

  2: {
    title: 'Konfiguracja 2',
    zones: [
      {
        heading: 'Strefa 1: Klony przy ulicy Wrocławskiej',
        text: `Pod starymi klonami zamiast betonu węższe przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew. Więcej wygodnych ławek.

Jak wynika z badań trybuny są chętnie wykorzystywane do siedzenia i rozmowy, często w kilkuosobowych grupach. W tej propozycji dwie trybuny zostają jako strefa spotkań, są wzbogacone o specjalnie zaprojektowane, częściowo ruchome meble do siedzenia. Nad nimi daszki zacieniające z ogniwami fotowoltaicznymi dające możliwość podłączenia urządzeń przenośnych do prądu.`
      },
      {
        heading: 'Strefa 2 : Przestrzeń obecnego skateparku od ulicy Akademickiej',
        text: `Badania wskazują, że pożądane byłoby stworzenie miejsca bezpośredniego kontaktu i współdziałania mieszkańców, studentów i pracowników Politechniki. W tym wariancie proponujemy w miejscu skateparku (który w tej konfiguracji przenosimy na drugą stronę placu) urządzenie otwartej strefy popularyzacji nauki, kameralnych wydarzeń kulturalnych i organizowanych na różne sposoby wspólnych działań oddolnych. Nawierzchnia przepuszczalna, skwerowy charakter, infrastruktura umożliwiająca mocowanie różnych elementów, np. lekkich zadaszeń, dostęp do prądu itp. Stały pawilon może służyć m.in. radzie dzielnicy. Trybuna usunięta, zostaje tylko jej niższa część (od strony obecnego skateparku).`
      },
      {
        heading: 'Strefa 3: Przestrzeń wzdłuż budynku Rektoratu/Wydziału Górniczego',
        text: `Miejskie Lapidarium - miejsce, gdzie przeplatają się różne wątki historii miasta i uczelni, przestrzeń, w której są zgromadzone i wyeksponowane elementy nieistniejących już budowli oraz obiekty związane z historią miasta, budujące gliwicką tożsamość. Pomnik Powstań jest częścią Lapidarium. Za nim Bębny Czasu - instalacja edukacyjna. Na trawnikach atrakcja dla dzieci - figury koni (wspomnienie dawnego targu końskiego) i krowy prof. Fryzego. Kawiarnia Kloppot (nazwa istniejącego tu kiedyś stawu), która jest zarazem klubem historycznym, punktem informacji o historii miasta i miejscem spotkań mieszkańców.`
      },
      {
        heading: 'Strefa 4: Przestrzeń wzdłuż ulicy Łużyckiej',
        text: `Nowy skatepark jest częścią ogólnodostępnego skweru. Przeszkody to  rzeźbiarskie formy dekoracyjne (tu wstępne propozycje ich kształtu do dyskusji), jednocześnie kierują ruch w taki sposób, aby osoby jeżdżące na deskach, rolkach lub tp. nie zagrażały przechodniom.`
      },
      {
        heading: 'Strefa 5: Plac - otwarta przestrzeń na środku',
        text: `Część centralna nieco mniejsza niż obecnie, nawierzchnia z przełożonych płyt obecnego placu.`
      }
    ]
  },

  3: {
    title: 'Konfiguracja 3',
    zones: [
      {
        heading: 'Strefa 1: Klony przy ulicy Wrocławskiej',
        text: `Pod starymi klonami zamiast betonu węższe przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew. Więcej wygodnych ławek.
Zamiast trybun (jeśli ich stan techniczny nie pozwoli na zachowanie) duży, chroniący przed deszczem i słońcem dach z pnączami. Pod nim dwa pawilony kawiarni i przestrzeń dająca możliwość zorganizowania targu i różnych wydarzeń, np. potańcówki. Na co dzień miejsce odpoczynku, rozmów, picia kawy, spotkań. Dach latem zacienia, zimą przepuszcza światło słoneczne.`
      },
      {
        heading: 'Strefa 2 : Przestrzeń obecnego skateparku od ulicy Akademickiej',
        text: `Badania wskazują, że pożądane byłoby stworzenie miejsca bezpośredniego kontaktu i współdziałania mieszkańców, studentów i pracowników Politechniki. W tym wariancie proponujemy w miejscu skateparku (który przenosimy na drugą stronę placu) urządzenie dużego zadaszenia z dostępem do prądu i wody, z ogniwami fotowoltaicznymi i z systemem zbierania deszczówki. Pod dachemi możliwość organizowania  wydarzeń popularyzujących naukę i współpracę naukowców z mieszkańcami, wydarzeń kulturalnych, wystaw, targów, ale i działań pomocowych w sytuacjach kryzysowych.`
      },
      {
        heading: 'Strefa 3: Przestrzeń wzdłuż budynku Rektoratu/Wydziału Górniczego',
        text: `Wzdłuż południowej krawędzi placu znajduje się “strefa historii i pamięci” ukształtowana przez dodanie elementów rzeźbiarskich w otoczeniu pomnika. Mogą to być postaci z historii Gliwic w skali naturalnej obok których, na kamiennych „kartach historii”, byłyby opisane lub wyświetlane opowieści o ich roli w rozwoju Gliwic. Przez „karty historii” można byłoby przechodzić, niczym przez kolejne bramy wtajemniczenia, dla lepszego poznania i zrozumienia dziejów miasta.`
      },
      {
        heading: 'Strefa 4: Przestrzeń wzdłuż ulicy Łużyckiej',
        text: `W tej propozycji skatepark jest częścią ogólnodostępnego skweru. Przeszkody to  rzeźbiarskie formy dekoracyjne (tu wstępne propozycje ich kształtu do dyskusji), które kierują ruch w taki sposób, aby osoby jeżdżące na rolkach lub tp. nie zagrażały przechodniom.`
      },
      {
        heading: 'Strefa 5: Plac - otwarta przestrzeń na środku',
        text: `Część centralna nieco mniejsza niż obecnie, nawierzchnia z przełożonych płyt obecnego placu.`
      }
    ]
  },

  4: {
    title: 'Konfiguracja 4',
    zones: [
      {
        heading: 'Strefa 1: Klony przy ulicy Wrocławskiej',
        text: `Pod starymi klonami  zamiast betonu węższe przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew. Więcej wygodnych ławek.
Trybuny rozbudowane o drewniane tarasy i pochylnię - miejsce spotkań i atrakcji typu pomost widokowy czy “kładka w koronach drzew” (przy maksymalnej ochronie klonów). Od strony otwartej placu dodane zadaszenia zacieniające trybuny. Pomosty stanowią zadaszenie targu dostępnego od strony alei klonów, mogłyby tu znaleźć się też niewielkie pawilony gastronomiczne.`
      },
      {
        heading: 'Strefa 2 : Przestrzeń obecnego skateparku od ulicy Akademickiej',
        text: `Budynek Centrum nauki dostępny przez podcienia od strony ul. Akademickiej a od strony placu w formie stopni tworzących wysoką trybunę, która może być wykorzystywana przy różnych okazjach. Po tych stopniach wchodzimy na dach budynku, który jest tarasem widokowym, z pawilonem kawiarni i przestrzenią ekspozycyjną.`
      },
      {
        heading: 'Strefa 3: Przestrzeń wzdłuż budynku Rektoratu/Wydziału Górniczego',
        text: `Przeniesienie pomnika w inne miejsce daje możliwość usytuowania kilku dwukondygnacyjnych pawilonów z tarasami tworzących pierzeję placu. W pawilonach mogłyby się mieścić bary z przekąskami, kawiarnie i inne, użyteczne społecznie funkcje – np. świetlica Rady Dzielnicy, społeczna kawiarnia, oddolna komitywa, klub studencki, karciany, klub gier planszowych, lub przestrzeń co-workingowa.`
      },
      {
        heading: 'Strefa 4: Przestrzeń wzdłuż ulicy Łużyckiej',
        text: `Skatepark ukształtowany jako część skweru, z możliwością użytkowania części głównej płyty placu. Jest tu też pawilon gastronomiczny z zadaszonym tarasem.`
      },
      {
        heading: 'Strefa 5: Plac - otwarta przestrzeń na środku',
        text: `Część centralna nieco mniejsza niż obecnie, nawierzchnia z przełożonych płyt obecnego placu.`
      }
    ]
  },

  5: {
    title: 'Konfiguracja 5',
    zones: [
      {
        heading: 'Strefa 1: Klony przy ulicy Wrocławskiej',
        text: `Pod starymi klonami zamiast betonu węższe przejścia z przepuszczalnej nawierzchni, aby poprawić warunki życia drzew.
Miejsce na targ (niebieskie namioty), dużo wygodnych ławek. Toaleta publiczna wyremontowana.
Trybuny pozostawione, zostają częściowo zazielenione, nad nimi zacieniająca pergola z pnączami.`
      },
      {
        heading: 'Strefa 2 : Przestrzeń obecnego skateparku od ulicy Akademickiej',
        text: `Nowy skatepark w miejscu starego. Lepsze przeszkody (tu propozycja do dyskusji), z wyspą zieleni z trawą, drzewami i pnączami (cień, schładzanie, oczyszczanie powietrza). Na jednej z przeszkód (tunel) od zewnątrz ścianka do wspinaczki (boulderingu). Nad trybuną daszki zacieniające, na trybunie stoliki umożliwiające rozłożenie np. gier planszowych. Trybuna jest przecięta i umożliwia przejazd na otwartą część placu, gdzie jaśniejszym kolorem zaznaczono nawierzchnię nadającą się do jazdy np. na rolkach.`
      },
      {
        heading: 'Strefa 3: Przestrzeń wzdłuż budynku Rektoratu/Wydziału Górniczego',
        text: `Strefa Pamięci i Wyciszenia – zieleniec otaczający pomnik stanowi wyraźnie wydzieloną, ale dostępną z otwartej części placu zieloną strefę wyciszenia. Wygodne ławki pozwalające na odpoczynek. Od strony placu ogrody deszczowe (zaznaczone ciemną zielenią)`
      },
      {
        heading: 'Strefa 4: Przestrzeń wzdłuż ulicy Łużyckiej',
        text: `Rozbudowany skwer, ze ścieżkami i ławkami ułożonymi tak, aby ułatwić kilkuosobowe rozmowy. Na skwerze dwa pawilony - jeden kawiarniany, drugi mieszczący świetlicę, klub i Radę Dzielnicy. Przed nimi miejsca do siedzenia oraz ogród deszczowy wchodzący w część otwartą placu.`
      },
      {
        heading: 'Strefa 5: Plac - otwarta przestrzeń na środku',
        text: `Otwarta część placu jest zmniejszona w stosunku do obecnej przez zielone strefy pomnika i skweru. Jaśniejsza część placu to posadzka do jeżdżenia na rolkach/desce itp. Pozostała część placu z przełożony obecnych płyt betonowych. Na płycie placu fontanna w postaci podświetlanych tryskaczy.`
      }
    ]
  }
};

// === Render: dodaj sekcję po FAQ =============================================
function renderConfigsAfterFAQ() {
  const faq = document.querySelector('.hf-faq') || document.querySelector('#hf-faq') || document.querySelector('.hf-section');
  if (!faq) return;

  // Sekcja host
  const sec = document.createElement('section');
  sec.id = 'cfg-info';
//   sec.className = 'hf-section';

  // Nagłówek
  const h2 = document.createElement('h2');
  h2.className = 'hf-h2';
  h2.textContent = 'Szczegóły konfiguracji';
  sec.appendChild(h2);

  // Każda konfiguracja jako card (obraz + strefy)
  Object.entries(CONFIG_LONG_INFO).forEach(([cfgId, cfg]) => {
    const card = document.createElement('article');
    card.className = 'cfg-card';
    card.style.margin = '10px 0';
    card.style.padding = '12px';
    card.style.border = '2px solid rgba(0,0,0,.12)';
    card.style.borderRadius = '12px';
    card.style.background = '#ffffff69';

    // Tytuł
    const title = document.createElement('h3');
    title.textContent = cfg.title;
    title.style.margin = '0 0 8px';
    title.style.fontWeight = '800';
    card.appendChild(title);

    // Obraz (opcjonalnie)
    const url = CONFIG_PHOTOS[cfgId];
    if (url) {
      const img = document.createElement('img');
      img.src = url;
      img.alt = cfg.title;
      img.style.width = '100%';
      img.style.height = 'auto';
      img.style.borderRadius = '10px';
      img.style.display = 'block';
      img.style.margin = '6px 0 12px';
      card.appendChild(img);
    }

    // Strefy
    cfg.zones.forEach(z => {
      const zt = document.createElement('div');
      zt.style.margin = '10px 0 12px';

      const h4 = document.createElement('h4');
      h4.textContent = z.heading;
      h4.style.margin = '0 0 6px';
      h4.style.fontSize = '18px';
      h4.style.fontWeight = '800';

      const p = document.createElement('p');
      p.style.whiteSpace = 'pre-wrap';
      p.style.margin = '0';
      p.textContent = z.text;

      zt.appendChild(h4);
      zt.appendChild(p);
      card.appendChild(zt);
    });

    sec.appendChild(card);
  });

  // wstaw ZA FAQ
  faq.insertAdjacentElement('afterend', sec);
}

// uruchom po załadowaniu DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderConfigsAfterFAQ);
} else {
  renderConfigsAfterFAQ();
}

